/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
/**
 * AI chat conversation with ID
 */
export interface AIConversation {
  title: string;
  ai_conversation_id: number;
}

/**
 * Schema for creating a new conversation
 */
export interface AIConversationCreate {
  title?: string;
}

/**
 * Full conversation with all messages
 */
export interface AIConversationRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  title: string;
  ai_conversation_id: number;
  messages: AIMessageRead[];
}

export type AIMessageCreateContent = string | null;

/**
 * Schema for creating a new message (user sends this)
 */
export interface AIMessageCreate {
  content?: AIMessageCreateContent;
}

export type AIMessageReadModelName = string | null;

export type AIMessageReadInputTokens = number | null;

export type AIMessageReadOutputTokens = number | null;

export type AIMessageReadTotalTokens = number | null;

/**
 * Full AI chat message with metadata for detailed view
 */
export interface AIMessageRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  ai_conversation_id: number;
  content: string;
  role: MessageRoleEnum;
  model_name?: AIMessageReadModelName;
  input_tokens?: AIMessageReadInputTokens;
  output_tokens?: AIMessageReadOutputTokens;
  total_tokens?: AIMessageReadTotalTokens;
  ai_message_id: number;
  tool_calls: AIToolCallRead[];
}

export type AIMessageStreamEventContent = string | null;

export type AIMessageStreamEventToolCalls = AIToolCallBase[] | null;

export type AIMessageStreamEventInputTokens = number | null;

export type AIMessageStreamEventOutputTokens = number | null;

export type AIMessageStreamEventTotalTokens = number | null;

/**
 * Generic SSE payload for AI chat streaming.
 */
export interface AIMessageStreamEvent {
  type: AIMessageTypeEnum;
  content?: AIMessageStreamEventContent;
  tool_calls?: AIMessageStreamEventToolCalls;
  input_tokens?: AIMessageStreamEventInputTokens;
  output_tokens?: AIMessageStreamEventOutputTokens;
  total_tokens?: AIMessageStreamEventTotalTokens;
}

/**
 * AIMessageTypeEnum class for AI chat streaming events
 */
export type AIMessageTypeEnum =
  (typeof AIMessageTypeEnum)[keyof typeof AIMessageTypeEnum];

export const AIMessageTypeEnum = {
  text: "text",
  tool_call: "tool_call",
  tool_result: "tool_result",
  done: "done",
  error: "error",
} as const;

export type AIToolCallBaseArgsAnyOf = { [key: string]: unknown };

export type AIToolCallBaseArgs = AIToolCallBaseArgsAnyOf | null;

export type AIToolCallBaseSummary = string | null;

/**
 * Base schema for AI tool call events.
 */
export interface AIToolCallBase {
  event_type: ToolCallEnum;
  name: string;
  args?: AIToolCallBaseArgs;
  summary?: AIToolCallBaseSummary;
}

export type AIToolCallReadArgsAnyOf = { [key: string]: unknown };

export type AIToolCallReadArgs = AIToolCallReadArgsAnyOf | null;

export type AIToolCallReadSummary = string | null;

/**
 * Full AI tool call schema.
 */
export interface AIToolCallRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  event_type: ToolCallEnum;
  name: string;
  args?: AIToolCallReadArgs;
  summary?: AIToolCallReadSummary;
  ai_message_id: number;
  sequence_number: number;
  ai_tool_call_id: number;
}

/**
 * AdministrationRouteEnum class
 */
export type AdministrationRouteEnum =
  (typeof AdministrationRouteEnum)[keyof typeof AdministrationRouteEnum];

export const AdministrationRouteEnum = {
  Ophthalmic: "Ophthalmic",
  Oral: "Oral",
} as const;

/**
 * Schema for assigning a lot number to batches
 */
export interface AssignLotRequest {
  inventory_id: string;
  /** @minItems 1 */
  inventory_batch_ids: string[];
  /**
   * @minLength 1
   * @maxLength 40
   */
  lot_number: string;
  expiration_date: string;
  force?: boolean;
}

/**
 * Response from assign-lot endpoint
 */
export interface AssignLotResponse {
  updated_count: number;
}

export type AuditOldValue = string | null;

export type AuditNewValue = string | null;

/**
 * Audit schema for pydantic models

This is used to return the created_by and updated_by user information
 */
export interface Audit {
  column_name: string;
  old_value?: AuditOldValue;
  new_value?: AuditNewValue;
  created_at: string;
  created_by: UserName;
}

/**
 * Email address of user
 */
export type AuthUserEmail = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type AuthUserTitle = string | null;

/**
 * URL of the user's first logo
 */
export type AuthUserFirstLogo = string | null;

/**
 * AuthUser schema

This validates the user's permissions and entities in the api.
It is cached in the user dependency.
 */
export interface AuthUser {
  /** Unique identifier for the user from Firebase (same as uid) */
  user_id: string;
  /** Full name of the user */
  name: string;
  /** Email address of user */
  email?: AuthUserEmail;
  /** Role of the user in the system, e.g., DOCTOR, ADMIN */
  role: UserRoleEnum;
  /** Title of the user, e.g., MD, RN, PA */
  title?: AuthUserTitle;
  /** Set of permissions associated with the user */
  permissions: PermissionEnum[];
  /** Set of unique identifiers for the user's entities */
  entity_ids: number[];
  /** List of entities with basic information (name and ID) */
  entities: EntityNameWithStateProvince[];
  /** Whether the user is available to receive calls */
  is_call_available?: boolean;
  /** Whether the user has at least one MFA factor enrolled */
  mfa_enabled?: boolean;
  /** Whether any of the user's entities requires MFA enrollment */
  mfa_required?: boolean;
  /** URL of the user's first logo */
  first_logo?: AuthUserFirstLogo;
}

export type BatchCreateExternalBatchId = string | null;

export type BatchCreateShippingCharge = number | null;

export type BatchCreateTax = number | null;

export type BatchCreateSubtotal = number | null;

export type BatchCreateTotalPrice = number | null;

export type BatchCreateUnitCost = number | null;

export type BatchCreateOrderedAt = string | null;

export type BatchCreateExpectedAt = string | null;

export type BatchCreateArrivedAt = string | null;

export type BatchCreateTrackingNumber = string | null;

export type BatchCreateExpirationDate = string | null;

export type BatchCreateStockOrderId = string | null;

export type BatchCreateNote = string | null;

export type BatchCreateInvoiceUrl = string | null;

export type BatchCreateBatchId = number | null;

/**
 * Batch create schema
 */
export interface BatchCreate {
  external_batch_id?: BatchCreateExternalBatchId;
  warehouse_vendor_id: number;
  /** @minimum 0.25 */
  order_quantity: number;
  /** @minimum 0 */
  quantity_on_hand?: number;
  status?: BatchStatusEnum;
  shipping_charge?: BatchCreateShippingCharge;
  tax?: BatchCreateTax;
  subtotal?: BatchCreateSubtotal;
  total_price?: BatchCreateTotalPrice;
  unit_cost?: BatchCreateUnitCost;
  ordered_at?: BatchCreateOrderedAt;
  expected_at?: BatchCreateExpectedAt;
  arrived_at?: BatchCreateArrivedAt;
  tracking_number?: BatchCreateTrackingNumber;
  expiration_date?: BatchCreateExpirationDate;
  stock_order_id?: BatchCreateStockOrderId;
  owner_id: number;
  note?: BatchCreateNote;
  invoice_url?: BatchCreateInvoiceUrl;
  batch_id?: BatchCreateBatchId;
}

export type BatchLogCreateBulkSuborderProductId = number | null;

/**
 * BatchLog create schema
 */
export interface BatchLogCreate {
  batch_id: number;
  log_type: BatchLogTypeEnum;
  quantity: number;
  bulk_suborder_product_id?: BatchLogCreateBulkSuborderProductId;
}

export type BatchLogReadBulkSuborderProductId = number | null;

export type BatchLogReadBulkSuborderProduct = BulkSuborderProductRef | null;

/**
 * BatchLog read schema
 */
export interface BatchLogRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  batch_id: number;
  log_type: BatchLogTypeEnum;
  quantity: number;
  bulk_suborder_product_id?: BatchLogReadBulkSuborderProductId;
  batch_log_id: number;
  created_by: UserName;
  bulk_suborder_product?: BatchLogReadBulkSuborderProduct;
}

/**
 * BatchLogTypeEnum class

Represents the type of batch log entry.
 */
export type BatchLogTypeEnum =
  (typeof BatchLogTypeEnum)[keyof typeof BatchLogTypeEnum];

export const BatchLogTypeEnum = {
  Slippage: "Slippage",
  Sample: "Sample",
  Sold: "Sold",
  Received: "Received",
  Manufactured: "Manufactured",
  Adjustment: "Adjustment",
  Unmake: "Unmake",
  Return: "Return",
} as const;

export type BatchReadExternalBatchId = string | null;

export type BatchReadShippingCharge = number | null;

export type BatchReadTax = number | null;

export type BatchReadSubtotal = number | null;

export type BatchReadTotalPrice = number | null;

export type BatchReadUnitCost = number | null;

export type BatchReadOrderedAt = string | null;

export type BatchReadExpectedAt = string | null;

export type BatchReadArrivedAt = string | null;

export type BatchReadTrackingNumber = string | null;

export type BatchReadExpirationDate = string | null;

export type BatchReadStockOrderId = string | null;

export type BatchReadNote = string | null;

export type BatchReadInvoiceUrl = string | null;

export type BatchReadInvoiceSignedUrl = string | null;

/**
 * Batch read schema
 */
export interface BatchRead {
  external_batch_id?: BatchReadExternalBatchId;
  warehouse_vendor_id: number;
  /** @minimum 0.25 */
  order_quantity: number;
  /** @minimum 0 */
  quantity_on_hand?: number;
  status?: BatchStatusEnum;
  shipping_charge?: BatchReadShippingCharge;
  tax?: BatchReadTax;
  subtotal?: BatchReadSubtotal;
  total_price?: BatchReadTotalPrice;
  unit_cost?: BatchReadUnitCost;
  ordered_at?: BatchReadOrderedAt;
  expected_at?: BatchReadExpectedAt;
  arrived_at?: BatchReadArrivedAt;
  tracking_number?: BatchReadTrackingNumber;
  expiration_date?: BatchReadExpirationDate;
  stock_order_id?: BatchReadStockOrderId;
  owner_id: number;
  note?: BatchReadNote;
  invoice_url?: BatchReadInvoiceUrl;
  batch_id: number;
  owner: EntityName;
  batch_logs: BatchLogRead[];
  warehouse_vendor: WarehouseVendorRead;
  audit_batch: Audit[];
  invoice_signed_url?: BatchReadInvoiceSignedUrl;
}

/**
 * BatchStatusEnum class

Represents the status of a batch purchase order.
 */
export type BatchStatusEnum =
  (typeof BatchStatusEnum)[keyof typeof BatchStatusEnum];

export const BatchStatusEnum = {
  Draft: "Draft",
  Open: "Open",
  Approved: "Approved",
  Purchased: "Purchased",
  Arrived: "Arrived",
  Cancelled: "Cancelled",
} as const;

export type BatchStatusUpdateExpirationDate = string | null;

/**
 * Batch status update schema for arrive transition
 */
export interface BatchStatusUpdate {
  arrived_at: string;
  expiration_date?: BatchStatusUpdateExpirationDate;
}

export type BatchWithOwnerAndWarehouseVendorExternalBatchId = string | null;

export type BatchWithOwnerAndWarehouseVendorShippingCharge = number | null;

export type BatchWithOwnerAndWarehouseVendorTax = number | null;

export type BatchWithOwnerAndWarehouseVendorSubtotal = number | null;

export type BatchWithOwnerAndWarehouseVendorTotalPrice = number | null;

export type BatchWithOwnerAndWarehouseVendorUnitCost = number | null;

export type BatchWithOwnerAndWarehouseVendorOrderedAt = string | null;

export type BatchWithOwnerAndWarehouseVendorExpectedAt = string | null;

export type BatchWithOwnerAndWarehouseVendorArrivedAt = string | null;

export type BatchWithOwnerAndWarehouseVendorTrackingNumber = string | null;

export type BatchWithOwnerAndWarehouseVendorExpirationDate = string | null;

export type BatchWithOwnerAndWarehouseVendorStockOrderId = string | null;

export type BatchWithOwnerAndWarehouseVendorNote = string | null;

export type BatchWithOwnerAndWarehouseVendorInvoiceUrl = string | null;

/**
 * Batch with owner and warehouse vendor schema
 */
export interface BatchWithOwnerAndWarehouseVendor {
  external_batch_id?: BatchWithOwnerAndWarehouseVendorExternalBatchId;
  warehouse_vendor_id: number;
  /** @minimum 0.25 */
  order_quantity: number;
  /** @minimum 0 */
  quantity_on_hand?: number;
  status?: BatchStatusEnum;
  shipping_charge?: BatchWithOwnerAndWarehouseVendorShippingCharge;
  tax?: BatchWithOwnerAndWarehouseVendorTax;
  subtotal?: BatchWithOwnerAndWarehouseVendorSubtotal;
  total_price?: BatchWithOwnerAndWarehouseVendorTotalPrice;
  unit_cost?: BatchWithOwnerAndWarehouseVendorUnitCost;
  ordered_at?: BatchWithOwnerAndWarehouseVendorOrderedAt;
  expected_at?: BatchWithOwnerAndWarehouseVendorExpectedAt;
  arrived_at?: BatchWithOwnerAndWarehouseVendorArrivedAt;
  tracking_number?: BatchWithOwnerAndWarehouseVendorTrackingNumber;
  expiration_date?: BatchWithOwnerAndWarehouseVendorExpirationDate;
  stock_order_id?: BatchWithOwnerAndWarehouseVendorStockOrderId;
  owner_id: number;
  note?: BatchWithOwnerAndWarehouseVendorNote;
  invoice_url?: BatchWithOwnerAndWarehouseVendorInvoiceUrl;
  batch_id: number;
  warehouse_vendor: WarehouseVendorRead;
  owner: EntityName;
}

export type BatchWithStockOrderExternalBatchId = string | null;

export type BatchWithStockOrderShippingCharge = number | null;

export type BatchWithStockOrderTax = number | null;

export type BatchWithStockOrderSubtotal = number | null;

export type BatchWithStockOrderTotalPrice = number | null;

export type BatchWithStockOrderUnitCost = number | null;

export type BatchWithStockOrderOrderedAt = string | null;

export type BatchWithStockOrderExpectedAt = string | null;

export type BatchWithStockOrderArrivedAt = string | null;

export type BatchWithStockOrderTrackingNumber = string | null;

export type BatchWithStockOrderExpirationDate = string | null;

export type BatchWithStockOrderStockOrderId = string | null;

export type BatchWithStockOrderNote = string | null;

export type BatchWithStockOrderInvoiceUrl = string | null;

export type BatchWithStockOrderStockOrder = StockOrder | null;

/**
 * Batch with owner and stock order schema
 */
export interface BatchWithStockOrder {
  external_batch_id?: BatchWithStockOrderExternalBatchId;
  warehouse_vendor_id: number;
  /** @minimum 0.25 */
  order_quantity: number;
  /** @minimum 0 */
  quantity_on_hand?: number;
  status?: BatchStatusEnum;
  shipping_charge?: BatchWithStockOrderShippingCharge;
  tax?: BatchWithStockOrderTax;
  subtotal?: BatchWithStockOrderSubtotal;
  total_price?: BatchWithStockOrderTotalPrice;
  unit_cost?: BatchWithStockOrderUnitCost;
  ordered_at?: BatchWithStockOrderOrderedAt;
  expected_at?: BatchWithStockOrderExpectedAt;
  arrived_at?: BatchWithStockOrderArrivedAt;
  tracking_number?: BatchWithStockOrderTrackingNumber;
  expiration_date?: BatchWithStockOrderExpirationDate;
  stock_order_id?: BatchWithStockOrderStockOrderId;
  owner_id: number;
  note?: BatchWithStockOrderNote;
  invoice_url?: BatchWithStockOrderInvoiceUrl;
  batch_id: number;
  owner: EntityName;
  stock_order?: BatchWithStockOrderStockOrder;
}

export type BatchWithWarehouseExternalBatchId = string | null;

export type BatchWithWarehouseShippingCharge = number | null;

export type BatchWithWarehouseTax = number | null;

export type BatchWithWarehouseSubtotal = number | null;

export type BatchWithWarehouseTotalPrice = number | null;

export type BatchWithWarehouseUnitCost = number | null;

export type BatchWithWarehouseOrderedAt = string | null;

export type BatchWithWarehouseExpectedAt = string | null;

export type BatchWithWarehouseArrivedAt = string | null;

export type BatchWithWarehouseTrackingNumber = string | null;

export type BatchWithWarehouseExpirationDate = string | null;

export type BatchWithWarehouseStockOrderId = string | null;

export type BatchWithWarehouseNote = string | null;

export type BatchWithWarehouseInvoiceUrl = string | null;

/**
 * Batch with warehouse schema
 */
export interface BatchWithWarehouse {
  external_batch_id?: BatchWithWarehouseExternalBatchId;
  warehouse_vendor_id: number;
  /** @minimum 0.25 */
  order_quantity: number;
  /** @minimum 0 */
  quantity_on_hand?: number;
  status?: BatchStatusEnum;
  shipping_charge?: BatchWithWarehouseShippingCharge;
  tax?: BatchWithWarehouseTax;
  subtotal?: BatchWithWarehouseSubtotal;
  total_price?: BatchWithWarehouseTotalPrice;
  unit_cost?: BatchWithWarehouseUnitCost;
  ordered_at?: BatchWithWarehouseOrderedAt;
  expected_at?: BatchWithWarehouseExpectedAt;
  arrived_at?: BatchWithWarehouseArrivedAt;
  tracking_number?: BatchWithWarehouseTrackingNumber;
  expiration_date?: BatchWithWarehouseExpirationDate;
  stock_order_id?: BatchWithWarehouseStockOrderId;
  owner_id: number;
  note?: BatchWithWarehouseNote;
  invoice_url?: BatchWithWarehouseInvoiceUrl;
  batch_id: number;
  warehouse_vendor: WarehouseVendorWithWarehouse;
}

/**
 * BirthSexEnum class
 */
export type BirthSexEnum = (typeof BirthSexEnum)[keyof typeof BirthSexEnum];

export const BirthSexEnum = {
  Female: "Female",
  Male: "Male",
} as const;

export interface BodyBestRxUpload {
  csv_file: string;
}

export interface BodyCallIncoming {
  From: string;
  To: string;
  CallSid: string;
}

export interface BodyCallOutbound {
  CallSid: string;
  call_id: number;
}

export type BodyCallRecordingCallbackCallSid = string | null;

export type BodyCallRecordingCallbackConferenceSid = string | null;

export type BodyCallRecordingCallbackFriendlyName = string | null;

export type BodyCallRecordingCallbackRecordingDuration = number | null;

export type BodyCallRecordingCallbackEncryptionDetails = string | null;

export interface BodyCallRecordingCallback {
  RecordingSid: string;
  RecordingUrl: string;
  CallSid?: BodyCallRecordingCallbackCallSid;
  ConferenceSid?: BodyCallRecordingCallbackConferenceSid;
  FriendlyName?: BodyCallRecordingCallbackFriendlyName;
  RecordingDuration?: BodyCallRecordingCallbackRecordingDuration;
  EncryptionDetails?: BodyCallRecordingCallbackEncryptionDetails;
}

export type BodyCallStatusCallbackCallDuration = number | null;

export interface BodyCallStatusCallback {
  CallSid: string;
  CallStatus: CallStatusEnum;
  CallDuration?: BodyCallStatusCallbackCallDuration;
}

export type BodyConferenceStatusCallbackConferenceSid = string | null;

export interface BodyConferenceStatusCallback {
  StatusCallbackEvent: string;
  FriendlyName: string;
  ConferenceSid?: BodyConferenceStatusCallbackConferenceSid;
}

export interface BodyConfirmOrder {
  enroll_campaign: boolean;
}

export interface BodyFirebaseCallback {
  firebase_id_token: string;
  state: string;
}

export interface BodyIncomingCallFallback {
  DialCallStatus: string;
}

export interface BodyManufactureToPurchase {
  vendor_id: number;
  unit_cost: number;
}

export type BodyRegisterClientClientId = string | null;

export type BodyRegisterClientRedirectUris = string[] | null;

export interface BodyRegisterClient {
  client_id?: BodyRegisterClientClientId;
  redirect_uris?: BodyRegisterClientRedirectUris;
}

export type BodyRespondToSmsBody = string | null;

export type BodyRespondToSmsNumMedia = number | null;

export interface BodyRespondToSms {
  From: string;
  To: string;
  Body?: BodyRespondToSmsBody;
  NumMedia?: BodyRespondToSmsNumMedia;
}

export type BodySendTextMessageAttachments = TextMessageAttachmentBase[] | null;

export interface BodySendTextMessage {
  text_message: TextMessageBase;
  attachments?: BodySendTextMessageAttachments;
}

export interface BodyToggleCallAvailability {
  is_call_available: boolean;
}

export type BodyTokenRedirectUri = string | null;

export type BodyTokenCode = string | null;

export type BodyTokenCodeVerifier = string | null;

export type BodyTokenRefreshToken = string | null;

export interface BodyToken {
  grant_type: string;
  client_id: string;
  redirect_uri?: BodyTokenRedirectUri;
  code?: BodyTokenCode;
  code_verifier?: BodyTokenCodeVerifier;
  refresh_token?: BodyTokenRefreshToken;
}

export type BodyTransferCellAcceptDigits = string | null;

export interface BodyTransferCellAccept {
  To: string;
  Digits?: BodyTransferCellAcceptDigits;
}

export type BodyVoicemailRecordingCallbackRecordingDuration = number | null;

export type BodyVoicemailRecordingCallbackRecordingStatus = string | null;

export type BodyVoicemailRecordingCallbackEncryptionDetails = string | null;

export interface BodyVoicemailRecordingCallback {
  RecordingSid: string;
  RecordingUrl: string;
  RecordingDuration?: BodyVoicemailRecordingCallbackRecordingDuration;
  RecordingStatus?: BodyVoicemailRecordingCallbackRecordingStatus;
  EncryptionDetails?: BodyVoicemailRecordingCallbackEncryptionDetails;
}

/**
 * Request schema for bulk approving batches
 */
export interface BulkApproveRequest {
  batch_ids: number[];
}

export type BulkBundlePreviousBulkBundleId = number | null;

/**
 * BulkBundle schema
 */
export interface BulkBundle {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  name: string;
  bulk_bundle_id: number;
  bulk_bundle_products: BulkBundleProductBase[];
  previous_bulk_bundle_id?: BulkBundlePreviousBulkBundleId;
}

/**
 * BulkBundle create schema
 */
export interface BulkBundleCreate {
  entity_id: number;
  name: string;
}

/**
 * Optional NDC code override for this bundle product.
 */
export type BulkBundleProductBaseNdcCode = string | null;

/**
 * BulkBundleProduct base schema
 */
export interface BulkBundleProductBase {
  bulk_bundle_id: number;
  bulk_product_id: number;
  /** @minimum 1 */
  quantity: number;
  discount_type: DiscountTypeEnum;
  /**
   * Discount value (percentage or flat rate)
   * @minimum 0
   */
  discount_value: number;
  /** Optional NDC code override for this bundle product. */
  ndc_code?: BulkBundleProductBaseNdcCode;
}

/**
 * Optional NDC code override for this bundle product.
 */
export type BulkBundleProductCreateNdcCode = string | null;

/**
 * BulkBundleProduct create schema
 */
export interface BulkBundleProductCreate {
  bulk_bundle_id: number;
  bulk_product_id: number;
  /** @minimum 1 */
  quantity: number;
  discount_type: DiscountTypeEnum;
  /**
   * Discount value (percentage or flat rate)
   * @minimum 0
   */
  discount_value: number;
  /** Optional NDC code override for this bundle product. */
  ndc_code?: BulkBundleProductCreateNdcCode;
}

/**
 * Optional NDC code override for this bundle product.
 */
export type BulkBundleProductReadNdcCode = string | null;

/**
 * BulkBundleProduct read schema
 */
export interface BulkBundleProductRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bulk_bundle_id: number;
  bulk_product_id: number;
  /** @minimum 1 */
  quantity: number;
  discount_type: DiscountTypeEnum;
  /**
   * Discount value (percentage or flat rate)
   * @minimum 0
   */
  discount_value: number;
  /** Optional NDC code override for this bundle product. */
  ndc_code?: BulkBundleProductReadNdcCode;
  bulk_product: BulkProduct;
}

export type BulkBundleReadPreviousBulkBundleId = number | null;

/**
 * BulkBundle read schema with entity and products
 */
export interface BulkBundleRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  name: string;
  bulk_bundle_id: number;
  /** Bulk products in the bundle */
  bulk_bundle_products: BulkBundleProductRead[];
  previous_bulk_bundle_id?: BulkBundleReadPreviousBulkBundleId;
  entity: EntityName;
}

export type BulkInvoiceManyReadDueAt = string | null;

export type BulkInvoiceManyReadPaidAt = string | null;

export type BulkInvoiceManyReadChargedAt = string | null;

/**
 * BulkInvoice many read schema (lookup table)
 */
export interface BulkInvoiceManyRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bulk_order_ids: string[];
  payment_collector_id: number;
  ordering_entity_id: number;
  invoice_type: InvoiceTypeEnum;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  discount?: number;
  subtotal: number;
  total: number;
  due_at?: BulkInvoiceManyReadDueAt;
  paid_at?: BulkInvoiceManyReadPaidAt;
  payment_type: PaymentTypeEnum;
  charged_at?: BulkInvoiceManyReadChargedAt;
  bulk_invoice_id: string;
  payment_collector: EntityName;
  ordering_entity: EntityName;
  bulk_orders: BulkInvoiceOrderEntityName[];
}

/**
 * BulkOrder entity name schema

Used for the bulk invoice lookup table.
 */
export interface BulkInvoiceOrderEntityName {
  bulk_order_id: string;
  entity: EntityName;
}

export type BulkInvoiceProductReadDescription = string | null;

/**
 * BulkInvoiceProduct read schema
 */
export interface BulkInvoiceProductRead {
  bulk_product_id: number;
  quantity: number;
  /** @minimum 0 */
  unit_price?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  tax_rate?: number;
  description?: BulkInvoiceProductReadDescription;
  bulk_invoice_product_id: number;
  bulk_invoice_id: string;
  bulk_order_id: string;
  bulk_product: BulkProduct;
}

export type BulkInvoiceReadDueAt = string | null;

export type BulkInvoiceReadPaidAt = string | null;

export type BulkInvoiceReadChargedAt = string | null;

export type BulkInvoiceReadPayment = EntityPaymentSummary | null;

/**
 * The bill-to entity's account number with the payment collector, if exists.
 */
export type BulkInvoiceReadAccountNumber = string | null;

/**
 * BulkInvoice read schema (detail)
 */
export interface BulkInvoiceRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bulk_order_ids: string[];
  payment_collector_id: number;
  ordering_entity_id: number;
  invoice_type: InvoiceTypeEnum;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  discount?: number;
  subtotal: number;
  total: number;
  due_at?: BulkInvoiceReadDueAt;
  paid_at?: BulkInvoiceReadPaidAt;
  payment_type: PaymentTypeEnum;
  charged_at?: BulkInvoiceReadChargedAt;
  bulk_invoice_id: string;
  ordering_entity: Entity;
  payment_collector: Entity;
  bulk_invoice_products: BulkInvoiceProductRead[];
  payment?: BulkInvoiceReadPayment;
  transactions?: TransactionRead[];
  /** The bill-to entity's account number with the payment collector, if exists. */
  account_number?: BulkInvoiceReadAccountNumber;
}

/**
 * Unique identifier for the ShipEngine label
 */
export type BulkLabelShipengineLabelId = string | null;

/**
 * Unique identifier for the shipment
 */
export type BulkLabelShipmentId = string | null;

/**
 * Cost of the shipment
 */
export type BulkLabelShipmentCost = number | null;

/**
 * Service code for the shipment (e.g., Ground, 2-Day Air)
 */
export type BulkLabelServiceCode =
  (typeof BulkLabelServiceCode)[keyof typeof BulkLabelServiceCode];

export const BulkLabelServiceCode = {
  usps_priority_mail: "usps_priority_mail",
  usps_ground_advantage: "usps_ground_advantage",
  usps_priority_mail_express: "usps_priority_mail_express",
  fedex_ground: "fedex_ground",
  fedex_home_delivery: "fedex_home_delivery",
  fedex_express_saver: "fedex_express_saver",
  fedex_2day: "fedex_2day",
  fedex_2day_am: "fedex_2day_am",
  fedex_standard_overnight: "fedex_standard_overnight",
  fedex_priority_overnight: "fedex_priority_overnight",
  ups_ground: "ups_ground",
  ups_3_day_select: "ups_3_day_select",
  ups_2nd_day_air: "ups_2nd_day_air",
  ups_2nd_day_air_am: "ups_2nd_day_air_am",
  ups_next_day_air_saver: "ups_next_day_air_saver",
  ups_next_day_air: "ups_next_day_air",
  ups_next_day_air_early_am: "ups_next_day_air_early_am",
} as const;

/**
 * ShipEngine carrier account ID
 */
export type BulkLabelShipengineCarrierId = string | null;

/**
 * URL to download the shipping label
 */
export type BulkLabelLabelDownloadUrl = string | null;

/**
 * Ship date of the shipment
 */
export type BulkLabelShipDate = string | null;

/**
 * Estimated delivery date
 */
export type BulkLabelEstimatedDeliveryDate = string | null;

/**
 * Actual delivery date
 */
export type BulkLabelActualDeliveryDate = string | null;

/**
 * BulkLabel schema
 */
export interface BulkLabel {
  /** Unique identifier for the ShipEngine label */
  shipengine_label_id?: BulkLabelShipengineLabelId;
  /** Unique identifier for the shipment */
  shipment_id?: BulkLabelShipmentId;
  /** Cost of the shipment */
  shipment_cost?: BulkLabelShipmentCost;
  /**
   * Tracking number for the shipment
   * @minLength 5
   */
  tracking_number: string;
  /** Carrier for the shipment (e.g., Fedex, UPS) */
  carrier_code: CarrierCodesEnum;
  /** Service code for the shipment (e.g., Ground, 2-Day Air) */
  service_code: BulkLabelServiceCode;
  /** ShipEngine carrier account ID */
  shipengine_carrier_id?: BulkLabelShipengineCarrierId;
  /** URL to download the shipping label */
  label_download_url?: BulkLabelLabelDownloadUrl;
  /** Ship date of the shipment */
  ship_date?: BulkLabelShipDate;
  /** Estimated delivery date */
  estimated_delivery_date?: BulkLabelEstimatedDeliveryDate;
  /** Actual delivery date */
  actual_delivery_date?: BulkLabelActualDeliveryDate;
  bulk_suborder_id: string;
  bulk_label_id: number;
}

/**
 * Unique identifier for the ShipEngine label
 */
export type BulkLabelReadShipengineLabelId = string | null;

/**
 * Unique identifier for the shipment
 */
export type BulkLabelReadShipmentId = string | null;

/**
 * Cost of the shipment
 */
export type BulkLabelReadShipmentCost = number | null;

/**
 * Service code for the shipment (e.g., Ground, 2-Day Air)
 */
export type BulkLabelReadServiceCode =
  (typeof BulkLabelReadServiceCode)[keyof typeof BulkLabelReadServiceCode];

export const BulkLabelReadServiceCode = {
  usps_priority_mail: "usps_priority_mail",
  usps_ground_advantage: "usps_ground_advantage",
  usps_priority_mail_express: "usps_priority_mail_express",
  fedex_ground: "fedex_ground",
  fedex_home_delivery: "fedex_home_delivery",
  fedex_express_saver: "fedex_express_saver",
  fedex_2day: "fedex_2day",
  fedex_2day_am: "fedex_2day_am",
  fedex_standard_overnight: "fedex_standard_overnight",
  fedex_priority_overnight: "fedex_priority_overnight",
  ups_ground: "ups_ground",
  ups_3_day_select: "ups_3_day_select",
  ups_2nd_day_air: "ups_2nd_day_air",
  ups_2nd_day_air_am: "ups_2nd_day_air_am",
  ups_next_day_air_saver: "ups_next_day_air_saver",
  ups_next_day_air: "ups_next_day_air",
  ups_next_day_air_early_am: "ups_next_day_air_early_am",
} as const;

/**
 * ShipEngine carrier account ID
 */
export type BulkLabelReadShipengineCarrierId = string | null;

/**
 * URL to download the shipping label
 */
export type BulkLabelReadLabelDownloadUrl = string | null;

/**
 * Ship date of the shipment
 */
export type BulkLabelReadShipDate = string | null;

/**
 * Estimated delivery date
 */
export type BulkLabelReadEstimatedDeliveryDate = string | null;

/**
 * Actual delivery date
 */
export type BulkLabelReadActualDeliveryDate = string | null;

export type BulkLabelReadShipengineCarrier = ShipengineCarrierRead | null;

/**
 * BulkLabel read schema
 */
export interface BulkLabelRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Unique identifier for the ShipEngine label */
  shipengine_label_id?: BulkLabelReadShipengineLabelId;
  /** Unique identifier for the shipment */
  shipment_id?: BulkLabelReadShipmentId;
  /** Cost of the shipment */
  shipment_cost?: BulkLabelReadShipmentCost;
  /**
   * Tracking number for the shipment
   * @minLength 5
   */
  tracking_number: string;
  /** Carrier for the shipment (e.g., Fedex, UPS) */
  carrier_code: CarrierCodesEnum;
  /** Service code for the shipment (e.g., Ground, 2-Day Air) */
  service_code: BulkLabelReadServiceCode;
  /** ShipEngine carrier account ID */
  shipengine_carrier_id?: BulkLabelReadShipengineCarrierId;
  /** URL to download the shipping label */
  label_download_url?: BulkLabelReadLabelDownloadUrl;
  /** Ship date of the shipment */
  ship_date?: BulkLabelReadShipDate;
  /** Estimated delivery date */
  estimated_delivery_date?: BulkLabelReadEstimatedDeliveryDate;
  /** Actual delivery date */
  actual_delivery_date?: BulkLabelReadActualDeliveryDate;
  bulk_suborder_id: string;
  bulk_label_id: number;
  bulk_shipping_updates: BulkShippingUpdateRead[];
  updated_by: UserName;
  shipengine_carrier?: BulkLabelReadShipengineCarrier;
}

/**
 * BulkOrderBundle create schema
 */
export interface BulkOrderBundleCreate {
  bulk_bundle_id: number;
  /** @minimum 1 */
  quantity: number;
}

/**
 * BulkOrderBundle read schema
 */
export interface BulkOrderBundleRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bulk_bundle_id: number;
  /** @minimum 1 */
  quantity: number;
  bulk_order_id: number;
  bulk_bundle: BulkBundle;
}

/**
 * BulkOrderContents create schema
 */
export interface BulkOrderContentsCreate {
  bulk_bundles: BulkOrderBundleCreate[];
  bulk_suborders: BulkSuborderCreate[];
}

/**
 * 
        An optional external identifier for the bulk order, which can be used for integration
        with external systems or for additional tracking purposes. Example: Salesforce Account ID
        
 */
export type BulkOrderCreateExternalId = string | null;

export type BulkOrderCreatePaymentId = number | null;

export type BulkOrderCreateConfirmedAt = string | null;

export type BulkOrderCreatePaymentDueAt = string | null;

export type BulkOrderCreateChargedAt = string | null;

export type BulkOrderCreatePaymentCollectorId = number | null;

/**
 * BulkOrder create schema
 */
export interface BulkOrderCreate {
  entity_id: number;
  /** 
        An optional external identifier for the bulk order, which can be used for integration
        with external systems or for additional tracking purposes. Example: Salesforce Account ID
         */
  external_id?: BulkOrderCreateExternalId;
  payment_type: PaymentTypeEnum;
  payment_id?: BulkOrderCreatePaymentId;
  /**
   * @minLength 1
   * @maxLength 100
   */
  contact_name: string;
  contact_email: string;
  /** @minimum 0 */
  sales_tax?: number;
  /** @minimum 0 */
  shipping_charge?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal?: number;
  /** @minimum 0 */
  total_price?: number;
  confirmed_at?: BulkOrderCreateConfirmedAt;
  payment_due_at?: BulkOrderCreatePaymentDueAt;
  charged_at?: BulkOrderCreateChargedAt;
  status: BulkOrderStatusEnum;
  is_patient_360?: boolean;
  payment_collector_id?: BulkOrderCreatePaymentCollectorId;
}

/**
 * BulkOrder entity name schema

Used for the bulk suborder lookup table
 */
export interface BulkOrderEntityName {
  bulk_order_id: string;
  entity: EntityName;
}

/**
 * BulkOrderFile create schema
 */
export interface BulkOrderFileCreate {
  file_url: string;
  file_type: FileTypeEnum;
}

/**
 * BulkOrderFile read schema
 */
export interface BulkOrderFileRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  file_url: string;
  file_type: FileTypeEnum;
  bulk_order_note_id: number;
  bulk_order_file_id: number;
}

/**
 * 
        An optional external identifier for the bulk order, which can be used for integration
        with external systems or for additional tracking purposes. Example: Salesforce Account ID
        
 */
export type BulkOrderManyReadExternalId = string | null;

export type BulkOrderManyReadPaymentId = number | null;

export type BulkOrderManyReadConfirmedAt = string | null;

export type BulkOrderManyReadPaymentDueAt = string | null;

export type BulkOrderManyReadChargedAt = string | null;

export type BulkOrderManyReadPaymentCollectorId = number | null;

export type BulkOrderManyReadPoSentAt = string | null;

export type BulkOrderManyReadPoSentTo = string[] | null;

export type BulkOrderManyReadBulkReorderSchedule = BulkReorderSchedule | null;

/**
 * BulkOrder many read schema
 */
export interface BulkOrderManyRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  /** 
        An optional external identifier for the bulk order, which can be used for integration
        with external systems or for additional tracking purposes. Example: Salesforce Account ID
         */
  external_id?: BulkOrderManyReadExternalId;
  payment_type: PaymentTypeEnum;
  payment_id?: BulkOrderManyReadPaymentId;
  /**
   * @minLength 1
   * @maxLength 100
   */
  contact_name: string;
  contact_email: string;
  /** @minimum 0 */
  sales_tax?: number;
  /** @minimum 0 */
  shipping_charge?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal?: number;
  /** @minimum 0 */
  total_price?: number;
  confirmed_at?: BulkOrderManyReadConfirmedAt;
  payment_due_at?: BulkOrderManyReadPaymentDueAt;
  charged_at?: BulkOrderManyReadChargedAt;
  status: BulkOrderStatusEnum;
  is_patient_360?: boolean;
  payment_collector_id?: BulkOrderManyReadPaymentCollectorId;
  bulk_order_id: string;
  po_sent_at?: BulkOrderManyReadPoSentAt;
  po_sent_to?: BulkOrderManyReadPoSentTo;
  entity: EntityName;
  bulk_reorder_schedule: BulkOrderManyReadBulkReorderSchedule;
  created_by: UserName;
  is_sample: boolean;
}

/**
 * BulkOrderNote schema
 */
export interface BulkOrderNote {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bulk_order_id: string;
  note: string;
  bulk_order_note_id: number;
}

/**
 * BulkOrderNote create schema
 */
export interface BulkOrderNoteCreate {
  bulk_order_id: string;
  note: string;
  bulk_order_files: BulkOrderFileCreate[];
}

/**
 * BulkOrderNote read schema
 */
export interface BulkOrderNoteRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bulk_order_id: string;
  note: string;
  bulk_order_note_id: number;
  updated_by: User;
  bulk_order_files: BulkOrderFileRead[];
}

/**
 * 
        An optional external identifier for the bulk order, which can be used for integration
        with external systems or for additional tracking purposes. Example: Salesforce Account ID
        
 */
export type BulkOrderReadExternalId = string | null;

export type BulkOrderReadPaymentId = number | null;

export type BulkOrderReadConfirmedAt = string | null;

export type BulkOrderReadPaymentDueAt = string | null;

export type BulkOrderReadChargedAt = string | null;

export type BulkOrderReadPaymentCollectorId = number | null;

export type BulkOrderReadPoSentAt = string | null;

export type BulkOrderReadPoSentTo = string[] | null;

export type BulkOrderReadBulkReorderSchedule = BulkReorderSchedule | null;

export type BulkOrderReadPaymentCollector = EntityName | null;

export type BulkOrderReadPayment = EntityPayment | null;

/**
 * BulkOrder read schema
 */
export interface BulkOrderRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  /** 
        An optional external identifier for the bulk order, which can be used for integration
        with external systems or for additional tracking purposes. Example: Salesforce Account ID
         */
  external_id?: BulkOrderReadExternalId;
  payment_type: PaymentTypeEnum;
  payment_id?: BulkOrderReadPaymentId;
  /**
   * @minLength 1
   * @maxLength 100
   */
  contact_name: string;
  contact_email: string;
  /** @minimum 0 */
  sales_tax?: number;
  /** @minimum 0 */
  shipping_charge?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal?: number;
  /** @minimum 0 */
  total_price?: number;
  confirmed_at?: BulkOrderReadConfirmedAt;
  payment_due_at?: BulkOrderReadPaymentDueAt;
  charged_at?: BulkOrderReadChargedAt;
  status: BulkOrderStatusEnum;
  is_patient_360?: boolean;
  payment_collector_id?: BulkOrderReadPaymentCollectorId;
  bulk_order_id: string;
  po_sent_at?: BulkOrderReadPoSentAt;
  po_sent_to?: BulkOrderReadPoSentTo;
  entity: Entity;
  bulk_reorder_schedule: BulkOrderReadBulkReorderSchedule;
  created_by: UserName;
  is_sample: boolean;
  payment_collector?: BulkOrderReadPaymentCollector;
  payment: BulkOrderReadPayment;
  bulk_suborders: BulkSuborderRead[];
  bulk_order_notes: BulkOrderNoteRead[];
  audit_bulk_order: Audit[];
  bulk_order_bundles: BulkOrderBundleRead[];
  ordered_at: string;
}

/**
 * BulkOrderStatusEnum class

Represents the main status of a bulk_order.
 */
export type BulkOrderStatusEnum =
  (typeof BulkOrderStatusEnum)[keyof typeof BulkOrderStatusEnum];

export const BulkOrderStatusEnum = {
  Draft: "Draft",
  Open: "Open",
  Cancelled: "Cancelled",
  Complete: "Complete",
  Reorder: "Reorder",
} as const;

export type BulkProductWholesalePrice = number | null;

export type BulkProductNickname = string | null;

/**
 * BulkProduct schema
 */
export interface BulkProduct {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  catalog_product_id: number;
  payment_collector_id: number;
  is_orderable: boolean;
  entity_price: number;
  wholesale_price?: BulkProductWholesalePrice;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: BulkProductNickname;
  bulk_product_id: number;
  catalog_product: CatalogProductRead;
  payment_collector: EntityName;
  /** Formatted product display name */
  display_name: string;
}

export type BulkProductCreateWholesalePrice = number | null;

export type BulkProductCreateNickname = string | null;

/**
 * BulkProduct create schema
 */
export interface BulkProductCreate {
  entity_id: number;
  catalog_product_id: number;
  payment_collector_id: number;
  is_orderable: boolean;
  entity_price: number;
  wholesale_price?: BulkProductCreateWholesalePrice;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: BulkProductCreateNickname;
}

export type BulkProductReadWholesalePrice = number | null;

export type BulkProductReadNickname = string | null;

/**
 * BulkProduct read schema
 */
export interface BulkProductRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  catalog_product_id: number;
  payment_collector_id: number;
  is_orderable: boolean;
  entity_price: number;
  wholesale_price?: BulkProductReadWholesalePrice;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: BulkProductReadNickname;
  bulk_product_id: number;
  catalog_product: CatalogProductRead;
  payment_collector: EntityName;
  /** Formatted product display name */
  display_name: string;
  entity: EntityName;
}

export type BulkProductWithWarehouseWholesalePrice = number | null;

export type BulkProductWithWarehouseNickname = string | null;

/**
 * BulkProduct schema with warehouse info for fulfillment context
 */
export interface BulkProductWithWarehouse {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  catalog_product_id: number;
  payment_collector_id: number;
  is_orderable: boolean;
  entity_price: number;
  wholesale_price?: BulkProductWithWarehouseWholesalePrice;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: BulkProductWithWarehouseNickname;
  bulk_product_id: number;
  catalog_product: CatalogProductReadWithWarehouse;
  payment_collector: EntityName;
  /** Formatted product display name */
  display_name: string;
}

/**
 * BulkReorderSchedule base schema
 */
export interface BulkReorderSchedule {
  bulk_reorder_schedule_id: string;
  rrule: string;
  start_at: string;
  next_run_at: string;
}

/**
 * BulkReorderSchedule create schema
 */
export interface BulkReorderScheduleCreate {
  bulk_reorder_schedule_id: string;
  rrule: string;
  start_at: string;
  next_run_at: string;
}

/**
 * BulkShippingSpeedEnum class
 */
export type BulkShippingSpeedEnum =
  (typeof BulkShippingSpeedEnum)[keyof typeof BulkShippingSpeedEnum];

export const BulkShippingSpeedEnum = {
  Ground: "Ground",
  Express: "Express",
} as const;

export type BulkShippingUpdateReadCityLocality = string | null;

export type BulkShippingUpdateReadStateProvince = string | null;

export type BulkShippingUpdateReadPostalCode = string | null;

export type BulkShippingUpdateReadCountryCode = string | null;

export type BulkShippingUpdateReadCompanyName = string | null;

export type BulkShippingUpdateReadSigner = string | null;

/**
 * Schema for reading BulkShippingUpdate tracking events
 */
export interface BulkShippingUpdateRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  occurred_at: string;
  description: string;
  city_locality?: BulkShippingUpdateReadCityLocality;
  state_province?: BulkShippingUpdateReadStateProvince;
  postal_code?: BulkShippingUpdateReadPostalCode;
  country_code?: BulkShippingUpdateReadCountryCode;
  company_name?: BulkShippingUpdateReadCompanyName;
  signer?: BulkShippingUpdateReadSigner;
  bulk_shipping_update_id: number;
  bulk_label_id: number;
}

/**
 * Bulk Suborder KPI Schema
 */
export interface BulkSuborderCounts {
  open_suborders: number;
  overdue_suborders: number;
}

export type BulkSuborderCreateBulkSuborderId = string | null;

/**
 * BulkSuborder create schema
 */
export interface BulkSuborderCreate {
  bulk_suborder_id: BulkSuborderCreateBulkSuborderId;
  fulfiller_id: number;
  shipping_speed: BulkShippingSpeedEnum;
  bulk_suborder_products: BulkSuborderProductCreate[];
}

export type BulkSuborderDashboardAvgFulfillmentTimeAvgFulfillmentTime =
  | number
  | null;

/**
 * Dashboard avg fulfillment time grouped by time period
 */
export interface BulkSuborderDashboardAvgFulfillmentTime {
  period: string;
  avg_fulfillment_time: BulkSuborderDashboardAvgFulfillmentTimeAvgFulfillmentTime;
}

/**
 * Dashboard fulfilled counts grouped by time period
 */
export interface BulkSuborderDashboardFulfilledCounts {
  period: string;
  fulfilled_suborders: number;
  fulfilled_late_suborders: number;
}

export type BulkSuborderDashboardSummaryAvgFulfillmentTime = number | null;

/**
 * Aggregate KPI summary for the dashboard header cards across the full selected date range.
 */
export interface BulkSuborderDashboardSummary {
  avg_fulfillment_time: BulkSuborderDashboardSummaryAvgFulfillmentTime;
  fulfilled_suborders: number;
  fulfilled_late_suborders: number;
}

/**
 * BulkSuborderFile create schema
 */
export interface BulkSuborderFileCreate {
  file_url: string;
  file_type: FileTypeEnum;
}

/**
 * BulkSuborderFile read schema
 */
export interface BulkSuborderFileRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  file_url: string;
  file_type: FileTypeEnum;
  bulk_suborder_note_id: number;
  bulk_suborder_file_id: number;
}

/**
 * Quantity of a bulk suborder product being fulfilled.

Used when marking a suborder fulfilled to indicate a partial fulfillment;
the unfulfilled remainder is split into a new suborder.
 */
export interface BulkSuborderFulfillQuantity {
  bulk_suborder_product_id: number;
  /** @minimum 0 */
  quantity: number;
}

export type BulkSuborderFulfillTimeAvgFulfillmentTime = number | null;

/**
 * Bulk Suborder Fulfill Time KPI Schema
 */
export interface BulkSuborderFulfillTime {
  avg_fulfillment_time: BulkSuborderFulfillTimeAvgFulfillmentTime;
}

/**
 * Bulk Suborder Fulfilled Counts KPI Schema
 */
export interface BulkSuborderFulfilledCounts {
  fulfilled_suborders: number;
  fulfilled_late_suborders: number;
}

export type BulkSuborderLookupTargetShipBy = string | null;

export type BulkSuborderLookupPoSentAt = string | null;

export type BulkSuborderLookupPoSentTo = string[] | null;

export type BulkSuborderLookupFulfillmentNote = string | null;

export type BulkSuborderLookupFulfilledAt = string | null;

export type BulkSuborderLookupDeliveredAt = string | null;

export type BulkSuborderLookupCommissionPaidAt = string | null;

export type BulkSuborderLookupShipToStAddress2 = string | null;

export type BulkSuborderLookupBulkSuborderProducts =
  | BulkSuborderProductLookup[]
  | null;

export type BulkSuborderLookupBulkSuborderNotes =
  | BulkSuborderNoteLookup[]
  | null;

/**
 * Optimized BulkSuborder schema for lookup table

This schema only loads the minimum data needed for the lookup table display:
- Basic suborder info (id, status, dates, etc.)
- Only entity names (not full entity objects)
- Only note text and basic metadata (no files)
- Only product quantities (no catalog product details)
 */
export interface BulkSuborderLookup {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bulk_suborder_id: string;
  fulfiller_id: number;
  shipping_speed: BulkShippingSpeedEnum;
  bulk_order_id: string;
  target_ship_by?: BulkSuborderLookupTargetShipBy;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  total: number;
  status: BulkSuborderStatusEnum;
  po_sent_at?: BulkSuborderLookupPoSentAt;
  po_sent_to?: BulkSuborderLookupPoSentTo;
  fulfillment_note?: BulkSuborderLookupFulfillmentNote;
  fulfilled_at?: BulkSuborderLookupFulfilledAt;
  delivered_at?: BulkSuborderLookupDeliveredAt;
  commission_paid_at?: BulkSuborderLookupCommissionPaidAt;
  ship_to_name: string;
  ship_to_st_address_1: string;
  ship_to_st_address_2?: BulkSuborderLookupShipToStAddress2;
  ship_to_city: string;
  ship_to_state_province: string;
  ship_to_postal_code: string;
  fulfiller: EntityName;
  bulk_order: BulkOrderEntityName;
  bulk_suborder_products?: BulkSuborderLookupBulkSuborderProducts;
  bulk_suborder_notes?: BulkSuborderLookupBulkSuborderNotes;
  /** Whether any product in the suborder is a sample SKU */
  is_sample?: boolean;
}

export type BulkSuborderNoteCreateIsPinned = boolean | null;

/**
 * BulkSuborderNote create schema
 */
export interface BulkSuborderNoteCreate {
  bulk_suborder_id: string;
  note: string;
  is_pinned?: BulkSuborderNoteCreateIsPinned;
  bulk_suborder_files: BulkSuborderFileCreate[];
}

/**
 * Lightweight BulkSuborderNote schema for lookup tables

Only includes fields displayed in the lookup table hover card
 */
export interface BulkSuborderNoteLookup {
  note: string;
  created_at: string;
  updated_by: UserName;
}

export type BulkSuborderNoteReadIsPinned = boolean | null;

/**
 * BulkSuborderNote read schema
 */
export interface BulkSuborderNoteRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bulk_suborder_id: string;
  note: string;
  is_pinned?: BulkSuborderNoteReadIsPinned;
  bulk_suborder_note_id: number;
  updated_by: UserName;
  bulk_suborder_files: BulkSuborderFileRead[];
}

export type BulkSuborderNoteUpdateIsPinned = boolean | null;

/**
 * BulkSuborderNote update schema
 */
export interface BulkSuborderNoteUpdate {
  bulk_suborder_id: string;
  note: string;
  is_pinned?: BulkSuborderNoteUpdateIsPinned;
  bulk_suborder_note_id: number;
}

export type BulkSuborderOrderPayment = EntityPayment | null;

/**
 * This is an order schema specifically for sub orders

This schema is used by the sub order schema to avoid recursion errors.

It also removes some fields, like total_price, that we don't want shared with fulfillers.
 */
export interface BulkSuborderOrder {
  entity: Entity;
  payment_type: PaymentTypeEnum;
  payment: BulkSuborderOrderPayment;
  contact_name: string;
  contact_email: string;
}

export type BulkSuborderProductCreateLotNumber = string | null;

export type BulkSuborderProductCreateExpirationDate = string | null;

export type BulkSuborderProductCreateBatchId = number | null;

export type BulkSuborderProductCreateWholesalePrice = number | null;

/**
 * Optional NDC code override
 */
export type BulkSuborderProductCreateNdcCode = string | null;

/**
 * BulkSuborderProduct create schema
 */
export interface BulkSuborderProductCreate {
  bulk_product_id: number;
  /** @minimum 1 */
  quantity: number;
  /** @minimum 0 */
  unit_price?: number;
  /** @minimum 0 */
  discount?: number;
  lot_number?: BulkSuborderProductCreateLotNumber;
  expiration_date?: BulkSuborderProductCreateExpirationDate;
  batch_id?: BulkSuborderProductCreateBatchId;
  wholesale_price?: BulkSuborderProductCreateWholesalePrice;
  /** Optional NDC code override */
  ndc_code?: BulkSuborderProductCreateNdcCode;
}

/**
 * Lightweight BulkSuborderProduct schema for lookup tables

Only includes quantity field needed for aggregation
 */
export interface BulkSuborderProductLookup {
  /** @minimum 1 */
  quantity: number;
}

export type BulkSuborderProductReadLotNumber = string | null;

export type BulkSuborderProductReadExpirationDate = string | null;

export type BulkSuborderProductReadBatchId = number | null;

export type BulkSuborderProductReadWholesalePrice = number | null;

/**
 * Optional NDC code override
 */
export type BulkSuborderProductReadNdcCode = string | null;

/**
 * BulkSuborderProduct read schema
 */
export interface BulkSuborderProductRead {
  bulk_product_id: number;
  /** @minimum 1 */
  quantity: number;
  /** @minimum 0 */
  unit_price?: number;
  /** @minimum 0 */
  discount?: number;
  lot_number?: BulkSuborderProductReadLotNumber;
  expiration_date?: BulkSuborderProductReadExpirationDate;
  batch_id?: BulkSuborderProductReadBatchId;
  wholesale_price?: BulkSuborderProductReadWholesalePrice;
  /** Optional NDC code override */
  ndc_code?: BulkSuborderProductReadNdcCode;
  bulk_suborder_product_id: number;
  bulk_suborder_id: string;
  bulk_product: BulkProductWithWarehouse;
}

/**
 * Nested ref for BatchLogRead to expose suborder link data
 */
export interface BulkSuborderProductRef {
  bulk_suborder_product_id: number;
  bulk_suborder_id: string;
}

export type BulkSuborderReadTargetShipBy = string | null;

export type BulkSuborderReadPoSentAt = string | null;

export type BulkSuborderReadPoSentTo = string[] | null;

export type BulkSuborderReadFulfillmentNote = string | null;

export type BulkSuborderReadFulfilledAt = string | null;

export type BulkSuborderReadDeliveredAt = string | null;

export type BulkSuborderReadCommissionPaidAt = string | null;

export type BulkSuborderReadShipToStAddress2 = string | null;

/**
 * BulkSuborder read schema
 */
export interface BulkSuborderRead {
  bulk_suborder_id: string;
  fulfiller_id: number;
  shipping_speed: BulkShippingSpeedEnum;
  bulk_order_id: string;
  target_ship_by?: BulkSuborderReadTargetShipBy;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  total: number;
  status: BulkSuborderStatusEnum;
  po_sent_at?: BulkSuborderReadPoSentAt;
  po_sent_to?: BulkSuborderReadPoSentTo;
  fulfillment_note?: BulkSuborderReadFulfillmentNote;
  fulfilled_at?: BulkSuborderReadFulfilledAt;
  delivered_at?: BulkSuborderReadDeliveredAt;
  commission_paid_at?: BulkSuborderReadCommissionPaidAt;
  ship_to_name: string;
  ship_to_st_address_1: string;
  ship_to_st_address_2?: BulkSuborderReadShipToStAddress2;
  ship_to_city: string;
  ship_to_state_province: string;
  ship_to_postal_code: string;
  bulk_suborder_products: BulkSuborderProductRead[];
  bulk_suborder_notes: BulkSuborderNoteRead[];
  bulk_labels: BulkLabelRead[];
  audit_bulk_suborder: Audit[];
}

export type BulkSuborderShipToShipToStAddress2 = string | null;

/**
 * Ship-to name and address for a bulk suborder; used on the label and packing list.
 */
export interface BulkSuborderShipTo {
  ship_to_name: string;
  ship_to_st_address_1: string;
  ship_to_st_address_2?: BulkSuborderShipToShipToStAddress2;
  ship_to_city: string;
  ship_to_state_province: string;
  ship_to_postal_code: string;
}

/**
 * BulkSuborderStatusEnum class

Represents the fulfillment status of a bulk_suborder
 */
export type BulkSuborderStatusEnum =
  (typeof BulkSuborderStatusEnum)[keyof typeof BulkSuborderStatusEnum];

export const BulkSuborderStatusEnum = {
  Draft: "Draft",
  Open: "Open",
  Fulfilled: "Fulfilled",
  Delivered: "Delivered",
  Cancelled: "Cancelled",
} as const;

export type BulkSuborderWithOrderTargetShipBy = string | null;

export type BulkSuborderWithOrderPoSentAt = string | null;

export type BulkSuborderWithOrderPoSentTo = string[] | null;

export type BulkSuborderWithOrderFulfillmentNote = string | null;

export type BulkSuborderWithOrderFulfilledAt = string | null;

export type BulkSuborderWithOrderDeliveredAt = string | null;

export type BulkSuborderWithOrderCommissionPaidAt = string | null;

export type BulkSuborderWithOrderShipToStAddress2 = string | null;

/**
 * BulkSuborder with order read schema
 */
export interface BulkSuborderWithOrder {
  bulk_suborder_id: string;
  fulfiller_id: number;
  shipping_speed: BulkShippingSpeedEnum;
  bulk_order_id: string;
  target_ship_by?: BulkSuborderWithOrderTargetShipBy;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  total: number;
  status: BulkSuborderStatusEnum;
  po_sent_at?: BulkSuborderWithOrderPoSentAt;
  po_sent_to?: BulkSuborderWithOrderPoSentTo;
  fulfillment_note?: BulkSuborderWithOrderFulfillmentNote;
  fulfilled_at?: BulkSuborderWithOrderFulfilledAt;
  delivered_at?: BulkSuborderWithOrderDeliveredAt;
  commission_paid_at?: BulkSuborderWithOrderCommissionPaidAt;
  ship_to_name: string;
  ship_to_st_address_1: string;
  ship_to_st_address_2?: BulkSuborderWithOrderShipToStAddress2;
  ship_to_city: string;
  ship_to_state_province: string;
  ship_to_postal_code: string;
  bulk_suborder_products: BulkSuborderProductRead[];
  bulk_suborder_notes: BulkSuborderNoteRead[];
  bulk_labels: BulkLabelRead[];
  audit_bulk_suborder: Audit[];
  bulk_order: BulkSuborderOrder;
}

/**
 * Bundle create schema
 */
export interface BundleCreate {
  entity_id: number;
  name: string;
}

export type BundleForOrderReadPreviousBundleId = number | null;

/**
 * Bundle for embedding in orders — product details, but no entity or fulfillers.
 */
export interface BundleForOrderRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  name: string;
  bundle_id: number;
  previous_bundle_id?: BundleForOrderReadPreviousBundleId;
  bundle_products: BundleProductWithProduct[];
}

/**
 * Entity that fulfills this product when the bundle is added to an order. Falls back to the dispensing pharmacy when unset.
 */
export type BundleProductCreateFulfillingPharmacyId = number | null;

/**
 * BundleProduct create schema
 */
export interface BundleProductCreate {
  bundle_id: number;
  product_id: number;
  /** @minimum 1 */
  quantity: number;
  discount_type: DiscountTypeEnum;
  /** @minimum 0 */
  discount_value: number;
  /** Entity that fulfills this product when the bundle is added to an order. Falls back to the dispensing pharmacy when unset. */
  fulfilling_pharmacy_id?: BundleProductCreateFulfillingPharmacyId;
}

/**
 * Entity that fulfills this product when the bundle is added to an order. Falls back to the dispensing pharmacy when unset.
 */
export type BundleProductReadFulfillingPharmacyId = number | null;

/**
 * BundleProduct read schema
 */
export interface BundleProductRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bundle_id: number;
  product_id: number;
  /** @minimum 1 */
  quantity: number;
  discount_type: DiscountTypeEnum;
  /** @minimum 0 */
  discount_value: number;
  /** Entity that fulfills this product when the bundle is added to an order. Falls back to the dispensing pharmacy when unset. */
  fulfilling_pharmacy_id?: BundleProductReadFulfillingPharmacyId;
  product: ProductRead;
}

/**
 * Entity that fulfills this product when the bundle is added to an order. Falls back to the dispensing pharmacy when unset.
 */
export type BundleProductWithProductFulfillingPharmacyId = number | null;

/**
 * BundleProduct with basic product info (no entity or fulfiller data).
 */
export interface BundleProductWithProduct {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bundle_id: number;
  product_id: number;
  /** @minimum 1 */
  quantity: number;
  discount_type: DiscountTypeEnum;
  /** @minimum 0 */
  discount_value: number;
  /** Entity that fulfills this product when the bundle is added to an order. Falls back to the dispensing pharmacy when unset. */
  fulfilling_pharmacy_id?: BundleProductWithProductFulfillingPharmacyId;
  product: Product;
}

export type BundleReadPreviousBundleId = number | null;

/**
 * Bundle read schema with entity and products
 */
export interface BundleRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  name: string;
  bundle_id: number;
  /** Products in the bundle */
  bundle_products: BundleProductRead[];
  previous_bundle_id?: BundleReadPreviousBundleId;
  entity: EntityName;
}

/**
 * CallDirectionEnum class - represents the direction of a phone call
 */
export type CallDirectionEnum =
  (typeof CallDirectionEnum)[keyof typeof CallDirectionEnum];

export const CallDirectionEnum = {
  inbound: "inbound",
  outbound: "outbound",
} as const;

/**
 * Call count bucketed into duration intervals.
 */
export interface CallDurationHistogram {
  bucket: string;
  total: number;
}

/**
 * CallStatusEnum class - represents the status of a phone call
 */
export type CallStatusEnum =
  (typeof CallStatusEnum)[keyof typeof CallStatusEnum];

export const CallStatusEnum = {
  queued: "queued",
  initiated: "initiated",
  ringing: "ringing",
  "in-progress": "in-progress",
  completed: "completed",
  failed: "failed",
  "no-answer": "no-answer",
  busy: "busy",
  canceled: "canceled",
} as const;

/**
 * Phone call agents that appear on calls in the calling dashboard.
 */
export interface CallingAgent {
  user_id: string;
  first_name: string;
  last_name: string;
}

/**
 * Metrics for the calling dashboard
 */
export interface CallingMetrics {
  total_calls: number;
  inbound_calls: number;
  outbound_calls: number;
  missed_calls: number;
  avg_duration: number;
  total_duration: number;
}

/**
 * Call count grouped by hour of the day.
 */
export interface CallsByHour {
  hour: number;
  total: number;
}

/**
 * Call volume over time for the calling dashboard.
 */
export interface CallsOverTime {
  inbound: number;
  outbound: number;
  date: string;
}

/**
 * Campaign opt-in counts for the texting dashboard.
 */
export interface CampaignOptIns {
  campaign: string;
  count: number;
}

/**
 * Entities this entity can order from
 */
export interface CanSeeEntities {
  seen_by_entity_id: number;
  can_see_entity_id: number;
  can_see_entity: EntityName;
}

/**
 * ShipEngineCarrierCodes enum
 */
export type CarrierCodesEnum =
  (typeof CarrierCodesEnum)[keyof typeof CarrierCodesEnum];

export const CarrierCodesEnum = {
  stamps_com: "stamps_com",
  fedex: "fedex",
  ups: "ups",
} as const;

/**
 * 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
        
 */
export type CatalogProductSku = string | null;

/**
 * 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
        
 */
export type CatalogProductStrength = string | null;

/**
 * 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
        
 */
export type CatalogProductRoute = AdministrationRouteEnum | null;

/**
 * Dosage form of the product
 */
export type CatalogProductDosage = DosageFormEnum | null;

/**
 * Color of the product. Included in the display name when set.
 */
export type CatalogProductColor = ProductColorEnum | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductGrossMerchandiseValue = number | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductAverageWholesalePrice = number | null;

/**
 * Retail price pharmacies are recommended to sell the drug at.
 */
export type CatalogProductSuggestedPrice = number | null;

/**
 * Firebase image URL of the product
 */
export type CatalogProductImage = string | null;

/**
 * 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
        
 */
export type CatalogProductDescription = string | null;

/**
 * Identifier for the fulfiller
 */
export type CatalogProductFulfillerId = number | null;

/**
 * If the product is a kit, this field should be null.
 */
export type CatalogProductNdcCode = string | null;

/**
 * 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
        
 */
export type CatalogProductExternalId = string | null;

/**
 * CatalogProduct schema
 */
export interface CatalogProduct {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Identifier for the base product */
  product_base_id: number;
  /** Identifier for the product brand */
  product_brand_id: number;
  /** Along with the unit field, this describes the size of the product. */
  size: number;
  /** 
        Unit of measurement for the product size. (e.g., mg, ml, g, etc.) For a 
        standalone product, like a single kit, the unit will be 1 'ct' (count).
         */
  unit: ProductUnitEnum;
  /** 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
         */
  sku?: CatalogProductSku;
  /** 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
         */
  strength?: CatalogProductStrength;
  /** 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
         */
  route?: CatalogProductRoute;
  /** Dosage form of the product */
  dosage?: CatalogProductDosage;
  /** Color of the product. Included in the display name when set. */
  color?: CatalogProductColor;
  /** Not currently used anywhere */
  gross_merchandise_value?: CatalogProductGrossMerchandiseValue;
  /** Not currently used anywhere */
  average_wholesale_price?: CatalogProductAverageWholesalePrice;
  /** Retail price pharmacies are recommended to sell the drug at. */
  suggested_price?: CatalogProductSuggestedPrice;
  /** Firebase image URL of the product */
  image?: CatalogProductImage;
  /** 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
         */
  description?: CatalogProductDescription;
  /** Identifier for the fulfiller */
  fulfiller_id?: CatalogProductFulfillerId;
  /** If the product is a kit, this field should be null. */
  ndc_code?: CatalogProductNdcCode;
  /** 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
         */
  external_id?: CatalogProductExternalId;
  /** 
        Whether this catalog product is a sample SKU. Sample products are created through the
        Sales 360 sample flow, are hidden from normal catalog/bulk product lists, and can be
        promoted to a full catalog product.
         */
  is_sample?: boolean;
  catalog_product_id: number;
}

/**
 * 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
        
 */
export type CatalogProductCreateSku = string | null;

/**
 * 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
        
 */
export type CatalogProductCreateStrength = string | null;

/**
 * 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
        
 */
export type CatalogProductCreateRoute = AdministrationRouteEnum | null;

/**
 * Dosage form of the product
 */
export type CatalogProductCreateDosage = DosageFormEnum | null;

/**
 * Color of the product. Included in the display name when set.
 */
export type CatalogProductCreateColor = ProductColorEnum | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductCreateGrossMerchandiseValue = number | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductCreateAverageWholesalePrice = number | null;

/**
 * Retail price pharmacies are recommended to sell the drug at.
 */
export type CatalogProductCreateSuggestedPrice = number | null;

/**
 * Firebase image URL of the product
 */
export type CatalogProductCreateImage = string | null;

/**
 * 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
        
 */
export type CatalogProductCreateDescription = string | null;

/**
 * Identifier for the fulfiller
 */
export type CatalogProductCreateFulfillerId = number | null;

/**
 * If the product is a kit, this field should be null.
 */
export type CatalogProductCreateNdcCode = string | null;

/**
 * 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
        
 */
export type CatalogProductCreateExternalId = string | null;

/**
 * CatalogProduct create schema
 */
export interface CatalogProductCreate {
  /** Identifier for the base product */
  product_base_id: number;
  /** Identifier for the product brand */
  product_brand_id: number;
  /** Along with the unit field, this describes the size of the product. */
  size: number;
  /** 
        Unit of measurement for the product size. (e.g., mg, ml, g, etc.) For a 
        standalone product, like a single kit, the unit will be 1 'ct' (count).
         */
  unit: ProductUnitEnum;
  /** 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
         */
  sku?: CatalogProductCreateSku;
  /** 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
         */
  strength?: CatalogProductCreateStrength;
  /** 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
         */
  route?: CatalogProductCreateRoute;
  /** Dosage form of the product */
  dosage?: CatalogProductCreateDosage;
  /** Color of the product. Included in the display name when set. */
  color?: CatalogProductCreateColor;
  /** Not currently used anywhere */
  gross_merchandise_value?: CatalogProductCreateGrossMerchandiseValue;
  /** Not currently used anywhere */
  average_wholesale_price?: CatalogProductCreateAverageWholesalePrice;
  /** Retail price pharmacies are recommended to sell the drug at. */
  suggested_price?: CatalogProductCreateSuggestedPrice;
  /** Firebase image URL of the product */
  image?: CatalogProductCreateImage;
  /** 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
         */
  description?: CatalogProductCreateDescription;
  /** Identifier for the fulfiller */
  fulfiller_id?: CatalogProductCreateFulfillerId;
  /** If the product is a kit, this field should be null. */
  ndc_code?: CatalogProductCreateNdcCode;
  /** 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
         */
  external_id?: CatalogProductCreateExternalId;
  /** 
        Whether this catalog product is a sample SKU. Sample products are created through the
        Sales 360 sample flow, are hidden from normal catalog/bulk product lists, and can be
        promoted to a full catalog product.
         */
  is_sample?: boolean;
  /** List of entity IDs that can see the catalog product */
  visible_entity_ids: number[];
}

/**
 * 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
        
 */
export type CatalogProductReadSku = string | null;

/**
 * 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
        
 */
export type CatalogProductReadStrength = string | null;

/**
 * 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
        
 */
export type CatalogProductReadRoute = AdministrationRouteEnum | null;

/**
 * Dosage form of the product
 */
export type CatalogProductReadDosage = DosageFormEnum | null;

/**
 * Color of the product. Included in the display name when set.
 */
export type CatalogProductReadColor = ProductColorEnum | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductReadGrossMerchandiseValue = number | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductReadAverageWholesalePrice = number | null;

/**
 * Retail price pharmacies are recommended to sell the drug at.
 */
export type CatalogProductReadSuggestedPrice = number | null;

/**
 * Firebase image URL of the product
 */
export type CatalogProductReadImage = string | null;

/**
 * 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
        
 */
export type CatalogProductReadDescription = string | null;

/**
 * Identifier for the fulfiller
 */
export type CatalogProductReadFulfillerId = number | null;

/**
 * If the product is a kit, this field should be null.
 */
export type CatalogProductReadNdcCode = string | null;

/**
 * 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
        
 */
export type CatalogProductReadExternalId = string | null;

/**
 * Fulfiller information
 */
export type CatalogProductReadFulfiller = EntityName | null;

/**
 * CatalogProduct read schema
 */
export interface CatalogProductRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Identifier for the base product */
  product_base_id: number;
  /** Identifier for the product brand */
  product_brand_id: number;
  /** Along with the unit field, this describes the size of the product. */
  size: number;
  /** 
        Unit of measurement for the product size. (e.g., mg, ml, g, etc.) For a 
        standalone product, like a single kit, the unit will be 1 'ct' (count).
         */
  unit: ProductUnitEnum;
  /** 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
         */
  sku?: CatalogProductReadSku;
  /** 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
         */
  strength?: CatalogProductReadStrength;
  /** 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
         */
  route?: CatalogProductReadRoute;
  /** Dosage form of the product */
  dosage?: CatalogProductReadDosage;
  /** Color of the product. Included in the display name when set. */
  color?: CatalogProductReadColor;
  /** Not currently used anywhere */
  gross_merchandise_value?: CatalogProductReadGrossMerchandiseValue;
  /** Not currently used anywhere */
  average_wholesale_price?: CatalogProductReadAverageWholesalePrice;
  /** Retail price pharmacies are recommended to sell the drug at. */
  suggested_price?: CatalogProductReadSuggestedPrice;
  /** Firebase image URL of the product */
  image?: CatalogProductReadImage;
  /** 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
         */
  description?: CatalogProductReadDescription;
  /** Identifier for the fulfiller */
  fulfiller_id?: CatalogProductReadFulfillerId;
  /** If the product is a kit, this field should be null. */
  ndc_code?: CatalogProductReadNdcCode;
  /** 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
         */
  external_id?: CatalogProductReadExternalId;
  /** 
        Whether this catalog product is a sample SKU. Sample products are created through the
        Sales 360 sample flow, are hidden from normal catalog/bulk product lists, and can be
        promoted to a full catalog product.
         */
  is_sample?: boolean;
  catalog_product_id: number;
  /** Base product information */
  product_base: ProductBaseRead;
  /** Brand information */
  product_brand: ProductBrandRead;
  /** Fulfiller information */
  fulfiller?: CatalogProductReadFulfiller;
  /** Formatted catalog product strength */
  display_strength: string;
  /** Formatted catalog product display name */
  display_name: string;
  /** List of components in the product, such as kit items */
  components: ComponentRead[];
}

/**
 * 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
        
 */
export type CatalogProductReadWithVisibilitySku = string | null;

/**
 * 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
        
 */
export type CatalogProductReadWithVisibilityStrength = string | null;

/**
 * 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
        
 */
export type CatalogProductReadWithVisibilityRoute =
  AdministrationRouteEnum | null;

/**
 * Dosage form of the product
 */
export type CatalogProductReadWithVisibilityDosage = DosageFormEnum | null;

/**
 * Color of the product. Included in the display name when set.
 */
export type CatalogProductReadWithVisibilityColor = ProductColorEnum | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductReadWithVisibilityGrossMerchandiseValue =
  | number
  | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductReadWithVisibilityAverageWholesalePrice =
  | number
  | null;

/**
 * Retail price pharmacies are recommended to sell the drug at.
 */
export type CatalogProductReadWithVisibilitySuggestedPrice = number | null;

/**
 * Firebase image URL of the product
 */
export type CatalogProductReadWithVisibilityImage = string | null;

/**
 * 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
        
 */
export type CatalogProductReadWithVisibilityDescription = string | null;

/**
 * Identifier for the fulfiller
 */
export type CatalogProductReadWithVisibilityFulfillerId = number | null;

/**
 * If the product is a kit, this field should be null.
 */
export type CatalogProductReadWithVisibilityNdcCode = string | null;

/**
 * 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
        
 */
export type CatalogProductReadWithVisibilityExternalId = string | null;

/**
 * Fulfiller information
 */
export type CatalogProductReadWithVisibilityFulfiller = EntityName | null;

/**
 * CatalogProduct read with visibility schema
 */
export interface CatalogProductReadWithVisibility {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Identifier for the base product */
  product_base_id: number;
  /** Identifier for the product brand */
  product_brand_id: number;
  /** Along with the unit field, this describes the size of the product. */
  size: number;
  /** 
        Unit of measurement for the product size. (e.g., mg, ml, g, etc.) For a 
        standalone product, like a single kit, the unit will be 1 'ct' (count).
         */
  unit: ProductUnitEnum;
  /** 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
         */
  sku?: CatalogProductReadWithVisibilitySku;
  /** 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
         */
  strength?: CatalogProductReadWithVisibilityStrength;
  /** 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
         */
  route?: CatalogProductReadWithVisibilityRoute;
  /** Dosage form of the product */
  dosage?: CatalogProductReadWithVisibilityDosage;
  /** Color of the product. Included in the display name when set. */
  color?: CatalogProductReadWithVisibilityColor;
  /** Not currently used anywhere */
  gross_merchandise_value?: CatalogProductReadWithVisibilityGrossMerchandiseValue;
  /** Not currently used anywhere */
  average_wholesale_price?: CatalogProductReadWithVisibilityAverageWholesalePrice;
  /** Retail price pharmacies are recommended to sell the drug at. */
  suggested_price?: CatalogProductReadWithVisibilitySuggestedPrice;
  /** Firebase image URL of the product */
  image?: CatalogProductReadWithVisibilityImage;
  /** 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
         */
  description?: CatalogProductReadWithVisibilityDescription;
  /** Identifier for the fulfiller */
  fulfiller_id?: CatalogProductReadWithVisibilityFulfillerId;
  /** If the product is a kit, this field should be null. */
  ndc_code?: CatalogProductReadWithVisibilityNdcCode;
  /** 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
         */
  external_id?: CatalogProductReadWithVisibilityExternalId;
  /** 
        Whether this catalog product is a sample SKU. Sample products are created through the
        Sales 360 sample flow, are hidden from normal catalog/bulk product lists, and can be
        promoted to a full catalog product.
         */
  is_sample?: boolean;
  catalog_product_id: number;
  /** Base product information */
  product_base: ProductBaseRead;
  /** Brand information */
  product_brand: ProductBrandRead;
  /** Fulfiller information */
  fulfiller?: CatalogProductReadWithVisibilityFulfiller;
  /** Formatted catalog product strength */
  display_strength: string;
  /** Formatted catalog product display name */
  display_name: string;
  /** List of components in the product, such as kit items */
  components: ComponentRead[];
  catalog_product_visibility: CatalogProductVisibilityRead[];
}

/**
 * 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
        
 */
export type CatalogProductReadWithWarehouseSku = string | null;

/**
 * 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
        
 */
export type CatalogProductReadWithWarehouseStrength = string | null;

/**
 * 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
        
 */
export type CatalogProductReadWithWarehouseRoute =
  AdministrationRouteEnum | null;

/**
 * Dosage form of the product
 */
export type CatalogProductReadWithWarehouseDosage = DosageFormEnum | null;

/**
 * Color of the product. Included in the display name when set.
 */
export type CatalogProductReadWithWarehouseColor = ProductColorEnum | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductReadWithWarehouseGrossMerchandiseValue =
  | number
  | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductReadWithWarehouseAverageWholesalePrice =
  | number
  | null;

/**
 * Retail price pharmacies are recommended to sell the drug at.
 */
export type CatalogProductReadWithWarehouseSuggestedPrice = number | null;

/**
 * Firebase image URL of the product
 */
export type CatalogProductReadWithWarehouseImage = string | null;

/**
 * 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
        
 */
export type CatalogProductReadWithWarehouseDescription = string | null;

/**
 * Identifier for the fulfiller
 */
export type CatalogProductReadWithWarehouseFulfillerId = number | null;

/**
 * If the product is a kit, this field should be null.
 */
export type CatalogProductReadWithWarehouseNdcCode = string | null;

/**
 * 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
        
 */
export type CatalogProductReadWithWarehouseExternalId = string | null;

/**
 * Fulfiller information
 */
export type CatalogProductReadWithWarehouseFulfiller = EntityName | null;

/**
 * Warehouse information
 */
export type CatalogProductReadWithWarehouseWarehouse =
  CatalogProductWarehouse | null;

/**
 * CatalogProduct read schema with warehouse info for fulfillment context
 */
export interface CatalogProductReadWithWarehouse {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Identifier for the base product */
  product_base_id: number;
  /** Identifier for the product brand */
  product_brand_id: number;
  /** Along with the unit field, this describes the size of the product. */
  size: number;
  /** 
        Unit of measurement for the product size. (e.g., mg, ml, g, etc.) For a 
        standalone product, like a single kit, the unit will be 1 'ct' (count).
         */
  unit: ProductUnitEnum;
  /** 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
         */
  sku?: CatalogProductReadWithWarehouseSku;
  /** 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
         */
  strength?: CatalogProductReadWithWarehouseStrength;
  /** 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
         */
  route?: CatalogProductReadWithWarehouseRoute;
  /** Dosage form of the product */
  dosage?: CatalogProductReadWithWarehouseDosage;
  /** Color of the product. Included in the display name when set. */
  color?: CatalogProductReadWithWarehouseColor;
  /** Not currently used anywhere */
  gross_merchandise_value?: CatalogProductReadWithWarehouseGrossMerchandiseValue;
  /** Not currently used anywhere */
  average_wholesale_price?: CatalogProductReadWithWarehouseAverageWholesalePrice;
  /** Retail price pharmacies are recommended to sell the drug at. */
  suggested_price?: CatalogProductReadWithWarehouseSuggestedPrice;
  /** Firebase image URL of the product */
  image?: CatalogProductReadWithWarehouseImage;
  /** 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
         */
  description?: CatalogProductReadWithWarehouseDescription;
  /** Identifier for the fulfiller */
  fulfiller_id?: CatalogProductReadWithWarehouseFulfillerId;
  /** If the product is a kit, this field should be null. */
  ndc_code?: CatalogProductReadWithWarehouseNdcCode;
  /** 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
         */
  external_id?: CatalogProductReadWithWarehouseExternalId;
  /** 
        Whether this catalog product is a sample SKU. Sample products are created through the
        Sales 360 sample flow, are hidden from normal catalog/bulk product lists, and can be
        promoted to a full catalog product.
         */
  is_sample?: boolean;
  catalog_product_id: number;
  /** Base product information */
  product_base: ProductBaseRead;
  /** Brand information */
  product_brand: ProductBrandRead;
  /** Fulfiller information */
  fulfiller?: CatalogProductReadWithWarehouseFulfiller;
  /** Formatted catalog product strength */
  display_strength: string;
  /** Formatted catalog product display name */
  display_name: string;
  /** List of components in the product, such as kit items */
  components: ComponentRead[];
  /** Warehouse information */
  warehouse?: CatalogProductReadWithWarehouseWarehouse;
}

/**
 * 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
        
 */
export type CatalogProductReadWithoutComponentsSku = string | null;

/**
 * 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
        
 */
export type CatalogProductReadWithoutComponentsStrength = string | null;

/**
 * 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
        
 */
export type CatalogProductReadWithoutComponentsRoute =
  AdministrationRouteEnum | null;

/**
 * Dosage form of the product
 */
export type CatalogProductReadWithoutComponentsDosage = DosageFormEnum | null;

/**
 * Color of the product. Included in the display name when set.
 */
export type CatalogProductReadWithoutComponentsColor = ProductColorEnum | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductReadWithoutComponentsGrossMerchandiseValue =
  | number
  | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductReadWithoutComponentsAverageWholesalePrice =
  | number
  | null;

/**
 * Retail price pharmacies are recommended to sell the drug at.
 */
export type CatalogProductReadWithoutComponentsSuggestedPrice = number | null;

/**
 * Firebase image URL of the product
 */
export type CatalogProductReadWithoutComponentsImage = string | null;

/**
 * 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
        
 */
export type CatalogProductReadWithoutComponentsDescription = string | null;

/**
 * Identifier for the fulfiller
 */
export type CatalogProductReadWithoutComponentsFulfillerId = number | null;

/**
 * If the product is a kit, this field should be null.
 */
export type CatalogProductReadWithoutComponentsNdcCode = string | null;

/**
 * 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
        
 */
export type CatalogProductReadWithoutComponentsExternalId = string | null;

/**
 * Fulfiller information
 */
export type CatalogProductReadWithoutComponentsFulfiller = EntityName | null;

/**
 * CatalogProduct read schema without components

This is used by the ComponentRead schema to avoid an infinite recursion loop.
CatalogProducts get components and components get products, but those sub-products can't get
more sub-components.
 */
export interface CatalogProductReadWithoutComponents {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Identifier for the base product */
  product_base_id: number;
  /** Identifier for the product brand */
  product_brand_id: number;
  /** Along with the unit field, this describes the size of the product. */
  size: number;
  /** 
        Unit of measurement for the product size. (e.g., mg, ml, g, etc.) For a 
        standalone product, like a single kit, the unit will be 1 'ct' (count).
         */
  unit: ProductUnitEnum;
  /** 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
         */
  sku?: CatalogProductReadWithoutComponentsSku;
  /** 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
         */
  strength?: CatalogProductReadWithoutComponentsStrength;
  /** 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
         */
  route?: CatalogProductReadWithoutComponentsRoute;
  /** Dosage form of the product */
  dosage?: CatalogProductReadWithoutComponentsDosage;
  /** Color of the product. Included in the display name when set. */
  color?: CatalogProductReadWithoutComponentsColor;
  /** Not currently used anywhere */
  gross_merchandise_value?: CatalogProductReadWithoutComponentsGrossMerchandiseValue;
  /** Not currently used anywhere */
  average_wholesale_price?: CatalogProductReadWithoutComponentsAverageWholesalePrice;
  /** Retail price pharmacies are recommended to sell the drug at. */
  suggested_price?: CatalogProductReadWithoutComponentsSuggestedPrice;
  /** Firebase image URL of the product */
  image?: CatalogProductReadWithoutComponentsImage;
  /** 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
         */
  description?: CatalogProductReadWithoutComponentsDescription;
  /** Identifier for the fulfiller */
  fulfiller_id?: CatalogProductReadWithoutComponentsFulfillerId;
  /** If the product is a kit, this field should be null. */
  ndc_code?: CatalogProductReadWithoutComponentsNdcCode;
  /** 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
         */
  external_id?: CatalogProductReadWithoutComponentsExternalId;
  /** 
        Whether this catalog product is a sample SKU. Sample products are created through the
        Sales 360 sample flow, are hidden from normal catalog/bulk product lists, and can be
        promoted to a full catalog product.
         */
  is_sample?: boolean;
  catalog_product_id: number;
  /** Base product information */
  product_base: ProductBaseRead;
  /** Brand information */
  product_brand: ProductBrandRead;
  /** Fulfiller information */
  fulfiller?: CatalogProductReadWithoutComponentsFulfiller;
  /** Formatted catalog product strength */
  display_strength: string;
  /** Formatted catalog product display name */
  display_name: string;
}

/**
 * Schema for catalog product usage checks
 */
export interface CatalogProductUsageCheck {
  /** Markdown link to the object */
  link: string;
  /** Name of the database table */
  table: string;
  /** Identifier for the catalog product */
  item_id: number;
  /** Identifier for the entity using the catalog product */
  entity_id: number;
  /** Name of the entity using the catalog product */
  entity: string;
}

/**
 * Visibility read schema
 */
export interface CatalogProductVisibilityRead {
  catalog_product_id: number;
  entity_id: number;
  /** Name of the entity who can see the catalog product. */
  entity: EntityName;
}

export type CatalogProductWarehouseReorderLevel = number | null;

export type CatalogProductWarehouseHoldingCost = number | null;

/**
 * Lightweight warehouse schema to avoid circular imports with the warehouse module.
 */
export interface CatalogProductWarehouse {
  warehouse_id: number;
  quantity_on_hand?: number;
  source: WarehouseSourceEnum;
  reorder_level?: CatalogProductWarehouseReorderLevel;
  holding_cost?: CatalogProductWarehouseHoldingCost;
}

/**
 * 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
        
 */
export type CatalogProductWithWarehouseSku = string | null;

/**
 * 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
        
 */
export type CatalogProductWithWarehouseStrength = string | null;

/**
 * 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
        
 */
export type CatalogProductWithWarehouseRoute = AdministrationRouteEnum | null;

/**
 * Dosage form of the product
 */
export type CatalogProductWithWarehouseDosage = DosageFormEnum | null;

/**
 * Color of the product. Included in the display name when set.
 */
export type CatalogProductWithWarehouseColor = ProductColorEnum | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductWithWarehouseGrossMerchandiseValue = number | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductWithWarehouseAverageWholesalePrice = number | null;

/**
 * Retail price pharmacies are recommended to sell the drug at.
 */
export type CatalogProductWithWarehouseSuggestedPrice = number | null;

/**
 * Firebase image URL of the product
 */
export type CatalogProductWithWarehouseImage = string | null;

/**
 * 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
        
 */
export type CatalogProductWithWarehouseDescription = string | null;

/**
 * Identifier for the fulfiller
 */
export type CatalogProductWithWarehouseFulfillerId = number | null;

/**
 * If the product is a kit, this field should be null.
 */
export type CatalogProductWithWarehouseNdcCode = string | null;

/**
 * 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
        
 */
export type CatalogProductWithWarehouseExternalId = string | null;

/**
 * Fulfiller information
 */
export type CatalogProductWithWarehouseFulfiller = EntityName | null;

export type CatalogProductWithWarehouseWarehouse = WarehouseManyRead | null;

/**
 * Catalog Product with warehouse vendors specifically for Stock 360 use
 */
export interface CatalogProductWithWarehouse {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Identifier for the base product */
  product_base_id: number;
  /** Identifier for the product brand */
  product_brand_id: number;
  /** Along with the unit field, this describes the size of the product. */
  size: number;
  /** 
        Unit of measurement for the product size. (e.g., mg, ml, g, etc.) For a 
        standalone product, like a single kit, the unit will be 1 'ct' (count).
         */
  unit: ProductUnitEnum;
  /** 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
         */
  sku?: CatalogProductWithWarehouseSku;
  /** 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
         */
  strength?: CatalogProductWithWarehouseStrength;
  /** 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
         */
  route?: CatalogProductWithWarehouseRoute;
  /** Dosage form of the product */
  dosage?: CatalogProductWithWarehouseDosage;
  /** Color of the product. Included in the display name when set. */
  color?: CatalogProductWithWarehouseColor;
  /** Not currently used anywhere */
  gross_merchandise_value?: CatalogProductWithWarehouseGrossMerchandiseValue;
  /** Not currently used anywhere */
  average_wholesale_price?: CatalogProductWithWarehouseAverageWholesalePrice;
  /** Retail price pharmacies are recommended to sell the drug at. */
  suggested_price?: CatalogProductWithWarehouseSuggestedPrice;
  /** Firebase image URL of the product */
  image?: CatalogProductWithWarehouseImage;
  /** 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
         */
  description?: CatalogProductWithWarehouseDescription;
  /** Identifier for the fulfiller */
  fulfiller_id?: CatalogProductWithWarehouseFulfillerId;
  /** If the product is a kit, this field should be null. */
  ndc_code?: CatalogProductWithWarehouseNdcCode;
  /** 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
         */
  external_id?: CatalogProductWithWarehouseExternalId;
  /** 
        Whether this catalog product is a sample SKU. Sample products are created through the
        Sales 360 sample flow, are hidden from normal catalog/bulk product lists, and can be
        promoted to a full catalog product.
         */
  is_sample?: boolean;
  catalog_product_id: number;
  /** Base product information */
  product_base: ProductBaseRead;
  /** Brand information */
  product_brand: ProductBrandRead;
  /** Fulfiller information */
  fulfiller?: CatalogProductWithWarehouseFulfiller;
  /** Formatted catalog product strength */
  display_strength: string;
  /** Formatted catalog product display name */
  display_name: string;
  warehouse?: CatalogProductWithWarehouseWarehouse;
}

/**
 * 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
        
 */
export type CatalogProductWithWarehouseBaseSku = string | null;

/**
 * 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
        
 */
export type CatalogProductWithWarehouseBaseStrength = string | null;

/**
 * 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
        
 */
export type CatalogProductWithWarehouseBaseRoute =
  AdministrationRouteEnum | null;

/**
 * Dosage form of the product
 */
export type CatalogProductWithWarehouseBaseDosage = DosageFormEnum | null;

/**
 * Color of the product. Included in the display name when set.
 */
export type CatalogProductWithWarehouseBaseColor = ProductColorEnum | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductWithWarehouseBaseGrossMerchandiseValue =
  | number
  | null;

/**
 * Not currently used anywhere
 */
export type CatalogProductWithWarehouseBaseAverageWholesalePrice =
  | number
  | null;

/**
 * Retail price pharmacies are recommended to sell the drug at.
 */
export type CatalogProductWithWarehouseBaseSuggestedPrice = number | null;

/**
 * Firebase image URL of the product
 */
export type CatalogProductWithWarehouseBaseImage = string | null;

/**
 * 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
        
 */
export type CatalogProductWithWarehouseBaseDescription = string | null;

/**
 * Identifier for the fulfiller
 */
export type CatalogProductWithWarehouseBaseFulfillerId = number | null;

/**
 * If the product is a kit, this field should be null.
 */
export type CatalogProductWithWarehouseBaseNdcCode = string | null;

/**
 * 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
        
 */
export type CatalogProductWithWarehouseBaseExternalId = string | null;

/**
 * Fulfiller information
 */
export type CatalogProductWithWarehouseBaseFulfiller = EntityName | null;

export type CatalogProductWithWarehouseBaseWarehouse = WarehouseBase | null;

/**
 * CatalogProduct with basic warehouse info (no vendors or batches)
 */
export interface CatalogProductWithWarehouseBase {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Identifier for the base product */
  product_base_id: number;
  /** Identifier for the product brand */
  product_brand_id: number;
  /** Along with the unit field, this describes the size of the product. */
  size: number;
  /** 
        Unit of measurement for the product size. (e.g., mg, ml, g, etc.) For a 
        standalone product, like a single kit, the unit will be 1 'ct' (count).
         */
  unit: ProductUnitEnum;
  /** 
        Unique Stock Keeping Unit manually created by Legrande admins. 
        This is only used internally.
         */
  sku?: CatalogProductWithWarehouseBaseSku;
  /** 
        This field is just for medications (Rx). It describes the strength of the 
        product as a percentage.
         */
  strength?: CatalogProductWithWarehouseBaseStrength;
  /** 
        Route of administration for the product. The options are 'Oral', 'Ophthalmic' 
        (direct application to the eye).
         */
  route?: CatalogProductWithWarehouseBaseRoute;
  /** Dosage form of the product */
  dosage?: CatalogProductWithWarehouseBaseDosage;
  /** Color of the product. Included in the display name when set. */
  color?: CatalogProductWithWarehouseBaseColor;
  /** Not currently used anywhere */
  gross_merchandise_value?: CatalogProductWithWarehouseBaseGrossMerchandiseValue;
  /** Not currently used anywhere */
  average_wholesale_price?: CatalogProductWithWarehouseBaseAverageWholesalePrice;
  /** Retail price pharmacies are recommended to sell the drug at. */
  suggested_price?: CatalogProductWithWarehouseBaseSuggestedPrice;
  /** Firebase image URL of the product */
  image?: CatalogProductWithWarehouseBaseImage;
  /** 
        Description of the product. Currently also holds Imprimis' NDC number that 
        they've asked us to assign to certain kits.
         */
  description?: CatalogProductWithWarehouseBaseDescription;
  /** Identifier for the fulfiller */
  fulfiller_id?: CatalogProductWithWarehouseBaseFulfillerId;
  /** If the product is a kit, this field should be null. */
  ndc_code?: CatalogProductWithWarehouseBaseNdcCode;
  /** 
        An optional external identifier for the product, which can be used for integration
        with external systems or for additional tracking purposes. Example: used for imprimis
        kits' NDC's
         */
  external_id?: CatalogProductWithWarehouseBaseExternalId;
  /** 
        Whether this catalog product is a sample SKU. Sample products are created through the
        Sales 360 sample flow, are hidden from normal catalog/bulk product lists, and can be
        promoted to a full catalog product.
         */
  is_sample?: boolean;
  catalog_product_id: number;
  /** Base product information */
  product_base: ProductBaseRead;
  /** Brand information */
  product_brand: ProductBrandRead;
  /** Fulfiller information */
  fulfiller?: CatalogProductWithWarehouseBaseFulfiller;
  /** Formatted catalog product strength */
  display_strength: string;
  /** Formatted catalog product display name */
  display_name: string;
  warehouse?: CatalogProductWithWarehouseBaseWarehouse;
}

/**
 * User eligible to receive a call transfer on their cell phone.
 */
export interface CellTransferTarget {
  user_id: string;
  first_name: string;
  last_name: string;
  /** User's cell phone number */
  phone: string;
}

/**
 * ChronicityEnum class
 */
export type ChronicityEnum =
  (typeof ChronicityEnum)[keyof typeof ChronicityEnum];

export const ChronicityEnum = {
  Chronic: "Chronic",
  Acute: "Acute",
  NA: "NA",
} as const;

/**
 * Cogs breakdown by product
 */
export interface CogsBreakdown {
  product_id: number;
  product_name: string;
  expense: number;
  units: number;
  date: string;
}

/**
 * Commission schema
 */
export interface Commission {
  /** UserEntity to create the commission for */
  user_entity_id: number;
  /** Sales advisor type, either 'Primary' or 'Secondary' */
  sales_advisor_type: SalesAdvisorEnum;
  /** Commission rate as a decimal (e.g., 0.1234 for 12.34%) */
  commission_rate: number;
}

/**
 * Component create schema
 */
export interface ComponentCreate {
  /** Identifier for the parent component */
  parent_id: number;
  /** Identifier for the component */
  component_id: number;
  /** Quantity of the component */
  quantity: number;
  /** Whether the component should be hidden from receipts and packing lists. */
  is_hidden?: boolean;
}

/**
 * Component read schema
 */
export interface ComponentRead {
  /** Identifier for the parent component */
  parent_id: number;
  /** Identifier for the component */
  component_id: number;
  /** Quantity of the component */
  quantity: number;
  /** Whether the component should be hidden from receipts and packing lists. */
  is_hidden?: boolean;
  /** Component catalog product information */
  catalog_product: CatalogProductReadWithoutComponents;
}

/**
 * Cost per kit over time data point
 */
export interface CostPerKitOverTime {
  date: string;
  cost_per_kit: number;
}

export type CountryEnum = (typeof CountryEnum)[keyof typeof CountryEnum];

export const CountryEnum = {
  Aruba: "Aruba",
  Afghanistan: "Afghanistan",
  Angola: "Angola",
  Anguilla: "Anguilla",
  Åland_Islands: "Åland Islands",
  Albania: "Albania",
  Andorra: "Andorra",
  United_Arab_Emirates: "United Arab Emirates",
  Argentina: "Argentina",
  Armenia: "Armenia",
  American_Samoa: "American Samoa",
  Antarctica: "Antarctica",
  French_Southern_Territories: "French Southern Territories",
  Antigua_and_Barbuda: "Antigua and Barbuda",
  Australia: "Australia",
  Austria: "Austria",
  Azerbaijan: "Azerbaijan",
  Burundi: "Burundi",
  Belgium: "Belgium",
  Benin: "Benin",
  "Bonaire,_Sint_Eustatius_and_Saba": "Bonaire, Sint Eustatius and Saba",
  Burkina_Faso: "Burkina Faso",
  Bangladesh: "Bangladesh",
  Bulgaria: "Bulgaria",
  Bahrain: "Bahrain",
  Bahamas: "Bahamas",
  Bosnia_and_Herzegovina: "Bosnia and Herzegovina",
  Saint_Barthélemy: "Saint Barthélemy",
  Belarus: "Belarus",
  Belize: "Belize",
  Bermuda: "Bermuda",
  "Bolivia,_Plurinational_State_of": "Bolivia, Plurinational State of",
  Brazil: "Brazil",
  Barbados: "Barbados",
  Brunei_Darussalam: "Brunei Darussalam",
  Bhutan: "Bhutan",
  Bouvet_Island: "Bouvet Island",
  Botswana: "Botswana",
  Central_African_Republic: "Central African Republic",
  Canada: "Canada",
  "Cocos_(Keeling)_Islands": "Cocos (Keeling) Islands",
  Switzerland: "Switzerland",
  Chile: "Chile",
  China: "China",
  "Côte_d'Ivoire": "Côte d'Ivoire",
  Cameroon: "Cameroon",
  "Congo,_The_Democratic_Republic_of_the":
    "Congo, The Democratic Republic of the",
  Congo: "Congo",
  Cook_Islands: "Cook Islands",
  Colombia: "Colombia",
  Comoros: "Comoros",
  Cabo_Verde: "Cabo Verde",
  Costa_Rica: "Costa Rica",
  Cuba: "Cuba",
  Curaçao: "Curaçao",
  Christmas_Island: "Christmas Island",
  Cayman_Islands: "Cayman Islands",
  Cyprus: "Cyprus",
  Czechia: "Czechia",
  Germany: "Germany",
  Djibouti: "Djibouti",
  Dominica: "Dominica",
  Denmark: "Denmark",
  Dominican_Republic: "Dominican Republic",
  Algeria: "Algeria",
  Ecuador: "Ecuador",
  Egypt: "Egypt",
  Eritrea: "Eritrea",
  Western_Sahara: "Western Sahara",
  Spain: "Spain",
  Estonia: "Estonia",
  Ethiopia: "Ethiopia",
  Finland: "Finland",
  Fiji: "Fiji",
  "Falkland_Islands_(Malvinas)": "Falkland Islands (Malvinas)",
  France: "France",
  Faroe_Islands: "Faroe Islands",
  "Micronesia,_Federated_States_of": "Micronesia, Federated States of",
  Gabon: "Gabon",
  United_Kingdom: "United Kingdom",
  Georgia: "Georgia",
  Guernsey: "Guernsey",
  Ghana: "Ghana",
  Gibraltar: "Gibraltar",
  Guinea: "Guinea",
  Guadeloupe: "Guadeloupe",
  Gambia: "Gambia",
  "Guinea-Bissau": "Guinea-Bissau",
  Equatorial_Guinea: "Equatorial Guinea",
  Greece: "Greece",
  Grenada: "Grenada",
  Greenland: "Greenland",
  Guatemala: "Guatemala",
  French_Guiana: "French Guiana",
  Guam: "Guam",
  Guyana: "Guyana",
  Hong_Kong: "Hong Kong",
  Heard_Island_and_McDonald_Islands: "Heard Island and McDonald Islands",
  Honduras: "Honduras",
  Croatia: "Croatia",
  Haiti: "Haiti",
  Hungary: "Hungary",
  Indonesia: "Indonesia",
  Isle_of_Man: "Isle of Man",
  India: "India",
  British_Indian_Ocean_Territory: "British Indian Ocean Territory",
  Ireland: "Ireland",
  "Iran,_Islamic_Republic_of": "Iran, Islamic Republic of",
  Iraq: "Iraq",
  Iceland: "Iceland",
  Israel: "Israel",
  Italy: "Italy",
  Jamaica: "Jamaica",
  Jersey: "Jersey",
  Jordan: "Jordan",
  Japan: "Japan",
  Kazakhstan: "Kazakhstan",
  Kenya: "Kenya",
  Kyrgyzstan: "Kyrgyzstan",
  Cambodia: "Cambodia",
  Kiribati: "Kiribati",
  Saint_Kitts_and_Nevis: "Saint Kitts and Nevis",
  "Korea,_Republic_of": "Korea, Republic of",
  Kuwait: "Kuwait",
  "Lao_People's_Democratic_Republic": "Lao People's Democratic Republic",
  Lebanon: "Lebanon",
  Liberia: "Liberia",
  Libya: "Libya",
  Saint_Lucia: "Saint Lucia",
  Liechtenstein: "Liechtenstein",
  Sri_Lanka: "Sri Lanka",
  Lesotho: "Lesotho",
  Lithuania: "Lithuania",
  Luxembourg: "Luxembourg",
  Latvia: "Latvia",
  Macao: "Macao",
  "Saint_Martin_(French_part)": "Saint Martin (French part)",
  Morocco: "Morocco",
  Monaco: "Monaco",
  "Moldova,_Republic_of": "Moldova, Republic of",
  Madagascar: "Madagascar",
  Maldives: "Maldives",
  Mexico: "Mexico",
  Marshall_Islands: "Marshall Islands",
  North_Macedonia: "North Macedonia",
  Mali: "Mali",
  Malta: "Malta",
  Myanmar: "Myanmar",
  Montenegro: "Montenegro",
  Mongolia: "Mongolia",
  Northern_Mariana_Islands: "Northern Mariana Islands",
  Mozambique: "Mozambique",
  Mauritania: "Mauritania",
  Montserrat: "Montserrat",
  Martinique: "Martinique",
  Mauritius: "Mauritius",
  Malawi: "Malawi",
  Malaysia: "Malaysia",
  Mayotte: "Mayotte",
  Namibia: "Namibia",
  New_Caledonia: "New Caledonia",
  Niger: "Niger",
  Norfolk_Island: "Norfolk Island",
  Nigeria: "Nigeria",
  Nicaragua: "Nicaragua",
  Niue: "Niue",
  Netherlands: "Netherlands",
  Norway: "Norway",
  Nepal: "Nepal",
  Nauru: "Nauru",
  New_Zealand: "New Zealand",
  Oman: "Oman",
  Pakistan: "Pakistan",
  Panama: "Panama",
  Pitcairn: "Pitcairn",
  Peru: "Peru",
  Philippines: "Philippines",
  Palau: "Palau",
  Papua_New_Guinea: "Papua New Guinea",
  Poland: "Poland",
  Puerto_Rico: "Puerto Rico",
  "Korea,_Democratic_People's_Republic_of":
    "Korea, Democratic People's Republic of",
  Portugal: "Portugal",
  Paraguay: "Paraguay",
  "Palestine,_State_of": "Palestine, State of",
  French_Polynesia: "French Polynesia",
  Qatar: "Qatar",
  Réunion: "Réunion",
  Romania: "Romania",
  Russian_Federation: "Russian Federation",
  Rwanda: "Rwanda",
  Saudi_Arabia: "Saudi Arabia",
  Sudan: "Sudan",
  Senegal: "Senegal",
  Singapore: "Singapore",
  South_Georgia_and_the_South_Sandwich_Islands:
    "South Georgia and the South Sandwich Islands",
  "Saint_Helena,_Ascension_and_Tristan_da_Cunha":
    "Saint Helena, Ascension and Tristan da Cunha",
  Svalbard_and_Jan_Mayen: "Svalbard and Jan Mayen",
  Solomon_Islands: "Solomon Islands",
  Sierra_Leone: "Sierra Leone",
  El_Salvador: "El Salvador",
  San_Marino: "San Marino",
  Somalia: "Somalia",
  Saint_Pierre_and_Miquelon: "Saint Pierre and Miquelon",
  Serbia: "Serbia",
  South_Sudan: "South Sudan",
  Sao_Tome_and_Principe: "Sao Tome and Principe",
  Suriname: "Suriname",
  Slovakia: "Slovakia",
  Slovenia: "Slovenia",
  Sweden: "Sweden",
  Eswatini: "Eswatini",
  "Sint_Maarten_(Dutch_part)": "Sint Maarten (Dutch part)",
  Seychelles: "Seychelles",
  Syrian_Arab_Republic: "Syrian Arab Republic",
  Turks_and_Caicos_Islands: "Turks and Caicos Islands",
  Chad: "Chad",
  Togo: "Togo",
  Thailand: "Thailand",
  Tajikistan: "Tajikistan",
  Tokelau: "Tokelau",
  Turkmenistan: "Turkmenistan",
  "Timor-Leste": "Timor-Leste",
  Tonga: "Tonga",
  Trinidad_and_Tobago: "Trinidad and Tobago",
  Tunisia: "Tunisia",
  Türkiye: "Türkiye",
  Tuvalu: "Tuvalu",
  "Taiwan,_Province_of_China": "Taiwan, Province of China",
  "Tanzania,_United_Republic_of": "Tanzania, United Republic of",
  Uganda: "Uganda",
  Ukraine: "Ukraine",
  United_States_Minor_Outlying_Islands: "United States Minor Outlying Islands",
  Uruguay: "Uruguay",
  United_States: "United States",
  Uzbekistan: "Uzbekistan",
  "Holy_See_(Vatican_City_State)": "Holy See (Vatican City State)",
  Saint_Vincent_and_the_Grenadines: "Saint Vincent and the Grenadines",
  "Venezuela,_Bolivarian_Republic_of": "Venezuela, Bolivarian Republic of",
  "Virgin_Islands,_British": "Virgin Islands, British",
  "Virgin_Islands,_US": "Virgin Islands, U.S.",
  Viet_Nam: "Viet Nam",
  Vanuatu: "Vanuatu",
  Wallis_and_Futuna: "Wallis and Futuna",
  Samoa: "Samoa",
  Yemen: "Yemen",
  South_Africa: "South Africa",
  Zambia: "Zambia",
  Zimbabwe: "Zimbabwe",
} as const;

/**
 * DeliveryMethodEnum class
 */
export type DeliveryMethodEnum =
  (typeof DeliveryMethodEnum)[keyof typeof DeliveryMethodEnum];

export const DeliveryMethodEnum = {
  delivery: "delivery",
  pick_up: "pick_up",
} as const;

/**
 * DiscountTypeEnum class

Represents the type of discount applied to a bulk bundle product.
 */
export type DiscountTypeEnum =
  (typeof DiscountTypeEnum)[keyof typeof DiscountTypeEnum];

export const DiscountTypeEnum = {
  Percentage: "Percentage",
  Flat_Rate: "Flat Rate",
} as const;

/**
 * DisposalMethodEnum class

Represents the method used to dispose of quarantined products.
 */
export type DisposalMethodEnum =
  (typeof DisposalMethodEnum)[keyof typeof DisposalMethodEnum];

export const DisposalMethodEnum = {
  Reverse_Distributor_Pickup: "Reverse Distributor Pickup",
  Shipped_to_Reverse_Distributor: "Shipped to Reverse Distributor",
  "On-site_Destruction": "On-site Destruction",
  Donation: "Donation",
  Other: "Other",
} as const;

export type DisposerCreateStAddress2 = string | null;

export type DisposerCreateResellerLicenseNumber = string | null;

export type DisposerCreateEmail = string | null;

export type DisposerCreatePhone = string | null;

/**
 * Disposer create schema
 */
export interface DisposerCreate {
  st_address_1: string;
  st_address_2?: DisposerCreateStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  entity_id: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  reseller_license_number?: DisposerCreateResellerLicenseNumber;
  email?: DisposerCreateEmail;
  phone?: DisposerCreatePhone;
}

export type DisposerReadStAddress2 = string | null;

export type DisposerReadResellerLicenseNumber = string | null;

export type DisposerReadEmail = string | null;

export type DisposerReadPhone = string | null;

/**
 * Disposer read schema
 */
export interface DisposerRead {
  st_address_1: string;
  st_address_2?: DisposerReadStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  entity_id: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  reseller_license_number?: DisposerReadResellerLicenseNumber;
  email?: DisposerReadEmail;
  phone?: DisposerReadPhone;
  disposer_id: number;
}

/**
 * Phone number of the user
 */
export type DoctorReadPhone = string | null;

/**
 * Type of phone number
 */
export type DoctorReadPhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type DoctorReadTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type DoctorReadTitle = string | null;

/**
 * NPI number of the user
 */
export type DoctorReadNpiNumber = string | null;

/**
 * State license number of the user
 */
export type DoctorReadStateLicenseNumber = string | null;

/**
 * Allows for Firebase Cloud Messaging to send push notifications
 */
export type DoctorReadFcmRegistrationToken = string | null;

/**
 * Doctor read schema
 */
export interface DoctorRead {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  /** Email address of the user */
  email: string;
  /** Phone number of the user */
  phone?: DoctorReadPhone;
  /** Type of phone number */
  phone_type?: DoctorReadPhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: DoctorReadTextingUnsubscribedAt;
  role: "doctor";
  /** Title of the user, e.g., MD, RN, PA */
  title?: DoctorReadTitle;
  /** NPI number of the user */
  npi_number?: DoctorReadNpiNumber;
  /** State license number of the user */
  state_license_number?: DoctorReadStateLicenseNumber;
  user_id: string;
  /** Allows for Firebase Cloud Messaging to send push notifications */
  fcm_registration_token?: DoctorReadFcmRegistrationToken;
  /** Whether the user has at least one MFA factor enrolled */
  mfa_enabled?: boolean;
}

/**
 * Finance breakdown by doctor and product
 */
export interface DoctorSales {
  doctor_id: string;
  first_name: string;
  last_name: string;
  product_id: number;
  product_name: string;
  quantity: number;
  revenue: number;
  cogs: number;
  other_expenses: number;
  gross_profit: number;
}

/**
 * DosageFormEnum class
 */
export type DosageFormEnum =
  (typeof DosageFormEnum)[keyof typeof DosageFormEnum];

export const DosageFormEnum = {
  Suspension: "Suspension",
  Emulsion: "Emulsion",
  Gel: "Gel",
  Ointment: "Ointment",
  Capsule: "Capsule",
  Tablet: "Tablet",
  Solution: "Solution",
  Softgel: "Softgel",
  Injectable: "Injectable",
  Box: "Box",
  Bag: "Bag",
  Cup: "Cup",
} as const;

export type EntityStAddress2 = string | null;

/**
 * Email address
 */
export type EntityEmail = string | null;

/**
 * Firebase image URL of the entity's logo
 */
export type EntityLogo = string | null;

/**
 * Twilio phone number used to send text messages
 */
export type EntityTwilioPhone = string | null;

/**
 * Fax number
 */
export type EntityFax = string | null;

/**
 * Entity schema
 */
export interface Entity {
  st_address_1: string;
  st_address_2?: EntityStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  /**
   * Name of the entity
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** Email address */
  email?: EntityEmail;
  /** Firebase image URL of the entity's logo */
  logo?: EntityLogo;
  /** Type of the entity (practice, pharmacy, or fulfiller) */
  entity_type: EntityTypeEnum;
  /** Twilio phone number used to send text messages */
  twilio_phone?: EntityTwilioPhone;
  /** Whether 1-Click Outcomes campaigns are enabled (Practice entities only) */
  outcomes_enabled?: boolean;
  /** Phone number */
  phone: string;
  /**
   * National Provider Identifier (NPI)
   * @minLength 10
   * @maxLength 10
   */
  npi_number: string;
  /** Payment processor for the entity (usaepay or stripe) */
  payment_processor: PaymentProcessorEnum;
  /** Fax number */
  fax?: EntityFax;
  entity_id: number;
  /** Whether every user of the entity is required to enroll in MFA */
  require_mfa?: boolean;
}

/**
 * EntityContact schema
 */
export interface EntityContact {
  /** Email address of the entity contact */
  email: string;
  /** Service the contact should be contacted for */
  contact_service: ServiceEnum;
  entity_id: number;
  entity_contact_id: number;
}

/**
 * EntityContact create schema
 */
export interface EntityContactCreate {
  /** Email address of the entity contact */
  email: string;
  /** Service the contact should be contacted for */
  contact_service: ServiceEnum;
}

export type EntityCreateStAddress2 = string | null;

/**
 * Email address
 */
export type EntityCreateEmail = string | null;

/**
 * Firebase image URL of the entity's logo
 */
export type EntityCreateLogo = string | null;

/**
 * Twilio phone number used to send text messages
 */
export type EntityCreateTwilioPhone = string | null;

/**
 * Fax number
 */
export type EntityCreateFax = string | null;

/**
 * Reseller license number
 */
export type EntityCreateResellerLicenseNumber = string | null;

/**
 * Organization ID to which the entity belongs
 */
export type EntityCreateOrganizationId = number | null;

/**
 * Entity create schema
 */
export interface EntityCreate {
  st_address_1: string;
  st_address_2?: EntityCreateStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  /**
   * Name of the entity
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** Email address */
  email?: EntityCreateEmail;
  /** Firebase image URL of the entity's logo */
  logo?: EntityCreateLogo;
  /** Type of the entity (practice, pharmacy, or fulfiller) */
  entity_type: EntityTypeEnum;
  /** Twilio phone number used to send text messages */
  twilio_phone?: EntityCreateTwilioPhone;
  /** Whether 1-Click Outcomes campaigns are enabled (Practice entities only) */
  outcomes_enabled?: boolean;
  /** Phone number */
  phone: string;
  /**
   * National Provider Identifier (NPI)
   * @minLength 10
   * @maxLength 10
   */
  npi_number: string;
  /** Payment processor for the entity (usaepay or stripe) */
  payment_processor: PaymentProcessorEnum;
  /** Fax number */
  fax?: EntityCreateFax;
  /** Reseller license number */
  reseller_license_number?: EntityCreateResellerLicenseNumber;
  /**
   * How many days the entity has to pay invoices, i.e. Net 30
   * @minimum 0
   */
  payment_due_days: number;
  /**
   * Merchant processing fee percentage
   * @minimum 0
   */
  processing_fee_rate: number;
  /** Organization ID to which the entity belongs */
  organization_id?: EntityCreateOrganizationId;
  /** Whether receipts show itemized RX pricing (true) or bundled kit price (false) */
  show_itemized_rx_pricing?: boolean;
}

/**
 * EntityDocument create schema
 */
export interface EntityDocumentCreate {
  /** Firebase Storage URL of the uploaded file */
  file_url: string;
  /**
   * User-provided display name
   * @minLength 1
   * @maxLength 255
   */
  display_name: string;
  /**
   * File extension (e.g. .pdf, .docx)
   * @minLength 1
   * @maxLength 20
   */
  file_extension: string;
}

/**
 * EntityDocument read schema
 */
export interface EntityDocumentRead {
  entity_document_id: number;
  entity_id: number;
  display_name: string;
  file_extension: string;
  created_at: string;
  updated_by: UserName;
  signed_url: string;
}

/**
 * EntityFulfillerAccount create schema
 */
export interface EntityFulfillerAccountCreate {
  /** The practice that holds the account number. */
  entity_id: number;
  /** The fulfiller the account number is with. */
  fulfiller_id: number;
  /**
   * The account number used when ordering from the fulfiller.
   * @minLength 1
   * @maxLength 100
   */
  account_number: string;
}

/**
 * EntityFulfillerAccount read schema with entity and fulfiller names
 */
export interface EntityFulfillerAccountRead {
  /** The practice that holds the account number. */
  entity_id: number;
  /** The fulfiller the account number is with. */
  fulfiller_id: number;
  /**
   * The account number used when ordering from the fulfiller.
   * @minLength 1
   * @maxLength 100
   */
  account_number: string;
  entity_fulfiller_account_id: number;
  /** The practice that holds the account number. */
  entity: EntityName;
  /** The fulfiller the account number is with. */
  fulfiller: EntityName;
}

/**
 * EntityFulfillerAccount update schema
 */
export interface EntityFulfillerAccountUpdate {
  /**
   * The account number used when ordering from the fulfiller.
   * @minLength 1
   * @maxLength 100
   */
  account_number: string;
}

export type EntityManyReadStAddress2 = string | null;

/**
 * Email address
 */
export type EntityManyReadEmail = string | null;

/**
 * Firebase image URL of the entity's logo
 */
export type EntityManyReadLogo = string | null;

/**
 * Twilio phone number used to send text messages
 */
export type EntityManyReadTwilioPhone = string | null;

/**
 * Fax number
 */
export type EntityManyReadFax = string | null;

/**
 * Entity many read schema
 */
export interface EntityManyRead {
  st_address_1: string;
  st_address_2?: EntityManyReadStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  /**
   * Name of the entity
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** Email address */
  email?: EntityManyReadEmail;
  /** Firebase image URL of the entity's logo */
  logo?: EntityManyReadLogo;
  /** Type of the entity (practice, pharmacy, or fulfiller) */
  entity_type: EntityTypeEnum;
  /** Twilio phone number used to send text messages */
  twilio_phone?: EntityManyReadTwilioPhone;
  /** Whether 1-Click Outcomes campaigns are enabled (Practice entities only) */
  outcomes_enabled?: boolean;
  /** Phone number */
  phone: string;
  /**
   * National Provider Identifier (NPI)
   * @minLength 10
   * @maxLength 10
   */
  npi_number: string;
  /** Payment processor for the entity (usaepay or stripe) */
  payment_processor: PaymentProcessorEnum;
  /** Fax number */
  fax?: EntityManyReadFax;
  entity_id: number;
  /** Whether every user of the entity is required to enroll in MFA */
  require_mfa?: boolean;
  /** List of services the entity has access to */
  services: Service[];
}

/**
 * EntityName schema

This schema can be used to read entity names for lookup tables
 */
export interface EntityName {
  entity_id: number;
  name: string;
}

/**
 * EntityName schema

Includes state_provience
 */
export interface EntityNameWithStateProvince {
  entity_id: number;
  name: string;
  state_province: string;
}

export type EntityPaymentStAddress2 = string | null;

/**
 * EntityPayment schema
 */
export interface EntityPayment {
  st_address_1: string;
  st_address_2?: EntityPaymentStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  entity_id: number;
  /** @minLength 1 */
  cardholder_name: string;
  is_primary?: boolean;
  exp: string;
  token: string;
  masked_number: string;
  brand: string;
}

export type EntityPaymentCreateStAddress2 = string | null;

/**
 * EntityPaymentCreate schema

This is for the API.
 */
export interface EntityPaymentCreate {
  st_address_1: string;
  st_address_2?: EntityPaymentCreateStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  entity_id: number;
  /** @minLength 1 */
  cardholder_name: string;
  is_primary?: boolean;
  exp: string;
  /**
   * @minLength 12
   * @maxLength 19
   */
  number: string;
  /**
   * @minLength 3
   * @maxLength 4
   */
  cvv: string;
}

export type EntityPaymentReadStAddress2 = string | null;

/**
 * EntityPayment read schema
 */
export interface EntityPaymentRead {
  st_address_1: string;
  st_address_2?: EntityPaymentReadStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  entity_id: number;
  /** @minLength 1 */
  cardholder_name: string;
  is_primary?: boolean;
  exp: string;
  token: string;
  masked_number: string;
  brand: string;
  entity_payment_id: number;
}

/**
 * Minimal payment method info exposed on invoices — never includes the card token.
 */
export interface EntityPaymentSummary {
  brand: string;
  masked_number: string;
}

export type EntityPaymentUnchargedInvoiceBulkInvoiceSqid = string | null;

export type EntityPaymentUnchargedInvoiceDueAt = string | null;

/**
 * Uncharged bulk invoice that references a payment method.

Used to warn before deleting a card that these invoices will be
moved to Other payment.
 */
export interface EntityPaymentUnchargedInvoice {
  bulk_invoice_id: string;
  bulk_invoice_sqid: EntityPaymentUnchargedInvoiceBulkInvoiceSqid;
  bulk_order_ids: string[];
  total: number;
  due_at: EntityPaymentUnchargedInvoiceDueAt;
  created_at: string;
}

export type EntityReadStAddress2 = string | null;

/**
 * Email address
 */
export type EntityReadEmail = string | null;

/**
 * Firebase image URL of the entity's logo
 */
export type EntityReadLogo = string | null;

/**
 * Twilio phone number used to send text messages
 */
export type EntityReadTwilioPhone = string | null;

/**
 * Fax number
 */
export type EntityReadFax = string | null;

/**
 * Reseller license number
 */
export type EntityReadResellerLicenseNumber = string | null;

/**
 * Organization ID to which the entity belongs
 */
export type EntityReadOrganizationId = number | null;

/**
 * Stripe connected account ID
 */
export type EntityReadStripeAccountId = string | null;

/**
 * Balance floor (in cents) kept in reserve during the monthly payout job.
 */
export type EntityReadBalanceMinimum = number | null;

/**
 * Entity read schema
 */
export interface EntityRead {
  st_address_1: string;
  st_address_2?: EntityReadStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  /**
   * Name of the entity
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** Email address */
  email?: EntityReadEmail;
  /** Firebase image URL of the entity's logo */
  logo?: EntityReadLogo;
  /** Type of the entity (practice, pharmacy, or fulfiller) */
  entity_type: EntityTypeEnum;
  /** Twilio phone number used to send text messages */
  twilio_phone?: EntityReadTwilioPhone;
  /** Whether 1-Click Outcomes campaigns are enabled (Practice entities only) */
  outcomes_enabled?: boolean;
  /** Phone number */
  phone: string;
  /**
   * National Provider Identifier (NPI)
   * @minLength 10
   * @maxLength 10
   */
  npi_number: string;
  /** Payment processor for the entity (usaepay or stripe) */
  payment_processor: PaymentProcessorEnum;
  /** Fax number */
  fax?: EntityReadFax;
  entity_id: number;
  /** Whether every user of the entity is required to enroll in MFA */
  require_mfa?: boolean;
  /** List of services the entity has access to */
  services: Service[];
  /** Reseller license number */
  reseller_license_number?: EntityReadResellerLicenseNumber;
  /**
   * How many days the entity has to pay invoices, i.e. Net 30
   * @minimum 0
   */
  payment_due_days: number;
  /**
   * Merchant processing fee percentage
   * @minimum 0
   */
  processing_fee_rate: number;
  /** Organization ID to which the entity belongs */
  organization_id?: EntityReadOrganizationId;
  /** Whether receipts show itemized RX pricing (true) or bundled kit price (false) */
  show_itemized_rx_pricing?: boolean;
  /** Stripe connected account ID */
  stripe_account_id?: EntityReadStripeAccountId;
  /** Balance floor (in cents) kept in reserve during the monthly payout job. */
  balance_minimum?: EntityReadBalanceMinimum;
  /** List of contacts the entity has */
  entity_contacts: EntityContact[];
  /** List of practices that can see the entity */
  seen_by_entities: SeenByEntities[];
  /** List of fulfillers the entity can see */
  can_see_entities: CanSeeEntities[];
  /** List of credit card payment methods for the entity */
  credit_cards: EntityPaymentRead[];
}

/**
 * EntityTypeEnum class
 */
export type EntityTypeEnum =
  (typeof EntityTypeEnum)[keyof typeof EntityTypeEnum];

export const EntityTypeEnum = {
  Practice: "Practice",
  Pharmacy: "Pharmacy",
  Fulfiller: "Fulfiller",
} as const;

/**
 * EntityVisibility create schema
 */
export interface EntityVisibilityCreate {
  can_see_entity_ids: number[];
  seen_by_entity_ids: number[];
}

/**
 * FileTypeEnum class

Represents the type of file being uploaded
 */
export type FileTypeEnum = (typeof FileTypeEnum)[keyof typeof FileTypeEnum];

export const FileTypeEnum = {
  Invoice: "Invoice",
  Image: "Image",
  Document: "Document",
} as const;

/**
 * A user's natural-language request plus the filters available to set.
 */
export interface FilterAssistantRequest {
  utterance: string;
  fields: FilterFieldSpec[];
  today: string;
}

export type FilterAssistantResponseChanges = { [key: string]: unknown };

/**
 * Only the filters the user asked to change appear in ``changes``.

Values are keyed by field name: a date_range is ``{"start", "end"}``, an
enum is its string value, a boolean is a bool, and a lookup is a list of
resolved id strings (a numeric id like "102" or a sqid). Each consumer
coerces the strings to the type its query param expects.
 */
export interface FilterAssistantResponse {
  understood: boolean;
  explanation: string;
  changes: FilterAssistantResponseChanges;
}

export type FilterFieldSpecKind =
  (typeof FilterFieldSpecKind)[keyof typeof FilterFieldSpecKind];

export const FilterFieldSpecKind = {
  date_range: "date_range",
  enum: "enum",
  boolean: "boolean",
  lookup: "lookup",
  multi_enum: "multi_enum",
} as const;

export type FilterFieldSpecOptions = string[] | null;

export type FilterFieldSpecCurrentValue = string | null;

/**
 * One filter a dashboard exposes to the assistant.
 */
export interface FilterFieldSpec {
  name: string;
  kind: FilterFieldSpecKind;
  description: string;
  options?: FilterFieldSpecOptions;
  current_value?: FilterFieldSpecCurrentValue;
}

/**
 * Finance summary metrics
 */
export interface FinanceSummary {
  revenue: number;
  expense: number;
  profit: number;
  revenue_per_month: number;
  revenue_per_patient: number;
}

/**
 * Request body for the public forgot-password endpoint.
 */
export interface ForgotPasswordRequest {
  email: string;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

/**
 * HistoryEventEnum class
 */
export type HistoryEventEnum =
  (typeof HistoryEventEnum)[keyof typeof HistoryEventEnum];

export const HistoryEventEnum = {
  Patient_Detail: "Patient Detail",
  Order_Status: "Order Status",
  Suborder_Status: "Suborder Status",
  Notes: "Notes",
  Phone_Call: "Phone Call",
} as const;

export type IncomingSuborderProductReadBulkOrderSqid = string | null;

export type IncomingSuborderProductReadLotNumber = string | null;

export type IncomingSuborderProductReadExpirationDate = string | null;

export type IncomingSuborderProductReadBatchId = number | null;

/**
 * A fulfilled-but-not-delivered bulk suborder product for an inventory product
 */
export interface IncomingSuborderProductRead {
  bulk_suborder_product_id: number;
  bulk_suborder_id: number;
  bulk_order_sqid: IncomingSuborderProductReadBulkOrderSqid;
  ordered_at: string;
  quantity: number;
  lot_number?: IncomingSuborderProductReadLotNumber;
  expiration_date?: IncomingSuborderProductReadExpirationDate;
  batch_id?: IncomingSuborderProductReadBatchId;
}

export type IncomingSuborderProductUpdateLotNumber = string | null;

export type IncomingSuborderProductUpdateExpirationDate = string | null;

/**
 * Lot/expiration overrides for a bulk suborder product at arrival time
 */
export interface IncomingSuborderProductUpdate {
  bulk_suborder_product_id: number;
  lot_number?: IncomingSuborderProductUpdateLotNumber;
  expiration_date?: IncomingSuborderProductUpdateExpirationDate;
}

/**
 * Request body for initiating a phone call.
 */
export interface InitiatePhoneCall {
  /** Phone number to call */
  phone_number: string;
  /** Entity ID to call from */
  entity_id: number;
}

/**
 * Public instructions document response.
 */
export interface InstructionsDocument {
  url: string;
  is_html: boolean;
}

export type InventoryReorderLevel = number | null;

/**
 * Inventory schema
 */
export interface Inventory {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  product_id: number;
  quantity_on_hand?: number;
  reorder_level?: InventoryReorderLevel;
  inventory_id: string;
}

export type InventoryBatchLogCreateNote = string | null;

export type InventoryBatchLogCreateSuborderProductId = number | null;

export type InventoryBatchLogCreateDisposalMethod = DisposalMethodEnum | null;

export type InventoryBatchLogCreateDisposerId = number | null;

/**
 * InventoryBatchLog create schema for manual adjustments
 */
export interface InventoryBatchLogCreate {
  inventory_batch_id: string;
  log_type: InventoryBatchLogTypeEnum;
  quantity: number;
  quarantined_changed?: number;
  note?: InventoryBatchLogCreateNote;
  suborder_product_id?: InventoryBatchLogCreateSuborderProductId;
  disposal_method?: InventoryBatchLogCreateDisposalMethod;
  disposer_id?: InventoryBatchLogCreateDisposerId;
}

export type InventoryBatchLogReadInventoryBatchId = string | null;

export type InventoryBatchLogReadNote = string | null;

export type InventoryBatchLogReadSuborderProductId = number | null;

export type InventoryBatchLogReadDisposalMethod = DisposalMethodEnum | null;

export type InventoryBatchLogReadDisposerId = number | null;

export type InventoryBatchLogReadSuborderProduct = SuborderProductRef | null;

export type InventoryBatchLogReadInventoryId = string | null;

export type InventoryBatchLogReadLotNumber = string | null;

export type InventoryBatchLogReadPatientName = string | null;

export type InventoryBatchLogReadDoctorName = string | null;

export type InventoryBatchLogReadDoctorNpi = string | null;

export type InventoryBatchLogReadRxNumber = string | null;

export type InventoryBatchLogReadPrescribedAt = string | null;

export type InventoryBatchLogReadDisposer = DisposerRead | null;

/**
 * InventoryBatchLog read schema
 */
export interface InventoryBatchLogRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  inventory_batch_id?: InventoryBatchLogReadInventoryBatchId;
  log_type: InventoryBatchLogTypeEnum;
  quantity: number;
  quarantined_changed?: number;
  note?: InventoryBatchLogReadNote;
  suborder_product_id?: InventoryBatchLogReadSuborderProductId;
  disposal_method?: InventoryBatchLogReadDisposalMethod;
  disposer_id?: InventoryBatchLogReadDisposerId;
  inventory_batch_log_id: number;
  suborder_product?: InventoryBatchLogReadSuborderProduct;
  product_name: string;
  practice_name: string;
  inventory_id: InventoryBatchLogReadInventoryId;
  lot_number: InventoryBatchLogReadLotNumber;
  patient_name?: InventoryBatchLogReadPatientName;
  doctor_name?: InventoryBatchLogReadDoctorName;
  doctor_npi?: InventoryBatchLogReadDoctorNpi;
  rx_number?: InventoryBatchLogReadRxNumber;
  prescribed_at?: InventoryBatchLogReadPrescribedAt;
  disposer?: InventoryBatchLogReadDisposer;
}

/**
 * Minimal suborder schema for inventory batch logs
 */
export interface InventoryBatchLogSuborder {
  suborder_id: string;
  order_id: string;
}

/**
 * InventoryBatchLogTypeEnum class

Represents the type of inventory batch log entry.
 */
export type InventoryBatchLogTypeEnum =
  (typeof InventoryBatchLogTypeEnum)[keyof typeof InventoryBatchLogTypeEnum];

export const InventoryBatchLogTypeEnum = {
  Received: "Received",
  Dispensed: "Dispensed",
  Adjustment: "Adjustment",
  Quarantine: "Quarantine",
  Disposed: "Disposed",
  Unaccounted_Dispense: "Unaccounted Dispense",
} as const;

export type InventoryBatchMinimalLotNumber = string | null;

export type InventoryBatchMinimalExpirationDate = string | null;

/**
 * Minimal InventoryBatch schema for nested display
 */
export interface InventoryBatchMinimal {
  inventory_batch_id: string;
  lot_number?: InventoryBatchMinimalLotNumber;
  expiration_date?: InventoryBatchMinimalExpirationDate;
  quantity_on_hand: number;
}

export type InventoryBatchReadNote = string | null;

export type InventoryBatchReadLotNumber = string | null;

export type InventoryBatchReadExpirationDate = string | null;

export type InventoryBatchReadBulkSuborderProductId = number | null;

export type InventoryBatchReadBatchId = number | null;

export type InventoryBatchReadReceivedAt = string | null;

/**
 * InventoryBatch read schema - used when fetching inventory batches directly
 */
export interface InventoryBatchRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  inventory_id: string;
  /** @minimum 1 */
  order_quantity: number;
  /** @minimum 0 */
  unit_cost: number;
  note?: InventoryBatchReadNote;
  lot_number?: InventoryBatchReadLotNumber;
  expiration_date?: InventoryBatchReadExpirationDate;
  bulk_suborder_product_id?: InventoryBatchReadBulkSuborderProductId;
  batch_id?: InventoryBatchReadBatchId;
  /** @minimum 0 */
  quantity_on_hand: number;
  /** @minimum 0 */
  quantity_quarantined: number;
  /** @minimum 0 */
  total_cost: number;
  received_at?: InventoryBatchReadReceivedAt;
  inventory_batch_id: string;
  inventory_batch_logs: InventoryBatchLogRead[];
  inventory: InventoryWithProduct;
}

export type InventoryBatchUpdateLotNumber = string | null;

export type InventoryBatchUpdateExpirationDate = string | null;

/**
 * Schema for updating editable inventory batch fields
 */
export interface InventoryBatchUpdate {
  lot_number?: InventoryBatchUpdateLotNumber;
  expiration_date?: InventoryBatchUpdateExpirationDate;
}

export type InventoryBatchWithLogsNote = string | null;

export type InventoryBatchWithLogsLotNumber = string | null;

export type InventoryBatchWithLogsExpirationDate = string | null;

export type InventoryBatchWithLogsBulkSuborderProductId = number | null;

export type InventoryBatchWithLogsBatchId = number | null;

export type InventoryBatchWithLogsReceivedAt = string | null;

/**
 * InventoryBatch with logs schema - used when nested in InventoryRead
 */
export interface InventoryBatchWithLogs {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  inventory_id: string;
  /** @minimum 1 */
  order_quantity: number;
  /** @minimum 0 */
  unit_cost: number;
  note?: InventoryBatchWithLogsNote;
  lot_number?: InventoryBatchWithLogsLotNumber;
  expiration_date?: InventoryBatchWithLogsExpirationDate;
  bulk_suborder_product_id?: InventoryBatchWithLogsBulkSuborderProductId;
  batch_id?: InventoryBatchWithLogsBatchId;
  /** @minimum 0 */
  quantity_on_hand: number;
  /** @minimum 0 */
  quantity_quarantined: number;
  /** @minimum 0 */
  total_cost: number;
  received_at?: InventoryBatchWithLogsReceivedAt;
  inventory_batch_id: string;
  inventory_batch_logs: InventoryBatchLogRead[];
}

export type InventoryCreateReorderLevel = number | null;

/**
 * Schema for creating inventory from an existing product
 */
export interface InventoryCreate {
  product_id: number;
  reorder_level?: InventoryCreateReorderLevel;
}

export type InventoryLotSummaryReadLotNumber = string | null;

export type InventoryLotSummaryReadEarliestReceivedAt = string | null;

export type InventoryLotSummaryReadEarliestExpirationDate = string | null;

/**
 * Aggregated lot-level summary for the inventory details page lot table
 */
export interface InventoryLotSummaryRead {
  inventory_id: string;
  lot_number: InventoryLotSummaryReadLotNumber;
  order_quantity: number;
  quantity_on_hand: number;
  avg_unit_cost: number;
  total_cost: number;
  earliest_received_at: InventoryLotSummaryReadEarliestReceivedAt;
  earliest_expiration_date: InventoryLotSummaryReadEarliestExpirationDate;
}

export type InventoryReadReorderLevel = number | null;

/**
 * Inventory read schema with inventory batches
 */
export interface InventoryRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  product_id: number;
  quantity_on_hand?: number;
  reorder_level?: InventoryReadReorderLevel;
  inventory_id: string;
  product: ProductRead;
  inventory_batches: InventoryBatchWithLogs[];
  /** Quantity of ordered products that have not yet been delivered. */
  incoming_quantity: number;
}

export type InventoryUpdateReorderLevel = number | null;

/**
 * Schema for updating inventory settings
 */
export interface InventoryUpdate {
  reorder_level?: InventoryUpdateReorderLevel;
}

export type InventoryWithIncomingQuantityReorderLevel = number | null;

/**
 * Inventory read schema for list views
 */
export interface InventoryWithIncomingQuantity {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  product_id: number;
  quantity_on_hand?: number;
  reorder_level?: InventoryWithIncomingQuantityReorderLevel;
  inventory_id: string;
  product: ProductRead;
  /** Quantity of ordered products that have not yet been delivered. */
  incoming_quantity: number;
}

export type InventoryWithProductReorderLevel = number | null;

/**
 * Inventory with product schema (includes entity and catalog_product via Product)
 */
export interface InventoryWithProduct {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  product_id: number;
  quantity_on_hand?: number;
  reorder_level?: InventoryWithProductReorderLevel;
  inventory_id: string;
  product: ProductRead;
}

/**
 * InvoiceTypeEnum class

Distinguishes practice-to-manufacturer invoices from Legrande's wholesale
commission invoices.
 */
export type InvoiceTypeEnum =
  (typeof InvoiceTypeEnum)[keyof typeof InvoiceTypeEnum];

export const InvoiceTypeEnum = {
  STANDARD: "STANDARD",
  WHOLESALE: "WHOLESALE",
} as const;

export type JobInfoKey = (typeof JobInfoKey)[keyof typeof JobInfoKey];

export const JobInfoKey = {
  auto_charge_bulk_invoices: "auto_charge_bulk_invoices",
  create_bulk_reorders: "create_bulk_reorders",
  confirm_bulk_reorders: "confirm_bulk_reorders",
  create_low_stock_draft_orders: "create_low_stock_draft_orders",
  notify_advocates_of_stale_low_stock_drafts:
    "notify_advocates_of_stale_low_stock_drafts",
  send_daily_text_reminders: "send_daily_text_reminders",
  send_weekly_text_reminders: "send_weekly_text_reminders",
  send_stale_inventory_notifications: "send_stale_inventory_notifications",
  send_warehouse_reorder_alerts: "send_warehouse_reorder_alerts",
  send_predicted_supply_discrepancy_notifications:
    "send_predicted_supply_discrepancy_notifications",
  audit_warehouse_quantities: "audit_warehouse_quantities",
  send_weekly_wholesale_price_notifications:
    "send_weekly_wholesale_price_notifications",
  send_legrande_bulk_order_report: "send_legrande_bulk_order_report",
  delete_old_call_recordings: "delete_old_call_recordings",
  cleanup_stuck_calls: "cleanup_stuck_calls",
  send_practice_reports: "send_practice_reports",
  send_operational_report: "send_operational_report",
  create_refill_tasks: "create_refill_tasks",
  send_outcome_questions: "send_outcome_questions",
  payout_entities: "payout_entities",
  generate_imprimis_med_wholesale_invoices:
    "generate_imprimis_med_wholesale_invoices",
  generate_pine_wholesale_invoices: "generate_pine_wholesale_invoices",
  generate_imprimis_kit_wholesale_invoices:
    "generate_imprimis_kit_wholesale_invoices",
  generate_pq_wholesale_invoices: "generate_pq_wholesale_invoices",
} as const;

export type JobInfoCategory =
  (typeof JobInfoCategory)[keyof typeof JobInfoCategory];

export const JobInfoCategory = {
  report: "report",
  notification: "notification",
  operation: "operation",
  payment: "payment",
} as const;

/**
 * Metadata for a job listed on the reports page.
 */
export interface JobInfo {
  key: JobInfoKey;
  category: JobInfoCategory;
}

export type JobResultKey = (typeof JobResultKey)[keyof typeof JobResultKey];

export const JobResultKey = {
  auto_charge_bulk_invoices: "auto_charge_bulk_invoices",
  create_bulk_reorders: "create_bulk_reorders",
  confirm_bulk_reorders: "confirm_bulk_reorders",
  create_low_stock_draft_orders: "create_low_stock_draft_orders",
  notify_advocates_of_stale_low_stock_drafts:
    "notify_advocates_of_stale_low_stock_drafts",
  send_daily_text_reminders: "send_daily_text_reminders",
  send_weekly_text_reminders: "send_weekly_text_reminders",
  send_stale_inventory_notifications: "send_stale_inventory_notifications",
  send_warehouse_reorder_alerts: "send_warehouse_reorder_alerts",
  send_predicted_supply_discrepancy_notifications:
    "send_predicted_supply_discrepancy_notifications",
  audit_warehouse_quantities: "audit_warehouse_quantities",
  send_weekly_wholesale_price_notifications:
    "send_weekly_wholesale_price_notifications",
  send_legrande_bulk_order_report: "send_legrande_bulk_order_report",
  delete_old_call_recordings: "delete_old_call_recordings",
  cleanup_stuck_calls: "cleanup_stuck_calls",
  send_practice_reports: "send_practice_reports",
  send_operational_report: "send_operational_report",
  create_refill_tasks: "create_refill_tasks",
  send_outcome_questions: "send_outcome_questions",
  payout_entities: "payout_entities",
  generate_imprimis_med_wholesale_invoices:
    "generate_imprimis_med_wholesale_invoices",
  generate_pine_wholesale_invoices: "generate_pine_wholesale_invoices",
  generate_imprimis_kit_wholesale_invoices:
    "generate_imprimis_kit_wholesale_invoices",
  generate_pq_wholesale_invoices: "generate_pq_wholesale_invoices",
} as const;

/**
 * Result of a triggered job
 */
export interface JobResult {
  key: JobResultKey;
  success: boolean;
}

/**
 * Kit by log type data point
 */
export interface KitByLogType {
  log_type: string;
  kit_count: number;
}

/**
 * Kit by practice data point
 */
export interface KitByPractice {
  practice_name: string;
  kit_count: number;
}

/**
 * Kits shipped, manufactured, and prebuilt per month schema
 */
export interface KitsPerMonth {
  date: string;
  kits_shipped: number;
  kits_manufactured: number;
  kits_prebuild: number;
}

/**
 * Unique identifier for the ShipEngine label
 */
export type LabelShipengineLabelId = string | null;

/**
 * Unique identifier for the shipment
 */
export type LabelShipmentId = string | null;

/**
 * Cost of the shipment
 */
export type LabelShipmentCost = number | null;

/**
 * Service code for the shipment (e.g., Ground, 2-Day Air)
 */
export type LabelServiceCode =
  (typeof LabelServiceCode)[keyof typeof LabelServiceCode];

export const LabelServiceCode = {
  usps_priority_mail: "usps_priority_mail",
  usps_ground_advantage: "usps_ground_advantage",
  usps_priority_mail_express: "usps_priority_mail_express",
  fedex_ground: "fedex_ground",
  fedex_home_delivery: "fedex_home_delivery",
  fedex_express_saver: "fedex_express_saver",
  fedex_2day: "fedex_2day",
  fedex_2day_am: "fedex_2day_am",
  fedex_standard_overnight: "fedex_standard_overnight",
  fedex_priority_overnight: "fedex_priority_overnight",
  ups_ground: "ups_ground",
  ups_3_day_select: "ups_3_day_select",
  ups_2nd_day_air: "ups_2nd_day_air",
  ups_2nd_day_air_am: "ups_2nd_day_air_am",
  ups_next_day_air_saver: "ups_next_day_air_saver",
  ups_next_day_air: "ups_next_day_air",
  ups_next_day_air_early_am: "ups_next_day_air_early_am",
} as const;

/**
 * ShipEngine carrier account ID
 */
export type LabelShipengineCarrierId = string | null;

/**
 * URL to download the shipping label
 */
export type LabelLabelDownloadUrl = string | null;

/**
 * Ship date of the shipment
 */
export type LabelShipDate = string | null;

/**
 * Estimated delivery date
 */
export type LabelEstimatedDeliveryDate = string | null;

/**
 * Actual delivery date
 */
export type LabelActualDeliveryDate = string | null;

/**
 * Label schema
 */
export interface Label {
  /** Unique identifier for the ShipEngine label */
  shipengine_label_id?: LabelShipengineLabelId;
  /** Unique identifier for the shipment */
  shipment_id?: LabelShipmentId;
  /** Cost of the shipment */
  shipment_cost?: LabelShipmentCost;
  /**
   * Tracking number for the shipment
   * @minLength 5
   */
  tracking_number: string;
  /** Carrier for the shipment (e.g., Fedex, UPS) */
  carrier_code: CarrierCodesEnum;
  /** Service code for the shipment (e.g., Ground, 2-Day Air) */
  service_code: LabelServiceCode;
  /** ShipEngine carrier account ID */
  shipengine_carrier_id?: LabelShipengineCarrierId;
  /** URL to download the shipping label */
  label_download_url?: LabelLabelDownloadUrl;
  /** Ship date of the shipment */
  ship_date?: LabelShipDate;
  /** Estimated delivery date */
  estimated_delivery_date?: LabelEstimatedDeliveryDate;
  /** Actual delivery date */
  actual_delivery_date?: LabelActualDeliveryDate;
  suborder_id: string;
  label_id: number;
}

/**
 * Unique identifier for the ShipEngine label
 */
export type LabelReadShipengineLabelId = string | null;

/**
 * Unique identifier for the shipment
 */
export type LabelReadShipmentId = string | null;

/**
 * Cost of the shipment
 */
export type LabelReadShipmentCost = number | null;

/**
 * Service code for the shipment (e.g., Ground, 2-Day Air)
 */
export type LabelReadServiceCode =
  (typeof LabelReadServiceCode)[keyof typeof LabelReadServiceCode];

export const LabelReadServiceCode = {
  usps_priority_mail: "usps_priority_mail",
  usps_ground_advantage: "usps_ground_advantage",
  usps_priority_mail_express: "usps_priority_mail_express",
  fedex_ground: "fedex_ground",
  fedex_home_delivery: "fedex_home_delivery",
  fedex_express_saver: "fedex_express_saver",
  fedex_2day: "fedex_2day",
  fedex_2day_am: "fedex_2day_am",
  fedex_standard_overnight: "fedex_standard_overnight",
  fedex_priority_overnight: "fedex_priority_overnight",
  ups_ground: "ups_ground",
  ups_3_day_select: "ups_3_day_select",
  ups_2nd_day_air: "ups_2nd_day_air",
  ups_2nd_day_air_am: "ups_2nd_day_air_am",
  ups_next_day_air_saver: "ups_next_day_air_saver",
  ups_next_day_air: "ups_next_day_air",
  ups_next_day_air_early_am: "ups_next_day_air_early_am",
} as const;

/**
 * ShipEngine carrier account ID
 */
export type LabelReadShipengineCarrierId = string | null;

/**
 * URL to download the shipping label
 */
export type LabelReadLabelDownloadUrl = string | null;

/**
 * Ship date of the shipment
 */
export type LabelReadShipDate = string | null;

/**
 * Estimated delivery date
 */
export type LabelReadEstimatedDeliveryDate = string | null;

/**
 * Actual delivery date
 */
export type LabelReadActualDeliveryDate = string | null;

/**
 * Label read schema
 */
export interface LabelRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** Unique identifier for the ShipEngine label */
  shipengine_label_id?: LabelReadShipengineLabelId;
  /** Unique identifier for the shipment */
  shipment_id?: LabelReadShipmentId;
  /** Cost of the shipment */
  shipment_cost?: LabelReadShipmentCost;
  /**
   * Tracking number for the shipment
   * @minLength 5
   */
  tracking_number: string;
  /** Carrier for the shipment (e.g., Fedex, UPS) */
  carrier_code: CarrierCodesEnum;
  /** Service code for the shipment (e.g., Ground, 2-Day Air) */
  service_code: LabelReadServiceCode;
  /** ShipEngine carrier account ID */
  shipengine_carrier_id?: LabelReadShipengineCarrierId;
  /** URL to download the shipping label */
  label_download_url?: LabelReadLabelDownloadUrl;
  /** Ship date of the shipment */
  ship_date?: LabelReadShipDate;
  /** Estimated delivery date */
  estimated_delivery_date?: LabelReadEstimatedDeliveryDate;
  /** Actual delivery date */
  actual_delivery_date?: LabelReadActualDeliveryDate;
  suborder_id: string;
  label_id: number;
  shipping_updates: ShippingUpdateRead[];
  updated_by: UserName;
}

/**
 * License create schema
 */
export interface LicenseCreate {
  entity_id: number;
  name: string;
  license_number: string;
  expiration_date: string;
}

/**
 * License read schema
 */
export interface LicenseRead {
  entity_id: number;
  name: string;
  license_number: string;
  expiration_date: string;
  license_id: number;
}

export type LotBatchEditExpirationDate = string | null;

/**
 * Per-batch edits within a lot edit request
 */
export interface LotBatchEdit {
  inventory_batch_id: string;
  /** @minimum 1 */
  order_quantity: number;
  /** @minimum 0 */
  unit_cost: number;
  expiration_date?: LotBatchEditExpirationDate;
}

export type LotBatchItemExpirationDate = string | null;

/**
 * Individual batch within a lot, for the edit modal
 */
export interface LotBatchItem {
  inventory_batch_id: string;
  order_quantity: number;
  unit_cost: number;
  expiration_date?: LotBatchItemExpirationDate;
  is_bulk_order: boolean;
}

export type LotBatchLogCreateLotNumber = string | null;

export type LotBatchLogCreateNote = string | null;

/**
 * Schema for creating lot-level FIFO batch logs
 */
export interface LotBatchLogCreate {
  inventory_id: string;
  lot_number?: LotBatchLogCreateLotNumber;
  log_type: InventoryBatchLogTypeEnum;
  quantity: number;
  note?: LotBatchLogCreateNote;
}

export type LotDetailReadLotNumber = string | null;

export type LotDetailReadEarliestExpirationDate = string | null;

export type LotDetailReadEarliestReceivedAt = string | null;

/**
 * Aggregated lot detail for the lot transactions page
 */
export interface LotDetailRead {
  inventory_id: string;
  product_name: string;
  entity_id: number;
  entity_name: string;
  lot_number: LotDetailReadLotNumber;
  earliest_expiration_date: LotDetailReadEarliestExpirationDate;
  has_multiple_expiration_dates: boolean;
  order_quantity: number;
  quantity_on_hand: number;
  quantity_quarantined: number;
  total_cost: number;
  avg_unit_cost: number;
  earliest_received_at: LotDetailReadEarliestReceivedAt;
  batches: LotBatchItem[];
}

export type LotEditInputLotNumber = string | null;

/**
 * Request body for editing a lot
 */
export interface LotEditInput {
  inventory_id: string;
  lot_number?: LotEditInputLotNumber;
  batch_edits: LotBatchEdit[];
}

export type LotSummaryReadLotNumber = string | null;

/**
 * Aggregated lot-level inventory summary for mass adjustment view
 */
export interface LotSummaryRead {
  product_id: number;
  product_name: string;
  lot_number: LotSummaryReadLotNumber;
  quantity_on_hand: number;
}

export type LotsLookupReadLotNumber = string | null;

export type LotsLookupReadEarliestReceivedAt = string | null;

export type LotsLookupReadEarliestExpirationDate = string | null;

/**
 * Aggregated lot-level summary for the global lots lookup page
 */
export interface LotsLookupRead {
  inventory_id: string;
  lot_number: LotsLookupReadLotNumber;
  product_name: string;
  entity_name: string;
  order_quantity: number;
  quantity_on_hand: number;
  avg_unit_cost: number;
  total_cost: number;
  earliest_received_at: LotsLookupReadEarliestReceivedAt;
  earliest_expiration_date: LotsLookupReadEarliestExpirationDate;
}

export type ManualInventoryBatchCreateNote = string | null;

export type ManualInventoryBatchCreateLotNumber = string | null;

export type ManualInventoryBatchCreateExpirationDate = string | null;

/**
 * Schema for manually creating an inventory batch
 */
export interface ManualInventoryBatchCreate {
  inventory_id: string;
  /** @minimum 1 */
  order_quantity: number;
  /** @minimum 0 */
  unit_cost: number;
  note?: ManualInventoryBatchCreateNote;
  lot_number?: ManualInventoryBatchCreateLotNumber;
  expiration_date?: ManualInventoryBatchCreateExpirationDate;
}

/**
 * Request body for marking a bulk suborder as arrived from Inventory 360
 */
export interface MarkArrivedInput {
  bulk_suborder_id: number;
  product_updates?: IncomingSuborderProductUpdate[];
}

/**
 * Request body for bulk mass-adjusting multiple lot groups atomically
 */
export interface MassAdjustBulkInput {
  entity_id: number;
  adjustments: MassAdjustItem[];
}

export type MassAdjustItemLotNumber = string | null;

/**
 * A single lot adjustment within a bulk request
 */
export interface MassAdjustItem {
  product_id: number;
  lot_number?: MassAdjustItemLotNumber;
  /** @minimum 0 */
  new_quantity: number;
}

export type MassDisposeInputDisposerId = number | null;

export type MassDisposeInputNote = string | null;

/**
 * Request body for bulk disposing quarantined inventory batches
 */
export interface MassDisposeInput {
  inventory_batch_ids: string[];
  disposal_method: DisposalMethodEnum;
  disposer_id?: MassDisposeInputDisposerId;
  note?: MassDisposeInputNote;
}

export type MedicationSummaryReadNdcNumber = string | null;

/**
 * Schema for the medication summary in the practice dispensing page
 */
export interface MedicationSummaryRead {
  medication: string;
  type: string;
  ndc_number: MedicationSummaryReadNdcNumber;
  total_received: number;
  total_dispensed: number;
}

/**
 * MessageRoleEnum class for AI chat messages
 */
export type MessageRoleEnum =
  (typeof MessageRoleEnum)[keyof typeof MessageRoleEnum];

export const MessageRoleEnum = {
  user: "user",
  assistant: "assistant",
  system: "system",
} as const;

/**
 * Body/response for POST /users/me/mfa-sync.
 */
export interface MfaSync {
  mfa_enabled: boolean;
}

/**
 * Breakdown of inbound calls by missed/failed status type.
 */
export interface MissedCallBreakdown {
  status: string;
  total: number;
}

/**
 * Missed call volume over time.
 */
export interface MissedCallsOverTime {
  answered: number;
  missed: number;
  date: string;
}

/**
 * Null for text message notifications
 */
export type NotificationReadUserId = string | null;

/**
 * Null for text message notifications
 */
export type NotificationReadNotificationId = number | null;

/**
 * Whether the notification has been read
 */
export type NotificationReadReadAt = string | null;

/**
 * Notification read schema
 */
export interface NotificationRead {
  /** Null for text message notifications */
  user_id: NotificationReadUserId;
  /** Title of the notification */
  title: string;
  /** Body of the notification */
  body: string;
  /** Relative path to navigate to on click */
  to: string;
  /** Type of the notification */
  notification_type: NotificationTypeEnum;
  /** Null for text message notifications */
  notification_id: NotificationReadNotificationId;
  /** Whether the notification has been read */
  read_at?: NotificationReadReadAt;
}

/**
 * NotificationTypeEnum class
 */
export type NotificationTypeEnum =
  (typeof NotificationTypeEnum)[keyof typeof NotificationTypeEnum];

export const NotificationTypeEnum = {
  text_message: "text_message",
  task: "task",
  voicemail: "voicemail",
} as const;

/**
 * Operational Change create schema
 */
export interface OperationalChangeCreate {
  entity_id: number;
  note: string;
  effective_date: string;
}

/**
 * Operational Change read schema
 */
export interface OperationalChangeRead {
  entity_id: number;
  note: string;
  effective_date: string;
  operational_change_id: number;
  created_at: string;
  created_by: UserName;
}

/**
 * Opt-in status breakdown for the texting dashboard.
 */
export interface OptInStatus {
  status: string;
  count: number;
}

export type OrderPaymentId = number | null;

export type OrderPatientPayorId = number | null;

export type OrderShippingAddressId = number | null;

export type OrderSurgeryDate = string | null;

/**
 * Order schema
 */
export interface Order {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  practice_id: number;
  doctor_id: string;
  patient_id: string;
  payment_id?: OrderPaymentId;
  patient_payor_id?: OrderPatientPayorId;
  shipping_address_id?: OrderShippingAddressId;
  surgery_date?: OrderSurgeryDate;
  /** @minimum 0 */
  sales_tax?: number;
  /** @minimum 0 */
  shipping_charge?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal?: number;
  /** @minimum 0 */
  total_price?: number;
  order_id: string;
  status: OrderStatusEnum;
  has_chargeback: boolean;
  /** @minimum 0 */
  covered?: number;
}

/**
 * OrderBundle create schema
 */
export interface OrderBundleCreate {
  bundle_id: number;
  /** @minimum 1 */
  quantity: number;
}

/**
 * OrderBundle read schema
 */
export interface OrderBundleRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  bundle_id: number;
  /** @minimum 1 */
  quantity: number;
  order_id: string;
  bundle: BundleForOrderRead;
}

/**
 * Order Commission read schema
 */
export interface OrderCommissionRead {
  /** UserEntity to create the commission for */
  user_id: string;
  /** Name of the entity associated with the commission */
  entity_name: string;
  /** Revenue amount earned from this commission */
  revenue_amount: number;
  /** Month the commission was earned */
  month: number;
}

/**
 * OrderContents create schema
 */
export interface OrderContentsCreate {
  order_bundles: OrderBundleCreate[];
  suborders: SuborderCreate[];
}

export type OrderCreatePaymentId = number | null;

export type OrderCreatePatientPayorId = number | null;

export type OrderCreateShippingAddressId = number | null;

export type OrderCreateSurgeryDate = string | null;

/**
 * Order create schema
 */
export interface OrderCreate {
  practice_id: number;
  doctor_id: string;
  patient_id: string;
  payment_id?: OrderCreatePaymentId;
  patient_payor_id?: OrderCreatePatientPayorId;
  shipping_address_id?: OrderCreateShippingAddressId;
  surgery_date?: OrderCreateSurgeryDate;
  /** @minimum 0 */
  sales_tax?: number;
  /** @minimum 0 */
  shipping_charge?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal?: number;
  /** @minimum 0 */
  total_price?: number;
}

export type OrderManyReadPaymentId = number | null;

export type OrderManyReadPatientPayorId = number | null;

export type OrderManyReadShippingAddressId = number | null;

export type OrderManyReadSurgeryDate = string | null;

/**
 * Order many read schema
 */
export interface OrderManyRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  practice_id: number;
  doctor_id: string;
  patient_id: string;
  payment_id?: OrderManyReadPaymentId;
  patient_payor_id?: OrderManyReadPatientPayorId;
  shipping_address_id?: OrderManyReadShippingAddressId;
  surgery_date?: OrderManyReadSurgeryDate;
  /** @minimum 0 */
  sales_tax?: number;
  /** @minimum 0 */
  shipping_charge?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal?: number;
  /** @minimum 0 */
  total_price?: number;
  order_id: string;
  status: OrderStatusEnum;
  has_chargeback: boolean;
  /** @minimum 0 */
  covered?: number;
  practice: EntityName;
  doctor: DoctorRead;
  patient: Patient;
  created_by: UserName;
  tasks: Task[];
}

/**
 * Order summary metrics
 */
export interface OrderMetrics {
  total_orders: number;
  rx_count: number;
  unique_patients: number;
  chronic_dispense: number;
  acute_dispense: number;
  first_order_patients: number;
  reoccurring_patients: number;
  patient_conversion: number;
}

/**
 * OrderNote schema
 */
export interface OrderNote {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  order_id: string;
  note: string;
  order_note_id: number;
}

/**
 * OrderNote create schema
 */
export interface OrderNoteCreate {
  order_id: string;
  note: string;
}

/**
 * OrderNote read schema
 */
export interface OrderNoteRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  order_id: string;
  note: string;
  order_note_id: number;
  updated_by: UserName;
}

export type OrderPatientSurgeryDate = string | null;

/**
 * Order patient schema
 */
export interface OrderPatient {
  surgery_date: OrderPatientSurgeryDate;
  patient: Patient;
}

export type OrderReadPaymentId = number | null;

export type OrderReadPatientPayorId = number | null;

export type OrderReadShippingAddressId = number | null;

export type OrderReadSurgeryDate = string | null;

export type OrderReadPayment = PatientPayment | null;

export type OrderReadPatientPayor = PatientPayor | null;

export type OrderReadShippingAddress = PatientAddressRead | null;

/**
 * Order read schema
 */
export interface OrderRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  practice_id: number;
  doctor_id: string;
  patient_id: string;
  payment_id?: OrderReadPaymentId;
  patient_payor_id?: OrderReadPatientPayorId;
  shipping_address_id?: OrderReadShippingAddressId;
  surgery_date?: OrderReadSurgeryDate;
  /** @minimum 0 */
  sales_tax?: number;
  /** @minimum 0 */
  shipping_charge?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal?: number;
  /** @minimum 0 */
  total_price?: number;
  order_id: string;
  status: OrderStatusEnum;
  has_chargeback: boolean;
  /** @minimum 0 */
  covered?: number;
  practice: Entity;
  doctor: DoctorRead;
  patient: Patient;
  created_by: UserName;
  tasks: Task[];
  payment: OrderReadPayment;
  patient_payor: OrderReadPatientPayor;
  shipping_address: OrderReadShippingAddress;
  suborders: SuborderRead[];
  notes: OrderNoteRead[];
  audit_order: Audit[];
  order_bundles: OrderBundleRead[];
}

/**
 * Single-order detail with nested non-PHI suborder line items.
 */
export interface OrderSafeRead {
  order_id: string;
  status: OrderStatusEnum;
  has_chargeback: boolean;
  practice_id: number;
  practice: EntityName;
  doctor_id: string;
  doctor: UserBase;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  covered?: number;
  /** @minimum 0 */
  total_price: number;
  created_at: string;
  updated_at: string;
  suborders: OrderSafeSuborder[];
}

export type OrderSafeSuborderTargetShipBy = string | null;

export type OrderSafeSuborderChargedAt = string | null;

export type OrderSafeSuborderChargebackAt = string | null;

export type OrderSafeSuborderFulfilledAt = string | null;

export type OrderSafeSuborderDeliveredAt = string | null;

/**
 * Suborder summary without patient-scoped fields.
 */
export interface OrderSafeSuborder {
  order_id: string;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  processing_fee: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  total: number;
  target_ship_by?: OrderSafeSuborderTargetShipBy;
  status: SuborderStatusEnum;
  suborder_id: string;
  delivery_method: DeliveryMethodEnum;
  dispensing_pharmacy_id: number;
  dispensing_pharmacy: EntityName;
  charged_at?: OrderSafeSuborderChargedAt;
  chargeback_at?: OrderSafeSuborderChargebackAt;
  fulfilled_at?: OrderSafeSuborderFulfilledAt;
  delivered_at?: OrderSafeSuborderDeliveredAt;
  created_at: string;
  updated_at: string;
  suborder_products: OrderSafeSuborderProduct[];
}

/**
 * Suborder line item without patient-scoped fields (instructions, rx_number).
 */
export interface OrderSafeSuborderProduct {
  suborder_product_id: number;
  suborder_id: string;
  product_id: number;
  /** @minimum 0 */
  unit_price: number;
  /** @minimum 0 */
  patient_price: number;
  /** @minimum 0 */
  quantity: number;
  /** @minimum 0 */
  refills: number;
  product: Product;
}

/**
 * Order list-row shape. No patient identity, payment, payor, or address.
 */
export interface OrderSafeSummary {
  order_id: string;
  status: OrderStatusEnum;
  has_chargeback: boolean;
  practice_id: number;
  practice: EntityName;
  doctor_id: string;
  doctor: UserBase;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  covered?: number;
  /** @minimum 0 */
  total_price: number;
  created_at: string;
  updated_at: string;
}

/**
 * OrderStatusEnum class

Represents the main status of an order.

If all statuses are fulfilled, then the order is considered complete.
 */
export type OrderStatusEnum =
  (typeof OrderStatusEnum)[keyof typeof OrderStatusEnum];

export const OrderStatusEnum = {
  Draft: "Draft",
  Open: "Open",
  Cancelled: "Cancelled",
  Complete: "Complete",
} as const;

export type OrderWithTasksPaymentId = number | null;

export type OrderWithTasksPatientPayorId = number | null;

export type OrderWithTasksShippingAddressId = number | null;

export type OrderWithTasksSurgeryDate = string | null;

/**
 * Order with tasks schema

This schema is used by the PatientRead schema to avoid recursion errors
 */
export interface OrderWithTasks {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  practice_id: number;
  doctor_id: string;
  patient_id: string;
  payment_id?: OrderWithTasksPaymentId;
  patient_payor_id?: OrderWithTasksPatientPayorId;
  shipping_address_id?: OrderWithTasksShippingAddressId;
  surgery_date?: OrderWithTasksSurgeryDate;
  /** @minimum 0 */
  sales_tax?: number;
  /** @minimum 0 */
  shipping_charge?: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal?: number;
  /** @minimum 0 */
  total_price?: number;
  order_id: string;
  status: OrderStatusEnum;
  has_chargeback: boolean;
  /** @minimum 0 */
  covered?: number;
  tasks: Task[];
}

/**
 * Orders by user schema (doctor or creator)
 */
export interface OrdersByUser {
  self_fulfilled: number;
  externally_fulfilled: number;
  user_id: string;
  first_name: string;
  last_name: string;
}

/**
 * Orders per month schema
 */
export interface OrdersPerMonth {
  date: string;
  self_fulfilled: number;
  externally_fulfilled: number;
  cumulative_self_fulfilled: number;
  cumulative_externally_fulfilled: number;
}

/**
 * Orders per month year-to-date schema
 */
export interface OrdersPerMonthYTD {
  date: string;
  this_year: number;
  last_year: number;
}

/**
 * Other expenses breakdown (processing fees, chargebacks, sales tax)
 */
export interface OtherExpenseBreakdown {
  processing_fee: number;
  chargebacks: number;
  date: string;
}

/**
 * Create schema. The practice (entity_id) is resolved server-side from the patient.
 */
export interface OutcomeCampaignCreate {
  patient_id: string;
  campaign_type: OutcomeCampaignTypeEnum;
  surgery_date: string;
  check_in_dates?: string[];
  lock_in_dates?: string[];
}

export type OutcomeCampaignReadOptInSentAt = string | null;

export type OutcomeCampaignReadOptedInAt = string | null;

/**
 * Detail schema with the materialized message schedule.
 */
export interface OutcomeCampaignRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  patient_id: string;
  campaign_type: OutcomeCampaignTypeEnum;
  surgery_date: string;
  check_in_dates?: string[];
  lock_in_dates?: string[];
  outcome_campaign_id: number;
  entity_id: number;
  status: OutcomeCampaignStatusEnum;
  opt_in_sent_at?: OutcomeCampaignReadOptInSentAt;
  opted_in_at?: OutcomeCampaignReadOptedInAt;
  messages?: OutcomeMessageRead[];
}

/**
 * OutcomeCampaignStatusEnum class

Lifecycle of an outcomes campaign. Clinical questions only send while ACTIVE.
 */
export type OutcomeCampaignStatusEnum =
  (typeof OutcomeCampaignStatusEnum)[keyof typeof OutcomeCampaignStatusEnum];

export const OutcomeCampaignStatusEnum = {
  Pending_Opt_In: "Pending Opt In",
  Active: "Active",
  Completed: "Completed",
  Cancelled: "Cancelled",
} as const;

/**
 * OutcomeCampaignTypeEnum class

The 1-Click Outcomes campaign a patient is enrolled in. Day 1 ships only LAL;
additional types are added here as they are built.
 */
export type OutcomeCampaignTypeEnum =
  (typeof OutcomeCampaignTypeEnum)[keyof typeof OutcomeCampaignTypeEnum];

export const OutcomeCampaignTypeEnum = {
  Light_Adjustable_Lens: "Light Adjustable Lens",
} as const;

export type OutcomeCampaignUpdateSurgeryDate = string | null;

export type OutcomeCampaignUpdateCheckInDates = string[] | null;

export type OutcomeCampaignUpdateLockInDates = string[] | null;

export type OutcomeCampaignUpdateStatus = OutcomeCampaignStatusEnum | null;

/**
 * Edit schema.

Provide any of the date fields to re-materialize the schedule, and/or set
status to CANCELLED to cancel the campaign.
 */
export interface OutcomeCampaignUpdate {
  surgery_date?: OutcomeCampaignUpdateSurgeryDate;
  check_in_dates?: OutcomeCampaignUpdateCheckInDates;
  lock_in_dates?: OutcomeCampaignUpdateLockInDates;
  status?: OutcomeCampaignUpdateStatus;
}

/**
 * OutcomeMessageKindEnum class

What a scheduled message is. ONBOARDING/OPT_IN send inline on start; QUESTION
and CONGRATS send via the daily job once the campaign is ACTIVE.
 */
export type OutcomeMessageKindEnum =
  (typeof OutcomeMessageKindEnum)[keyof typeof OutcomeMessageKindEnum];

export const OutcomeMessageKindEnum = {
  Onboarding: "Onboarding",
  Opt_In: "Opt In",
  Question: "Question",
  Congrats: "Congrats",
} as const;

export type OutcomeMessageReadSentAt = string | null;

export type OutcomeMessageReadAnsweredAt = string | null;

/**
 * A materialized scheduled message, with any replies.
 */
export interface OutcomeMessageRead {
  outcome_message_id: number;
  question_key: string;
  kind: OutcomeMessageKindEnum;
  anchor_date: string;
  scheduled_for: string;
  status: OutcomeMessageStatusEnum;
  sent_at?: OutcomeMessageReadSentAt;
  answered_at?: OutcomeMessageReadAnsweredAt;
  responses?: OutcomeResponseRead[];
}

/**
 * OutcomeMessageStatusEnum class

Delivery status of a materialized outcome message.
 */
export type OutcomeMessageStatusEnum =
  (typeof OutcomeMessageStatusEnum)[keyof typeof OutcomeMessageStatusEnum];

export const OutcomeMessageStatusEnum = {
  Scheduled: "Scheduled",
  Sent: "Sent",
  Skipped: "Skipped",
  Cancelled: "Cancelled",
} as const;

export type OutcomeResponseReadOptionIndex = number | null;

export type OutcomeResponseReadSelectedOption = string | null;

/**
 * A structured patient reply to an outcome message.
 */
export interface OutcomeResponseRead {
  outcome_response_id: number;
  raw_reply: string;
  option_index?: OutcomeResponseReadOptionIndex;
  selected_option?: OutcomeResponseReadSelectedOption;
  received_at: string;
}

/**
 * Finance P&L data schema
 */
export interface PNLSummary {
  units: number;
  revenue: number;
  expense: number;
  other_expenses: number;
  profit: number;
  date: string;
}

/**
 * Unit of measurement for package dimensions
 */
export type PackageDimensionUnit =
  (typeof PackageDimensionUnit)[keyof typeof PackageDimensionUnit];

export const PackageDimensionUnit = {
  inch: "inch",
  centimeter: "centimeter",
} as const;

/**
 * ShipEngine package dimension schema
 */
export interface PackageDimension {
  /** Height of the package */
  height: number;
  /** Width of the package */
  width: number;
  /** Length of the package */
  length: number;
  /** Unit of measurement for package dimensions */
  unit: PackageDimensionUnit;
}

/**
 * ShipEngine package weight schema
 */
export interface PackageWeight {
  /** Weight of the package */
  value: number;
  /** Weight unit of the package */
  unit: ShippingWeightUnitEnum;
}

export interface PageBatchWithOwnerAndWarehouseVendor {
  /** List of items for the current page */
  items: BatchWithOwnerAndWarehouseVendor[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageBulkBundleRead {
  /** List of items for the current page */
  items: BulkBundleRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageBulkInvoiceManyRead {
  /** List of items for the current page */
  items: BulkInvoiceManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageBulkOrderManyRead {
  /** List of items for the current page */
  items: BulkOrderManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageBulkProductRead {
  /** List of items for the current page */
  items: BulkProductRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageBulkSuborderLookup {
  /** List of items for the current page */
  items: BulkSuborderLookup[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageBundleRead {
  /** List of items for the current page */
  items: BundleRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageCatalogProductReadWithVisibility {
  /** List of items for the current page */
  items: CatalogProductReadWithVisibility[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageCatalogProductWithWarehouseBase {
  /** List of items for the current page */
  items: CatalogProductWithWarehouseBase[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageEntityManyRead {
  /** List of items for the current page */
  items: EntityManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageInventoryBatchLogRead {
  /** List of items for the current page */
  items: InventoryBatchLogRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageInventoryBatchRead {
  /** List of items for the current page */
  items: InventoryBatchRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageInventoryLotSummaryRead {
  /** List of items for the current page */
  items: InventoryLotSummaryRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageInventoryWithIncomingQuantity {
  /** List of items for the current page */
  items: InventoryWithIncomingQuantity[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageLotsLookupRead {
  /** List of items for the current page */
  items: LotsLookupRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageOrderManyRead {
  /** List of items for the current page */
  items: OrderManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageOrderSafeSummary {
  /** List of items for the current page */
  items: OrderSafeSummary[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PagePatientManyRead {
  /** List of items for the current page */
  items: PatientManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PagePatientRxSummary {
  /** List of items for the current page */
  items: PatientRxSummary[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PagePayorRead {
  /** List of items for the current page */
  items: PayorRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageProductRead {
  /** List of items for the current page */
  items: ProductRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageRecallEventListRead {
  /** List of items for the current page */
  items: RecallEventListRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageRecallPatientRead {
  /** List of items for the current page */
  items: RecallPatientRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageStockOrderBulkProductRead {
  /** List of items for the current page */
  items: StockOrderBulkProductRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageStockOrderManyRead {
  /** List of items for the current page */
  items: StockOrderManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageSuborderManyRead {
  /** List of items for the current page */
  items: SuborderManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageTaskRead {
  /** List of items for the current page */
  items: TaskRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageUserManyRead {
  /** List of items for the current page */
  items: UserManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageVendorManyRead {
  /** List of items for the current page */
  items: VendorManyRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageWarehouseMonthlySales {
  /** List of items for the current page */
  items: WarehouseMonthlySales[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageWarehouseRead {
  /** List of items for the current page */
  items: WarehouseRead[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export interface PageWarehouseWithIncomingQuantity {
  /** List of items for the current page */
  items: WarehouseWithIncomingQuantity[];
  /** Total number of items available */
  count: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
}

export type PatientEmail = string | null;

/**
 * Type of phone number
 */
export type PatientPhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type PatientTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type PatientTitle = string | null;

/**
 * NPI number of the user
 */
export type PatientNpiNumber = string | null;

/**
 * State license number of the user
 */
export type PatientStateLicenseNumber = string | null;

export type PatientBestRxId = string | null;

export type PatientSex = BirthSexEnum | null;

/**
 * Patient schema
 */
export interface Patient {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  email?: PatientEmail;
  phone: string;
  /** Type of phone number */
  phone_type?: PatientPhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: PatientTextingUnsubscribedAt;
  role: "patient";
  /** Title of the user, e.g., MD, RN, PA */
  title?: PatientTitle;
  /** NPI number of the user */
  npi_number?: PatientNpiNumber;
  /** State license number of the user */
  state_license_number?: PatientStateLicenseNumber;
  date_of_birth: string;
  allergies?: string[];
  best_rx_id?: PatientBestRxId;
  sex?: PatientSex;
  patient_id: string;
}

export type PatientAddressCreateStAddress2 = string | null;

/**
 * PatientAddress create schema
 */
export interface PatientAddressCreate {
  st_address_1: string;
  st_address_2?: PatientAddressCreateStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  patient_id: string;
  is_primary?: boolean;
}

export type PatientAddressReadStAddress2 = string | null;

/**
 * PatientAddress read schema
 */
export interface PatientAddressRead {
  st_address_1: string;
  st_address_2?: PatientAddressReadStAddress2;
  city: string;
  postal_code: string;
  state_province: string;
  country: string;
  patient_id: string;
  is_primary?: boolean;
  patient_address_id: number;
}

export type PatientCampaignCampaign = PatientCampaignEnum | null;

export type PatientCampaignNextSendAt = string | null;

export type PatientCampaignEndAt = string | null;

/**
 * Patient Campaign schema
 */
export interface PatientCampaign {
  patient_id: string;
  order_id: string;
  product_id: number;
  campaign?: PatientCampaignCampaign;
  next_send_at?: PatientCampaignNextSendAt;
  end_at?: PatientCampaignEndAt;
  patient_campaign_id: number;
}

export type PatientCampaignCreateCampaign = PatientCampaignEnum | null;

export type PatientCampaignCreateNextSendAt = string | null;

export type PatientCampaignCreateEndAt = string | null;

/**
 * Patient Campaign create schema
 */
export interface PatientCampaignCreate {
  patient_id: string;
  order_id: string;
  product_id: number;
  campaign?: PatientCampaignCreateCampaign;
  next_send_at?: PatientCampaignCreateNextSendAt;
  end_at?: PatientCampaignCreateEndAt;
}

/**
 * PatientCampaignEnum class
 */
export type PatientCampaignEnum =
  (typeof PatientCampaignEnum)[keyof typeof PatientCampaignEnum];

export const PatientCampaignEnum = {
  Daily_Reminders: "Daily Reminders",
  Weekly_Reminders: "Weekly Reminders",
} as const;

export type PatientCreateEmail = string | null;

/**
 * Type of phone number
 */
export type PatientCreatePhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type PatientCreateTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type PatientCreateTitle = string | null;

/**
 * NPI number of the user
 */
export type PatientCreateNpiNumber = string | null;

/**
 * State license number of the user
 */
export type PatientCreateStateLicenseNumber = string | null;

export type PatientCreateBestRxId = string | null;

export type PatientCreateSex = BirthSexEnum | null;

/**
 * Patient create schema
 */
export interface PatientCreate {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  email?: PatientCreateEmail;
  phone: string;
  /** Type of phone number */
  phone_type?: PatientCreatePhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: PatientCreateTextingUnsubscribedAt;
  role: "patient";
  /** Title of the user, e.g., MD, RN, PA */
  title?: PatientCreateTitle;
  /** NPI number of the user */
  npi_number?: PatientCreateNpiNumber;
  /** State license number of the user */
  state_license_number?: PatientCreateStateLicenseNumber;
  date_of_birth: string;
  allergies?: string[];
  best_rx_id?: PatientCreateBestRxId;
  sex?: PatientCreateSex;
  entity_id: number;
}

/**
 * Schema for checking possible duplicate patients and unlinked text messages
 */
export interface PatientCreateCheck {
  duplicates: Patient[];
  unlinked_text_messages: TextMessageRead[];
}

export type PatientHistoryEventPhoneCallId = number | null;

export type PatientHistoryEventCallStatus = CallStatusEnum | null;

export type PatientHistoryEventCallDirection = CallDirectionEnum | null;

export type PatientHistoryEventPatientNoteId = number | null;

export type PatientHistoryEventCreatedById = string | null;

/**
 * Patient history event schema
 */
export interface PatientHistoryEvent {
  timestamp: string;
  user: string;
  action: string;
  event_type: HistoryEventEnum;
  has_recording?: boolean;
  phone_call_id?: PatientHistoryEventPhoneCallId;
  call_status?: PatientHistoryEventCallStatus;
  call_direction?: PatientHistoryEventCallDirection;
  patient_note_id?: PatientHistoryEventPatientNoteId;
  created_by_id?: PatientHistoryEventCreatedById;
  is_edited?: boolean;
}

export type PatientManyReadEmail = string | null;

/**
 * Type of phone number
 */
export type PatientManyReadPhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type PatientManyReadTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type PatientManyReadTitle = string | null;

/**
 * NPI number of the user
 */
export type PatientManyReadNpiNumber = string | null;

/**
 * State license number of the user
 */
export type PatientManyReadStateLicenseNumber = string | null;

export type PatientManyReadBestRxId = string | null;

export type PatientManyReadSex = BirthSexEnum | null;

/**
 * Patient many read schema
 */
export interface PatientManyRead {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  email?: PatientManyReadEmail;
  phone: string;
  /** Type of phone number */
  phone_type?: PatientManyReadPhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: PatientManyReadTextingUnsubscribedAt;
  role: "patient";
  /** Title of the user, e.g., MD, RN, PA */
  title?: PatientManyReadTitle;
  /** NPI number of the user */
  npi_number?: PatientManyReadNpiNumber;
  /** State license number of the user */
  state_license_number?: PatientManyReadStateLicenseNumber;
  date_of_birth: string;
  allergies?: string[];
  best_rx_id?: PatientManyReadBestRxId;
  sex?: PatientManyReadSex;
  patient_id: string;
  user_entities: UserEntityManyRead[];
}

export type PatientMergeCandidateEmail = string | null;

/**
 * Type of phone number
 */
export type PatientMergeCandidatePhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type PatientMergeCandidateTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type PatientMergeCandidateTitle = string | null;

/**
 * NPI number of the user
 */
export type PatientMergeCandidateNpiNumber = string | null;

/**
 * State license number of the user
 */
export type PatientMergeCandidateStateLicenseNumber = string | null;

export type PatientMergeCandidateBestRxId = string | null;

export type PatientMergeCandidateSex = BirthSexEnum | null;

/**
 * A possible duplicate patient with their orders.
 */
export interface PatientMergeCandidate {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  email?: PatientMergeCandidateEmail;
  phone: string;
  /** Type of phone number */
  phone_type?: PatientMergeCandidatePhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: PatientMergeCandidateTextingUnsubscribedAt;
  role: "patient";
  /** Title of the user, e.g., MD, RN, PA */
  title?: PatientMergeCandidateTitle;
  /** NPI number of the user */
  npi_number?: PatientMergeCandidateNpiNumber;
  /** State license number of the user */
  state_license_number?: PatientMergeCandidateStateLicenseNumber;
  date_of_birth: string;
  allergies?: string[];
  best_rx_id?: PatientMergeCandidateBestRxId;
  sex?: PatientMergeCandidateSex;
  patient_id: string;
  orders: Order[];
}

/**
 * Request to merge two patients.
 */
export interface PatientMergeRequest {
  surviving_patient_id: string;
  merged_patient_id: string;
}

/**
 * Request to mark two patients as non-duplicates.
 */
export interface PatientNonDuplicateCreate {
  patient_id_1: string;
  patient_id_2: string;
}

/**
 * A confirmed non-duplicate patient pair.
 */
export interface PatientNonDuplicateRead {
  patient_id_1: string;
  patient_id_2: string;
}

/**
 * PatientNote schema
 */
export interface PatientNote {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  patient_id: string;
  note: string;
  patient_note_id: number;
}

/**
 * PatientNote create schema
 */
export interface PatientNoteCreate {
  patient_id: string;
  note: string;
}

/**
 * PatientNote update schema
 */
export interface PatientNoteUpdate {
  note: string;
}

export type PatientPaymentStAddress1 = string | null;

export type PatientPaymentStAddress2 = string | null;

export type PatientPaymentCity = string | null;

export type PatientPaymentPostalCode = string | null;

export type PatientPaymentStateProvince = string | null;

export type PatientPaymentCountry = string | null;

export type PatientPaymentToken = string | null;

export type PatientPaymentStripePaymentMethodId = string | null;

export type PatientPaymentPriorityPaymentMethodId = number | null;

/**
 * PatientPayment schema
 */
export interface PatientPayment {
  st_address_1?: PatientPaymentStAddress1;
  st_address_2?: PatientPaymentStAddress2;
  city?: PatientPaymentCity;
  postal_code?: PatientPaymentPostalCode;
  state_province?: PatientPaymentStateProvince;
  country?: PatientPaymentCountry;
  patient_id: string;
  /** @minLength 1 */
  cardholder_name: string;
  is_primary?: boolean;
  exp: string;
  token: PatientPaymentToken;
  masked_number: string;
  brand: string;
  stripe_payment_method_id?: PatientPaymentStripePaymentMethodId;
  priority_payment_method_id?: PatientPaymentPriorityPaymentMethodId;
}

export type PatientPaymentCreateStAddress1 = string | null;

export type PatientPaymentCreateStAddress2 = string | null;

export type PatientPaymentCreateCity = string | null;

export type PatientPaymentCreatePostalCode = string | null;

export type PatientPaymentCreateStateProvince = string | null;

export type PatientPaymentCreateCountry = string | null;

/**
 * PatientPayment create schema

This is for the API.
 */
export interface PatientPaymentCreate {
  st_address_1?: PatientPaymentCreateStAddress1;
  st_address_2?: PatientPaymentCreateStAddress2;
  city?: PatientPaymentCreateCity;
  postal_code?: PatientPaymentCreatePostalCode;
  state_province?: PatientPaymentCreateStateProvince;
  country?: PatientPaymentCreateCountry;
  patient_id: string;
  /** @minLength 1 */
  cardholder_name: string;
  is_primary?: boolean;
  exp: string;
  /**
   * @minLength 12
   * @maxLength 19
   */
  number: string;
  /**
   * @minLength 3
   * @maxLength 4
   */
  cvv: string;
}

/**
 * PatientPayment create schema for Priority Commerce
 */
export interface PatientPaymentPriorityCreate {
  patient_id: string;
  priority_payment_method_id: number;
}

export type PatientPaymentReadStAddress1 = string | null;

export type PatientPaymentReadStAddress2 = string | null;

export type PatientPaymentReadCity = string | null;

export type PatientPaymentReadPostalCode = string | null;

export type PatientPaymentReadStateProvince = string | null;

export type PatientPaymentReadCountry = string | null;

export type PatientPaymentReadToken = string | null;

export type PatientPaymentReadStripePaymentMethodId = string | null;

export type PatientPaymentReadPriorityPaymentMethodId = number | null;

/**
 * PatientPayment read schema
 */
export interface PatientPaymentRead {
  st_address_1?: PatientPaymentReadStAddress1;
  st_address_2?: PatientPaymentReadStAddress2;
  city?: PatientPaymentReadCity;
  postal_code?: PatientPaymentReadPostalCode;
  state_province?: PatientPaymentReadStateProvince;
  country?: PatientPaymentReadCountry;
  patient_id: string;
  /** @minLength 1 */
  cardholder_name: string;
  is_primary?: boolean;
  exp: string;
  token: PatientPaymentReadToken;
  masked_number: string;
  brand: string;
  stripe_payment_method_id?: PatientPaymentReadStripePaymentMethodId;
  priority_payment_method_id?: PatientPaymentReadPriorityPaymentMethodId;
  patient_payment_id: number;
}

/**
 * PatientPayment create schema for Stripe
 */
export interface PatientPaymentStripeCreate {
  patient_id: string;
  stripe_payment_method_id: string;
}

export type PatientPayorGroupNumber = string | null;

/**
 * PatientPayor schema
 */
export interface PatientPayor {
  patient_id: string;
  /**
   * @minLength 3
   * @maxLength 50
   */
  account_number: string;
  group_number?: PatientPayorGroupNumber;
  payor_id: number;
  is_primary?: boolean;
  patient_payor_id: number;
  payor: PayorRead;
}

export type PatientPayorCreateGroupNumber = string | null;

/**
 * PatientPayor create schema
 */
export interface PatientPayorCreate {
  patient_id: string;
  /**
   * @minLength 3
   * @maxLength 50
   */
  account_number: string;
  group_number?: PatientPayorCreateGroupNumber;
  payor_id: number;
  is_primary?: boolean;
}

export type PatientPayorReadGroupNumber = string | null;

/**
 * PatientPayor read schema
 */
export interface PatientPayorRead {
  patient_id: string;
  /**
   * @minLength 3
   * @maxLength 50
   */
  account_number: string;
  group_number?: PatientPayorReadGroupNumber;
  payor_id: number;
  is_primary?: boolean;
  patient_payor_id: number;
  payor: PayorRead;
}

/**
 * Result of a phone textability check
 */
export interface PatientPhoneCheckResult {
  phone_type: PhoneTypeEnum;
}

export type PatientReadEmail = string | null;

/**
 * Type of phone number
 */
export type PatientReadPhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type PatientReadTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type PatientReadTitle = string | null;

/**
 * NPI number of the user
 */
export type PatientReadNpiNumber = string | null;

/**
 * State license number of the user
 */
export type PatientReadStateLicenseNumber = string | null;

export type PatientReadBestRxId = string | null;

export type PatientReadSex = BirthSexEnum | null;

/**
 * Patient read schema
 */
export interface PatientRead {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  email?: PatientReadEmail;
  phone: string;
  /** Type of phone number */
  phone_type?: PatientReadPhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: PatientReadTextingUnsubscribedAt;
  role: "patient";
  /** Title of the user, e.g., MD, RN, PA */
  title?: PatientReadTitle;
  /** NPI number of the user */
  npi_number?: PatientReadNpiNumber;
  /** State license number of the user */
  state_license_number?: PatientReadStateLicenseNumber;
  date_of_birth: string;
  allergies?: string[];
  best_rx_id?: PatientReadBestRxId;
  sex?: PatientReadSex;
  patient_id: string;
  user_entities: UserEntityManyRead[];
  patient_payors: PatientPayorRead[];
  addresses: PatientAddressRead[];
  orders: OrderWithTasks[];
  payments: PatientPaymentRead[];
  tasks: Task[];
}

export type PatientRxSummaryEmail = string | null;

/**
 * Type of phone number
 */
export type PatientRxSummaryPhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type PatientRxSummaryTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type PatientRxSummaryTitle = string | null;

/**
 * NPI number of the user
 */
export type PatientRxSummaryNpiNumber = string | null;

/**
 * State license number of the user
 */
export type PatientRxSummaryStateLicenseNumber = string | null;

export type PatientRxSummaryBestRxId = string | null;

export type PatientRxSummarySex = BirthSexEnum | null;

export type PatientRxSummaryLastRxOrderAt = string | null;

/**
 * Schema for summarizing a patient's prescription (Rx) activity.
 */
export interface PatientRxSummary {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  email?: PatientRxSummaryEmail;
  phone: string;
  /** Type of phone number */
  phone_type?: PatientRxSummaryPhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: PatientRxSummaryTextingUnsubscribedAt;
  role: "patient";
  /** Title of the user, e.g., MD, RN, PA */
  title?: PatientRxSummaryTitle;
  /** NPI number of the user */
  npi_number?: PatientRxSummaryNpiNumber;
  /** State license number of the user */
  state_license_number?: PatientRxSummaryStateLicenseNumber;
  date_of_birth: string;
  allergies?: string[];
  best_rx_id?: PatientRxSummaryBestRxId;
  sex?: PatientRxSummarySex;
  patient_id: string;
  total_rx_orders: number;
  last_rx_order_at: PatientRxSummaryLastRxOrderAt;
}

/**
 * PaymentProcessorEnum class for payment processor selection
 */
export type PaymentProcessorEnum =
  (typeof PaymentProcessorEnum)[keyof typeof PaymentProcessorEnum];

export const PaymentProcessorEnum = {
  USAePay: "USAePay",
  Stripe: "Stripe",
  Priority: "Priority",
} as const;

/**
 * PaymentProviders class
 */
export type PaymentProviders =
  (typeof PaymentProviders)[keyof typeof PaymentProviders];

export const PaymentProviders = {
  stripe: "stripe",
  usaepay: "usaepay",
  priority: "priority",
  external: "external",
} as const;

/**
 * PaymentTypeEnum class

The payment instrument used, independent of which provider handled it
 */
export type PaymentTypeEnum =
  (typeof PaymentTypeEnum)[keyof typeof PaymentTypeEnum];

export const PaymentTypeEnum = {
  card: "card",
  ach: "ach",
  cash: "cash",
  check: "check",
  other: "other",
  stripe_transfer: "stripe_transfer",
} as const;

export type PayorCreateEmail = string | null;

export type PayorCreatePhone = string | null;

export type PayorCreatePcn = string | null;

/**
 * Payor create schema
 */
export interface PayorCreate {
  /** @minLength 2 */
  name: string;
  email?: PayorCreateEmail;
  phone?: PayorCreatePhone;
  /**
   * @minLength 6
   * @maxLength 6
   */
  bin_number: string;
  pcn?: PayorCreatePcn;
  payor_type: PayorTypeEnum;
}

export type PayorReadEmail = string | null;

export type PayorReadPhone = string | null;

export type PayorReadPcn = string | null;

/**
 * Payor read schema
 */
export interface PayorRead {
  /** @minLength 2 */
  name: string;
  email?: PayorReadEmail;
  phone?: PayorReadPhone;
  /**
   * @minLength 6
   * @maxLength 6
   */
  bin_number: string;
  pcn?: PayorReadPcn;
  payor_type: PayorTypeEnum;
  payor_id: number;
}

/**
 * PayorTypeEnum class
 */
export type PayorTypeEnum = (typeof PayorTypeEnum)[keyof typeof PayorTypeEnum];

export const PayorTypeEnum = {
  Insurance: "Insurance",
  Coupon: "Coupon",
} as const;

/**
 * Permission schema
 */
export interface Permission {
  user_entity_id: number;
  permission: PermissionEnum;
  permission_id: number;
}

/**
 * PermissionEnum class

If you make any changes, be sure to update seed.py, defaultPermissions.ts,
and make any necessary migrations.
 */
export type PermissionEnum =
  (typeof PermissionEnum)[keyof typeof PermissionEnum];

export const PermissionEnum = {
  patient_360: "patient_360",
  entity_finance: "entity_finance",
  patient_360_analytics: "patient_360_analytics",
  pharmacy_360: "pharmacy_360",
  practice_360: "practice_360",
  fulfillment_360: "fulfillment_360",
  stock_360: "stock_360",
  warehouse_360: "warehouse_360",
  adjust_warehouse: "adjust_warehouse",
  approve_warehouse_po: "approve_warehouse_po",
  sales_360: "sales_360",
  sales_360_approver: "sales_360_approver",
  inventory_360: "inventory_360",
  administrate_legrande: "administrate_legrande",
  catalog: "catalog",
  filter_bypass: "filter_bypass",
  administrate_users: "administrate_users",
} as const;

/**
 * User permissions create schema
 */
export interface PermissionsCreate {
  user_entity_id: number;
  /** List of permissions for the user at this entity */
  permissions: PermissionEnum[];
}

/**
 * Pharmacy KPIs schema
 */
export interface PharmacyKPIs {
  total_suborders: number;
  open_suborders: number;
  total_practices: number;
  total_products: number;
}

/**
 * Current status of the call
 */
export type PhoneCallStatus = CallStatusEnum | null;

/**
 * Call duration in seconds
 */
export type PhoneCallDuration = number | null;

/**
 * Twilio recording SID
 */
export type PhoneCallRecordingSid = string | null;

/**
 * 
            Whether the voicemail has been reviewed (only applicable when
            status=no_answer and a recording is present)
        
 */
export type PhoneCallVoicemailReviewedAt = string | null;

/**
 * Transcription of the call recording
 */
export type PhoneCallTranscription = string | null;

/**
 * AI-generated summary of the call
 */
export type PhoneCallSummary = string | null;

/**
 * When the call started
 */
export type PhoneCallStartedAt = string | null;

/**
 * When the call ended
 */
export type PhoneCallEndedAt = string | null;

/**
 * Twilio parent call SID (client/caller → Twilio)
 */
export type PhoneCallTwilioParentCallSid = string | null;

/**
 * Twilio child call SID (Twilio → patient/advocate)
 */
export type PhoneCallTwilioChildCallSid = string | null;

/**
 * User ID associated with the call
 */
export type PhoneCallUserId = string | null;

/**
 * Cell number the call was transferred to (null if handled in-app)
 */
export type PhoneCallTransferredToPhone = string | null;

/**
 * PhoneCall schema with identifiers
 */
export interface PhoneCall {
  /** Current status of the call */
  status?: PhoneCallStatus;
  /** Call duration in seconds */
  duration?: PhoneCallDuration;
  /** Twilio recording SID */
  recording_sid?: PhoneCallRecordingSid;
  /** 
            Whether the voicemail has been reviewed (only applicable when
            status=no_answer and a recording is present)
         */
  voicemail_reviewed_at?: PhoneCallVoicemailReviewedAt;
  /** Transcription of the call recording */
  transcription?: PhoneCallTranscription;
  /** AI-generated summary of the call */
  summary?: PhoneCallSummary;
  /** When the call started */
  started_at?: PhoneCallStartedAt;
  /** When the call ended */
  ended_at?: PhoneCallEndedAt;
  /** Twilio parent call SID (client/caller → Twilio) */
  twilio_parent_call_sid?: PhoneCallTwilioParentCallSid;
  /** Twilio child call SID (Twilio → patient/advocate) */
  twilio_child_call_sid?: PhoneCallTwilioChildCallSid;
  /** Unique identifier for the phone call */
  phone_call_id: number;
  /** Patient's phone number. May be non-US or 'Anonymous' */
  patient_phone: string;
  /** Entity's Twilio phone number */
  entity_phone: string;
  /** Entity ID associated with the phone call */
  entity_id: number;
  /** User ID associated with the call */
  user_id?: PhoneCallUserId;
  /** Direction of the call (inbound/outbound) */
  direction: CallDirectionEnum;
  /** Cell number the call was transferred to (null if handled in-app) */
  transferred_to_phone?: PhoneCallTransferredToPhone;
}

/**
 * Current status of the call
 */
export type PhoneCallDetailStatus = CallStatusEnum | null;

/**
 * Call duration in seconds
 */
export type PhoneCallDetailDuration = number | null;

/**
 * Twilio recording SID
 */
export type PhoneCallDetailRecordingSid = string | null;

/**
 * 
            Whether the voicemail has been reviewed (only applicable when
            status=no_answer and a recording is present)
        
 */
export type PhoneCallDetailVoicemailReviewedAt = string | null;

/**
 * Transcription of the call recording
 */
export type PhoneCallDetailTranscription = string | null;

/**
 * AI-generated summary of the call
 */
export type PhoneCallDetailSummary = string | null;

/**
 * When the call started
 */
export type PhoneCallDetailStartedAt = string | null;

/**
 * When the call ended
 */
export type PhoneCallDetailEndedAt = string | null;

/**
 * Twilio parent call SID (client/caller → Twilio)
 */
export type PhoneCallDetailTwilioParentCallSid = string | null;

/**
 * Twilio child call SID (Twilio → patient/advocate)
 */
export type PhoneCallDetailTwilioChildCallSid = string | null;

/**
 * User ID associated with the call
 */
export type PhoneCallDetailUserId = string | null;

/**
 * Cell number the call was transferred to (null if handled in-app)
 */
export type PhoneCallDetailTransferredToPhone = string | null;

/**
 * User who handled the call
 */
export type PhoneCallDetailUser = UserName | null;

/**
 * PhoneCall schema with full details including hold events.
 */
export interface PhoneCallDetail {
  /** Current status of the call */
  status?: PhoneCallDetailStatus;
  /** Call duration in seconds */
  duration?: PhoneCallDetailDuration;
  /** Twilio recording SID */
  recording_sid?: PhoneCallDetailRecordingSid;
  /** 
            Whether the voicemail has been reviewed (only applicable when
            status=no_answer and a recording is present)
         */
  voicemail_reviewed_at?: PhoneCallDetailVoicemailReviewedAt;
  /** Transcription of the call recording */
  transcription?: PhoneCallDetailTranscription;
  /** AI-generated summary of the call */
  summary?: PhoneCallDetailSummary;
  /** When the call started */
  started_at?: PhoneCallDetailStartedAt;
  /** When the call ended */
  ended_at?: PhoneCallDetailEndedAt;
  /** Twilio parent call SID (client/caller → Twilio) */
  twilio_parent_call_sid?: PhoneCallDetailTwilioParentCallSid;
  /** Twilio child call SID (Twilio → patient/advocate) */
  twilio_child_call_sid?: PhoneCallDetailTwilioChildCallSid;
  /** Unique identifier for the phone call */
  phone_call_id: number;
  /** Patient's phone number. May be non-US or 'Anonymous' */
  patient_phone: string;
  /** Entity's Twilio phone number */
  entity_phone: string;
  /** Entity ID associated with the phone call */
  entity_id: number;
  /** User ID associated with the call */
  user_id?: PhoneCallDetailUserId;
  /** Direction of the call (inbound/outbound) */
  direction: CallDirectionEnum;
  /** Cell number the call was transferred to (null if handled in-app) */
  transferred_to_phone?: PhoneCallDetailTransferredToPhone;
  /** Patients associated with this call */
  phone_call_patients: PhoneCallPatientRead[];
  /** When the call record was created */
  created_at: string;
  /** Entity associated with the call */
  entity: Entity;
  /** User who handled the call */
  user?: PhoneCallDetailUser;
  /** Hold events during the call */
  hold_events: PhoneCallHoldEvent[];
  /** Recording pause events during the call */
  recording_pause_events: PhoneCallRecordingPauseEvent[];
  /** History of users who handled this call */
  user_history?: PhoneCallUserHistory[];
}

/**
 * When the call was resumed (null if still on hold)
 */
export type PhoneCallHoldEventHoldEndedAt = string | null;

/**
 * Duration of hold in seconds (computed when resumed)
 */
export type PhoneCallHoldEventDuration = number | null;

/**
 * PhoneCallHoldEvent schema with identifiers
 */
export interface PhoneCallHoldEvent {
  /** Phone call ID to place on hold */
  phone_call_id: number;
  /** When the call was placed on hold */
  hold_started_at: string;
  /** When the call was resumed (null if still on hold) */
  hold_ended_at?: PhoneCallHoldEventHoldEndedAt;
  /** Duration of hold in seconds (computed when resumed) */
  duration?: PhoneCallHoldEventDuration;
  /** Unique identifier for the hold event */
  phone_call_hold_event_id: number;
}

/**
 * PhoneCallPatient read schema with patient data
 */
export interface PhoneCallPatientRead {
  /** Phone Call ID */
  phone_call_id: number;
  /** Patient ID */
  patient_id: string;
  patient: UserWithPhoneType;
}

/**
 * When the recording was resumed (null if still paused)
 */
export type PhoneCallRecordingPauseEventResumedAt = string | null;

/**
 * Duration of recording pause in seconds (computed when resumed)
 */
export type PhoneCallRecordingPauseEventDuration = number | null;

/**
 * PhoneCallRecordingPauseEvent schema with identifiers
 */
export interface PhoneCallRecordingPauseEvent {
  /** Phone call ID whose recording was paused */
  phone_call_id: number;
  /** When the recording was paused */
  paused_at: string;
  /** When the recording was resumed (null if still paused) */
  resumed_at?: PhoneCallRecordingPauseEventResumedAt;
  /** Duration of recording pause in seconds (computed when resumed) */
  duration?: PhoneCallRecordingPauseEventDuration;
  /** Unique identifier for the recording pause event */
  phone_call_recording_pause_event_id: number;
}

/**
 * How long they handled the call before transfer
 */
export type PhoneCallUserHistoryDurationSeconds = number | null;

/**
 * History entry for a user who handled a phone call.
 */
export interface PhoneCallUserHistory {
  /** User who handled the call */
  user: UserName;
  /** When the user was assigned to the call */
  assigned_at: string;
  /** How long they handled the call before transfer */
  duration_seconds?: PhoneCallUserHistoryDurationSeconds;
}

/**
 * Current status of the call
 */
export type PhoneCallWithPatientsStatus = CallStatusEnum | null;

/**
 * Call duration in seconds
 */
export type PhoneCallWithPatientsDuration = number | null;

/**
 * Twilio recording SID
 */
export type PhoneCallWithPatientsRecordingSid = string | null;

/**
 * 
            Whether the voicemail has been reviewed (only applicable when
            status=no_answer and a recording is present)
        
 */
export type PhoneCallWithPatientsVoicemailReviewedAt = string | null;

/**
 * Transcription of the call recording
 */
export type PhoneCallWithPatientsTranscription = string | null;

/**
 * AI-generated summary of the call
 */
export type PhoneCallWithPatientsSummary = string | null;

/**
 * When the call started
 */
export type PhoneCallWithPatientsStartedAt = string | null;

/**
 * When the call ended
 */
export type PhoneCallWithPatientsEndedAt = string | null;

/**
 * Twilio parent call SID (client/caller → Twilio)
 */
export type PhoneCallWithPatientsTwilioParentCallSid = string | null;

/**
 * Twilio child call SID (Twilio → patient/advocate)
 */
export type PhoneCallWithPatientsTwilioChildCallSid = string | null;

/**
 * User ID associated with the call
 */
export type PhoneCallWithPatientsUserId = string | null;

/**
 * Cell number the call was transferred to (null if handled in-app)
 */
export type PhoneCallWithPatientsTransferredToPhone = string | null;

/**
 * PhoneCall schema with related patient and entity data for list views.
 */
export interface PhoneCallWithPatients {
  /** Current status of the call */
  status?: PhoneCallWithPatientsStatus;
  /** Call duration in seconds */
  duration?: PhoneCallWithPatientsDuration;
  /** Twilio recording SID */
  recording_sid?: PhoneCallWithPatientsRecordingSid;
  /** 
            Whether the voicemail has been reviewed (only applicable when
            status=no_answer and a recording is present)
         */
  voicemail_reviewed_at?: PhoneCallWithPatientsVoicemailReviewedAt;
  /** Transcription of the call recording */
  transcription?: PhoneCallWithPatientsTranscription;
  /** AI-generated summary of the call */
  summary?: PhoneCallWithPatientsSummary;
  /** When the call started */
  started_at?: PhoneCallWithPatientsStartedAt;
  /** When the call ended */
  ended_at?: PhoneCallWithPatientsEndedAt;
  /** Twilio parent call SID (client/caller → Twilio) */
  twilio_parent_call_sid?: PhoneCallWithPatientsTwilioParentCallSid;
  /** Twilio child call SID (Twilio → patient/advocate) */
  twilio_child_call_sid?: PhoneCallWithPatientsTwilioChildCallSid;
  /** Unique identifier for the phone call */
  phone_call_id: number;
  /** Patient's phone number. May be non-US or 'Anonymous' */
  patient_phone: string;
  /** Entity's Twilio phone number */
  entity_phone: string;
  /** Entity ID associated with the phone call */
  entity_id: number;
  /** User ID associated with the call */
  user_id?: PhoneCallWithPatientsUserId;
  /** Direction of the call (inbound/outbound) */
  direction: CallDirectionEnum;
  /** Cell number the call was transferred to (null if handled in-app) */
  transferred_to_phone?: PhoneCallWithPatientsTransferredToPhone;
  /** Patients associated with this call */
  phone_call_patients: PhoneCallPatientRead[];
  /** When the call record was created */
  created_at: string;
}

/**
 * PhoneTypeEnum class
 */
export type PhoneTypeEnum = (typeof PhoneTypeEnum)[keyof typeof PhoneTypeEnum];

export const PhoneTypeEnum = {
  Mobile: "Mobile",
  Landline: "Landline",
  VoIP: "VoIP",
  Other: "Other",
} as const;

/**
 * Response schema for Priority Commerce vaulting session
 */
export interface PriorityClientSecretResponse {
  client_secret: string;
  priority_customer_id: number;
  priority_business_id: string;
}

export type ProductNickname = string | null;

export type ProductBrochureUrl = string | null;

export type ProductCampaignDuration = number | null;

export type ProductInstructionsUrl = string | null;

export type ProductDaySupply = number | null;

/**
 * Product schema
 */
export interface Product {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_price: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: ProductNickname;
  entity_id: number;
  catalog_product_id: number;
  brochure_url?: ProductBrochureUrl;
  is_campaign_enabled?: boolean;
  campaign_duration?: ProductCampaignDuration;
  instructions_url?: ProductInstructionsUrl;
  day_supply?: ProductDaySupply;
  product_id: number;
  catalog_product: CatalogProductRead;
  /** Formatted product display name */
  display_name: string;
}

/**
 * ProductBase create schema
 */
export interface ProductBaseCreate {
  name: string;
  product_type: ProductTypeEnum;
  treatment_id: number;
  /** Chronicity of the condition this product treats */
  chronicity: ChronicityEnum;
}

/**
 * ProductBase read schema
 */
export interface ProductBaseRead {
  name: string;
  product_type: ProductTypeEnum;
  treatment_id: number;
  /** Chronicity of the condition this product treats */
  chronicity: ChronicityEnum;
  product_base_id: number;
  /** Treatment information */
  treatment: TreatmentRead;
}

/**
 * ProductBrand create schema
 */
export interface ProductBrandCreate {
  /** Name of the product brand */
  name: string;
}

/**
 * ProductBrand read schema
 */
export interface ProductBrandRead {
  /** Name of the product brand */
  name: string;
  /** Unique identifier for the product brand */
  product_brand_id: number;
}

/**
 * ProductColorEnum class
 */
export type ProductColorEnum =
  (typeof ProductColorEnum)[keyof typeof ProductColorEnum];

export const ProductColorEnum = {
  White: "White",
  Cream: "Cream",
  Black: "Black",
  Blue: "Blue",
  Brown: "Brown",
  Clear: "Clear",
  Gold: "Gold",
  Gray: "Gray",
  Green: "Green",
  Orange: "Orange",
  Pink: "Pink",
  Purple: "Purple",
  Red: "Red",
  Silver: "Silver",
  Yellow: "Yellow",
} as const;

export type ProductCreateNickname = string | null;

export type ProductCreateBrochureUrl = string | null;

export type ProductCreateCampaignDuration = number | null;

export type ProductCreateInstructionsUrl = string | null;

export type ProductCreateDaySupply = number | null;

/**
 * Product create schema
 */
export interface ProductCreate {
  entity_price: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: ProductCreateNickname;
  entity_id: number;
  catalog_product_id: number;
  brochure_url?: ProductCreateBrochureUrl;
  is_campaign_enabled?: boolean;
  campaign_duration?: ProductCreateCampaignDuration;
  instructions_url?: ProductCreateInstructionsUrl;
  day_supply?: ProductCreateDaySupply;
}

/**
 * Product fulfiller schema
 */
export interface ProductFulfiller {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  product_fulfiller_id: number;
  product_id: number;
  entity_id: number;
  is_default?: boolean;
  entity: EntityName;
}

/**
 * Product fulfiller create schema
 */
export interface ProductFulfillerCreate {
  product_id: number;
  entity_id: number;
  is_default?: boolean;
}

export type ProductFulfillerUpdateDefaultEntityId = number | null;

/**
 * Desired fulfiller state for a product
 */
export interface ProductFulfillerUpdate {
  entity_ids: number[];
  default_entity_id?: ProductFulfillerUpdateDefaultEntityId;
}

export type ProductReadNickname = string | null;

export type ProductReadBrochureUrl = string | null;

export type ProductReadCampaignDuration = number | null;

export type ProductReadInstructionsUrl = string | null;

export type ProductReadDaySupply = number | null;

/**
 * Product read schema
 */
export interface ProductRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_price: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: ProductReadNickname;
  entity_id: number;
  catalog_product_id: number;
  brochure_url?: ProductReadBrochureUrl;
  is_campaign_enabled?: boolean;
  campaign_duration?: ProductReadCampaignDuration;
  instructions_url?: ProductReadInstructionsUrl;
  day_supply?: ProductReadDaySupply;
  product_id: number;
  catalog_product: CatalogProductRead;
  /** Formatted product display name */
  display_name: string;
  entity: EntityName;
  fulfillers?: ProductFulfiller[];
}

/**
 * ProductTypeEnum class
 */
export type ProductTypeEnum =
  (typeof ProductTypeEnum)[keyof typeof ProductTypeEnum];

export const ProductTypeEnum = {
  RX: "RX",
  OTC: "OTC",
  Kit: "Kit",
  Accessory: "Accessory",
  Packing_Material: "Packing Material",
} as const;

/**
 * ProductUnitEnum class
 */
export type ProductUnitEnum =
  (typeof ProductUnitEnum)[keyof typeof ProductUnitEnum];

export const ProductUnitEnum = {
  mL: "mL",
  mg: "mg",
  g: "g",
  oz: "oz",
  ct: "ct",
  in: "in",
} as const;

export type ProductUpdateNickname = string | null;

export type ProductUpdateBrochureUrl = string | null;

export type ProductUpdateCampaignDuration = number | null;

export type ProductUpdateInstructionsUrl = string | null;

export type ProductUpdateDaySupply = number | null;

/**
 * Product create schema
 */
export interface ProductUpdate {
  entity_price: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: ProductUpdateNickname;
  entity_id: number;
  catalog_product_id: number;
  brochure_url?: ProductUpdateBrochureUrl;
  is_campaign_enabled?: boolean;
  campaign_duration?: ProductUpdateCampaignDuration;
  instructions_url?: ProductUpdateInstructionsUrl;
  day_supply?: ProductUpdateDaySupply;
  product_id: number;
}

/**
 * Quarantined Product create schema
 */
export interface QuarantinedProductCreate {
  product_id: number;
  lot_number: string;
  recall_date: string;
  status: QuarantinedProductEnum;
  reason: string;
}

/**
 * QuarantinedProductEnum class
 */
export type QuarantinedProductEnum =
  (typeof QuarantinedProductEnum)[keyof typeof QuarantinedProductEnum];

export const QuarantinedProductEnum = {
  Quarantined: "Quarantined",
  Disposed: "Disposed",
} as const;

/**
 * Product read schema
 */
export interface QuarantinedProductRead {
  product_id: number;
  lot_number: string;
  recall_date: string;
  status: QuarantinedProductEnum;
  reason: string;
  product: Product;
  created_at: string;
}

/**
 * RecallClassEnum class

FDA drug recall classification (severity).
 */
export type RecallClassEnum =
  (typeof RecallClassEnum)[keyof typeof RecallClassEnum];

export const RecallClassEnum = {
  Class_I: "Class I",
  Class_II: "Class II",
  Class_III: "Class III",
} as const;

export type RecallEventCreateLotNumber = string | null;

export type RecallEventCreateReason = string | null;

export type RecallEventCreateNotes = string | null;

export type RecallEventCreateRecallLetterUrl = string | null;

/**
 * Recall event create schema
 */
export interface RecallEventCreate {
  inventory_id: string;
  lot_number?: RecallEventCreateLotNumber;
  severity: RecallClassEnum;
  recall_date: string;
  reason?: RecallEventCreateReason;
  notes?: RecallEventCreateNotes;
  recall_letter_url?: RecallEventCreateRecallLetterUrl;
}

export type RecallEventDetailReadLotNumber = string | null;

export type RecallEventDetailReadReason = string | null;

export type RecallEventDetailReadNotes = string | null;

export type RecallEventDetailReadSignedUrl = string | null;

/**
 * Recall event detail, including the signed letter URL
 */
export interface RecallEventDetailRead {
  recall_event_id: number;
  inventory_id: string;
  lot_number: RecallEventDetailReadLotNumber;
  severity: RecallClassEnum;
  recall_date: string;
  product_name: string;
  entity_name: string;
  created_at: string;
  entity_id: number;
  reason: RecallEventDetailReadReason;
  notes: RecallEventDetailReadNotes;
  signed_url: RecallEventDetailReadSignedUrl;
}

export type RecallEventListReadLotNumber = string | null;

/**
 * Recall event row for the list page
 */
export interface RecallEventListRead {
  recall_event_id: number;
  inventory_id: string;
  lot_number: RecallEventListReadLotNumber;
  severity: RecallClassEnum;
  recall_date: string;
  product_name: string;
  entity_name: string;
  created_at: string;
}

export type RecallPatientReadEmail = string | null;

export type RecallPatientReadPhone = string | null;

export type RecallPatientReadRxNumber = string | null;

export type RecallPatientReadDoctorNpi = string | null;

/**
 * A patient who received product from a recalled lot
 */
export interface RecallPatientRead {
  patient_id: string;
  first_name: string;
  last_name: string;
  date_of_birth: string;
  email: RecallPatientReadEmail;
  phone: RecallPatientReadPhone;
  order_id: string;
  rx_number: RecallPatientReadRxNumber;
  quantity: number;
  dispensed_at: string;
  prescribed_at: string;
  doctor_name: string;
  doctor_npi: RecallPatientReadDoctorNpi;
}

/**
 * Revenue breakdown by product
 */
export interface RevenueBreakdown {
  product_id: number;
  product_name: string;
  revenue: number;
  units: number;
  date: string;
}

/**
 * Revenue by user schema (doctor or creator)
 */
export interface RevenueByUser {
  self_fulfilled: number;
  externally_fulfilled: number;
  user_id: string;
  first_name: string;
  last_name: string;
}

/**
 * Revenue per month schema
 */
export interface RevenuePerMonth {
  date: string;
  self_fulfilled: number;
  externally_fulfilled: number;
  cumulative_self_fulfilled: number;
  cumulative_externally_fulfilled: number;
}

/**
 * Revenue per month year-to-date schema
 */
export interface RevenuePerMonthYTD {
  date: string;
  this_year: number;
  last_year: number;
}

/**
 * SalesAdvisorEnum class
 */
export type SalesAdvisorEnum =
  (typeof SalesAdvisorEnum)[keyof typeof SalesAdvisorEnum];

export const SalesAdvisorEnum = {
  Primary: "Primary",
  Secondary: "Secondary",
} as const;

/**
 * Ensure each sample SKU has a warehouse + orderable bulk product for the entity.
 */
export interface SampleProvision {
  /** Recipient entity the samples are for */
  entity_id: number;
  /** @minItems 1 */
  lines: SampleProvisionLine[];
}

/**
 * A sample SKU to provision for an entity.
 */
export interface SampleProvisionLine {
  /** Sample catalog product */
  catalog_product_id: number;
  /**
   * Entity price for the provisioned sample
   * @minimum 0
   */
  unit_price?: number;
}

/**
 * The provisioned bulk product for a sample SKU.
 */
export interface SampleProvisionResult {
  catalog_product_id: number;
  bulk_product_id: number;
}

/**
 * Sankey distribution schema
 */
export interface SankeyDistribution {
  data: SankeyNode[];
  links: SankeyLink[];
}

/**
 * Sankey link schema
 */
export interface SankeyLink {
  source: string;
  target: string;
  value: number;
}

/**
 * Sankey node schema
 */
export interface SankeyNode {
  name: string;
}

/**
 * Entities that can order from this entity
 */
export interface SeenByEntities {
  seen_by_entity_id: number;
  can_see_entity_id: number;
  seen_by_entity: EntityName;
}

/**
 * Body for PATCH /users/me/profile.
 */
export interface SelfProfileUpdate {
  /**
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
}

/**
 * SentByEnum class
 */
export type SentByEnum = (typeof SentByEnum)[keyof typeof SentByEnum];

export const SentByEnum = {
  patient: "patient",
  staff: "staff",
  system: "system",
} as const;

/**
 * Service schema
 */
export interface Service {
  /** ID of the entity */
  entity_id: number;
  /** Service associated with the entity */
  service: ServiceEnum;
}

/**
 * Service create schema
 */
export interface ServiceCreate {
  /** ID of the entity */
  entity_id: number;
  /** List of services associated with the entity */
  services: ServiceEnum[];
}

/**
 * ServiceEnum class

Services (product offerings) that an entity may have based on their subscription tier.

These can also be seen as entity level permissions or features.
 */
export type ServiceEnum = (typeof ServiceEnum)[keyof typeof ServiceEnum];

export const ServiceEnum = {
  patient_360: "patient_360",
  pharmacy_360: "pharmacy_360",
  practice_360: "practice_360",
  fulfillment_360: "fulfillment_360",
  stock_360: "stock_360",
  warehouse_360: "warehouse_360",
  sales_360: "sales_360",
  inventory_360: "inventory_360",
  admin: "admin",
} as const;

/**
 * Unique identifier for the ShipEngine label
 */
export type ShipEngineLabelBaseShipengineLabelId = string | null;

/**
 * Unique identifier for the shipment
 */
export type ShipEngineLabelBaseShipmentId = string | null;

/**
 * Cost of the shipment
 */
export type ShipEngineLabelBaseShipmentCost = number | null;

/**
 * Service code for the shipment (e.g., Ground, 2-Day Air)
 */
export type ShipEngineLabelBaseServiceCode =
  (typeof ShipEngineLabelBaseServiceCode)[keyof typeof ShipEngineLabelBaseServiceCode];

export const ShipEngineLabelBaseServiceCode = {
  usps_priority_mail: "usps_priority_mail",
  usps_ground_advantage: "usps_ground_advantage",
  usps_priority_mail_express: "usps_priority_mail_express",
  fedex_ground: "fedex_ground",
  fedex_home_delivery: "fedex_home_delivery",
  fedex_express_saver: "fedex_express_saver",
  fedex_2day: "fedex_2day",
  fedex_2day_am: "fedex_2day_am",
  fedex_standard_overnight: "fedex_standard_overnight",
  fedex_priority_overnight: "fedex_priority_overnight",
  ups_ground: "ups_ground",
  ups_3_day_select: "ups_3_day_select",
  ups_2nd_day_air: "ups_2nd_day_air",
  ups_2nd_day_air_am: "ups_2nd_day_air_am",
  ups_next_day_air_saver: "ups_next_day_air_saver",
  ups_next_day_air: "ups_next_day_air",
  ups_next_day_air_early_am: "ups_next_day_air_early_am",
} as const;

/**
 * ShipEngine carrier account ID
 */
export type ShipEngineLabelBaseShipengineCarrierId = string | null;

/**
 * URL to download the shipping label
 */
export type ShipEngineLabelBaseLabelDownloadUrl = string | null;

/**
 * Ship date of the shipment
 */
export type ShipEngineLabelBaseShipDate = string | null;

/**
 * Estimated delivery date
 */
export type ShipEngineLabelBaseEstimatedDeliveryDate = string | null;

/**
 * Actual delivery date
 */
export type ShipEngineLabelBaseActualDeliveryDate = string | null;

/**
 * ShipEngineLabelBase schema
 */
export interface ShipEngineLabelBase {
  /** Unique identifier for the ShipEngine label */
  shipengine_label_id?: ShipEngineLabelBaseShipengineLabelId;
  /** Unique identifier for the shipment */
  shipment_id?: ShipEngineLabelBaseShipmentId;
  /** Cost of the shipment */
  shipment_cost?: ShipEngineLabelBaseShipmentCost;
  /**
   * Tracking number for the shipment
   * @minLength 5
   */
  tracking_number: string;
  /** Carrier for the shipment (e.g., Fedex, UPS) */
  carrier_code: CarrierCodesEnum;
  /** Service code for the shipment (e.g., Ground, 2-Day Air) */
  service_code: ShipEngineLabelBaseServiceCode;
  /** ShipEngine carrier account ID */
  shipengine_carrier_id?: ShipEngineLabelBaseShipengineCarrierId;
  /** URL to download the shipping label */
  label_download_url?: ShipEngineLabelBaseLabelDownloadUrl;
  /** Ship date of the shipment */
  ship_date?: ShipEngineLabelBaseShipDate;
  /** Estimated delivery date */
  estimated_delivery_date?: ShipEngineLabelBaseEstimatedDeliveryDate;
  /** Actual delivery date */
  actual_delivery_date?: ShipEngineLabelBaseActualDeliveryDate;
}

/**
 * Service code for the shipment (e.g., Ground, 2-Day Air)
 */
export type ShipEngineRateServiceCode =
  (typeof ShipEngineRateServiceCode)[keyof typeof ShipEngineRateServiceCode];

export const ShipEngineRateServiceCode = {
  usps_priority_mail: "usps_priority_mail",
  usps_ground_advantage: "usps_ground_advantage",
  usps_priority_mail_express: "usps_priority_mail_express",
  fedex_ground: "fedex_ground",
  fedex_home_delivery: "fedex_home_delivery",
  fedex_express_saver: "fedex_express_saver",
  fedex_2day: "fedex_2day",
  fedex_2day_am: "fedex_2day_am",
  fedex_standard_overnight: "fedex_standard_overnight",
  fedex_priority_overnight: "fedex_priority_overnight",
  ups_ground: "ups_ground",
  ups_3_day_select: "ups_3_day_select",
  ups_2nd_day_air: "ups_2nd_day_air",
  ups_2nd_day_air_am: "ups_2nd_day_air_am",
  ups_next_day_air_saver: "ups_next_day_air_saver",
  ups_next_day_air: "ups_next_day_air",
  ups_next_day_air_early_am: "ups_next_day_air_early_am",
} as const;

/**
 * Estimated delivery date
 */
export type ShipEngineRateEstimatedDeliveryDate = string | null;

/**
 * List of warning messages
 */
export type ShipEngineRateWarningMessages = string[] | null;

/**
 * List of error messages
 */
export type ShipEngineRateErrorMessages = string[] | null;

/**
 * ShipEngine rate schema
 */
export interface ShipEngineRate {
  /** Unique identifier for the rate */
  rate_id: string;
  /** Total rate for the shipment */
  total_rate: number;
  /** Service code for the shipment (e.g., Ground, 2-Day Air) */
  service_code: ShipEngineRateServiceCode;
  /** Service type for the shipment */
  service_type: string;
  /** Carrier code for the shipment */
  carrier_code: CarrierCodesEnum;
  /** Carrier name for the shipment */
  carrier_friendly_name: string;
  /** Estimated delivery date */
  estimated_delivery_date?: ShipEngineRateEstimatedDeliveryDate;
  /** List of warning messages */
  warning_messages?: ShipEngineRateWarningMessages;
  /** List of error messages */
  error_messages?: ShipEngineRateErrorMessages;
}

export type ShipEngineRateErrorFieldName = string | null;

/**
 * ShipEngine rate error schema
 */
export interface ShipEngineRateError {
  error_code: string;
  message: string;
  field_name?: ShipEngineRateErrorFieldName;
}

/**
 * Dimensions of the package
 */
export type ShipEngineRateRequestDimensions = PackageDimension | null;

export type ShipEngineRateRequestServiceCodesAnyOfItem =
  (typeof ShipEngineRateRequestServiceCodesAnyOfItem)[keyof typeof ShipEngineRateRequestServiceCodesAnyOfItem];

export const ShipEngineRateRequestServiceCodesAnyOfItem = {
  usps_priority_mail: "usps_priority_mail",
  usps_ground_advantage: "usps_ground_advantage",
  usps_priority_mail_express: "usps_priority_mail_express",
  fedex_ground: "fedex_ground",
  fedex_home_delivery: "fedex_home_delivery",
  fedex_express_saver: "fedex_express_saver",
  fedex_2day: "fedex_2day",
  fedex_2day_am: "fedex_2day_am",
  fedex_standard_overnight: "fedex_standard_overnight",
  fedex_priority_overnight: "fedex_priority_overnight",
  ups_ground: "ups_ground",
  ups_3_day_select: "ups_3_day_select",
  ups_2nd_day_air: "ups_2nd_day_air",
  ups_2nd_day_air_am: "ups_2nd_day_air_am",
  ups_next_day_air_saver: "ups_next_day_air_saver",
  ups_next_day_air: "ups_next_day_air",
  ups_next_day_air_early_am: "ups_next_day_air_early_am",
} as const;

/**
 * List of service codes to get rates for. Defaults to all
 */
export type ShipEngineRateRequestServiceCodes =
  | ShipEngineRateRequestServiceCodesAnyOfItem[]
  | null;

/**
 * ShipEngine rate request schema
 */
export interface ShipEngineRateRequest {
  /** Weight of the package */
  weight: PackageWeight;
  /** Dimensions of the package */
  dimensions: ShipEngineRateRequestDimensions;
  /** List of service codes to get rates for. Defaults to all */
  service_codes?: ShipEngineRateRequestServiceCodes;
  /** Entity ID to use to get shipengine accounts for rates check */
  shipengine_entity_id: number;
}

/**
 * ShipEngine rate response schema
 */
export interface ShipEngineRateResponse {
  /** List of shipping rates */
  rates: ShipEngineRate[];
  /** Errors while fetching rates */
  errors: ShipEngineRateError[];
}

export type ShipEngineTrackDataShipDate = string | null;

export type ShipEngineTrackDataEstimatedDeliveryDate = string | null;

export type ShipEngineTrackDataActualDeliveryDate = string | null;

/**
 * Schema for grabbing the response from ShipEngine tracking API
 */
export interface ShipEngineTrackData {
  tracking_number: string;
  status_code: string;
  ship_date: ShipEngineTrackDataShipDate;
  estimated_delivery_date: ShipEngineTrackDataEstimatedDeliveryDate;
  actual_delivery_date: ShipEngineTrackDataActualDeliveryDate;
  events: ShippingUpdateBase[];
}

/**
 * Schema for grabbing the response from ShipEngine tracking API
 */
export interface ShipEngineTrackResponse {
  data: ShipEngineTrackData;
}

/**
 * Base schema for ShipEngine Carrier
 */
export interface ShipengineCarrierBase {
  /** The unique identifier for the carrier from Shipengine. */
  shipengine_carrier_id: string;
  /** The carrier code. */
  carrier_code: CarrierCodesEnum;
  /** The unique identifier for the entity associated with this carrier. */
  entity_id: number;
  /** Indicates if the carrier is globally available to all entities. */
  globally_available: boolean;
}

/**
 * Read schema for Shipengine Carrier with entity name
 */
export interface ShipengineCarrierRead {
  /** The unique identifier for the carrier from Shipengine. */
  shipengine_carrier_id: string;
  /** The carrier code. */
  carrier_code: CarrierCodesEnum;
  /** The unique identifier for the entity associated with this carrier. */
  entity_id: number;
  /** Indicates if the carrier is globally available to all entities. */
  globally_available: boolean;
  /** The name of the entity associated with this carrier. */
  entity: EntityName;
}

export type ShippingUpdateBaseCityLocality = string | null;

export type ShippingUpdateBaseStateProvince = string | null;

export type ShippingUpdateBasePostalCode = string | null;

export type ShippingUpdateBaseCountryCode = string | null;

export type ShippingUpdateBaseCompanyName = string | null;

export type ShippingUpdateBaseSigner = string | null;

/**
 * Base schema for ShippingUpdate tracking events
 */
export interface ShippingUpdateBase {
  occurred_at: string;
  description: string;
  city_locality?: ShippingUpdateBaseCityLocality;
  state_province?: ShippingUpdateBaseStateProvince;
  postal_code?: ShippingUpdateBasePostalCode;
  country_code?: ShippingUpdateBaseCountryCode;
  company_name?: ShippingUpdateBaseCompanyName;
  signer?: ShippingUpdateBaseSigner;
}

export type ShippingUpdateReadCityLocality = string | null;

export type ShippingUpdateReadStateProvince = string | null;

export type ShippingUpdateReadPostalCode = string | null;

export type ShippingUpdateReadCountryCode = string | null;

export type ShippingUpdateReadCompanyName = string | null;

export type ShippingUpdateReadSigner = string | null;

/**
 * Schema for reading ShippingUpdate tracking events
 */
export interface ShippingUpdateRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  occurred_at: string;
  description: string;
  city_locality?: ShippingUpdateReadCityLocality;
  state_province?: ShippingUpdateReadStateProvince;
  postal_code?: ShippingUpdateReadPostalCode;
  country_code?: ShippingUpdateReadCountryCode;
  company_name?: ShippingUpdateReadCompanyName;
  signer?: ShippingUpdateReadSigner;
  shipping_update_id: number;
  label_id: number;
}

/**
 * ShippingWeightUnitEnum class
 */
export type ShippingWeightUnitEnum =
  (typeof ShippingWeightUnitEnum)[keyof typeof ShippingWeightUnitEnum];

export const ShippingWeightUnitEnum = {
  ounce: "ounce",
  pound: "pound",
  gram: "gram",
  kilogram: "kilogram",
} as const;

export type StockOrderTargetFulfillBy = string | null;

export type StockOrderChargedAt = string | null;

export type StockOrderFulfilledAt = string | null;

export type StockOrderConfirmedAt = string | null;

export type StockOrderInvoiceSentAt = string | null;

export type StockOrderInvoiceSentTo = string[] | null;

/**
 * StockOrder schema
 */
export interface StockOrder {
  owner_id: number;
  fulfiller_id: number;
  status: StockOrderStatusEnum;
  target_fulfill_by: StockOrderTargetFulfillBy;
  charged_at: StockOrderChargedAt;
  total_price: number;
  stock_order_id: string;
  fulfilled_at: StockOrderFulfilledAt;
  confirmed_at: StockOrderConfirmedAt;
  invoice_sent_at: StockOrderInvoiceSentAt;
  invoice_sent_to?: StockOrderInvoiceSentTo;
}

export type StockOrderBulkProductReadWholesalePrice = number | null;

export type StockOrderBulkProductReadNickname = string | null;

/**
 * Bulk Products with warehouse vendors specifically for Stock 360 use
 */
export interface StockOrderBulkProductRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  entity_id: number;
  catalog_product_id: number;
  payment_collector_id: number;
  is_orderable: boolean;
  entity_price: number;
  wholesale_price?: StockOrderBulkProductReadWholesalePrice;
  /**
   * @minimum 0
   * @maximum 100
   */
  sales_tax_rate: number;
  nickname?: StockOrderBulkProductReadNickname;
  bulk_product_id: number;
  catalog_product: CatalogProductWithWarehouse;
  payment_collector: EntityName;
  /** Formatted product display name */
  display_name: string;
  entity: EntityName;
}

/**
 * Warehouse order contents create schema
 */
export interface StockOrderContentsCreate {
  batches: BatchCreate[];
}

export type StockOrderCreateTargetFulfillBy = string | null;

export type StockOrderCreateChargedAt = string | null;

/**
 * Warehouse order create schema
 */
export interface StockOrderCreate {
  owner_id: number;
  fulfiller_id: number;
  status: StockOrderStatusEnum;
  target_fulfill_by: StockOrderCreateTargetFulfillBy;
  charged_at: StockOrderCreateChargedAt;
  total_price: number;
}

export type StockOrderManyReadTargetFulfillBy = string | null;

export type StockOrderManyReadChargedAt = string | null;

export type StockOrderManyReadFulfilledAt = string | null;

export type StockOrderManyReadConfirmedAt = string | null;

export type StockOrderManyReadInvoiceSentAt = string | null;

export type StockOrderManyReadInvoiceSentTo = string[] | null;

/**
 * StockOrder many read schema
 */
export interface StockOrderManyRead {
  owner_id: number;
  fulfiller_id: number;
  status: StockOrderStatusEnum;
  target_fulfill_by: StockOrderManyReadTargetFulfillBy;
  charged_at: StockOrderManyReadChargedAt;
  total_price: number;
  stock_order_id: string;
  fulfilled_at: StockOrderManyReadFulfilledAt;
  confirmed_at: StockOrderManyReadConfirmedAt;
  invoice_sent_at: StockOrderManyReadInvoiceSentAt;
  invoice_sent_to?: StockOrderManyReadInvoiceSentTo;
  owner: EntityName;
  fulfiller: EntityName;
  batches: BatchWithWarehouse[];
}

export type StockOrderReadTargetFulfillBy = string | null;

export type StockOrderReadChargedAt = string | null;

export type StockOrderReadFulfilledAt = string | null;

export type StockOrderReadConfirmedAt = string | null;

export type StockOrderReadInvoiceSentAt = string | null;

export type StockOrderReadInvoiceSentTo = string[] | null;

/**
 * StockOrder read schema
 */
export interface StockOrderRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  owner_id: number;
  fulfiller_id: number;
  status: StockOrderStatusEnum;
  target_fulfill_by: StockOrderReadTargetFulfillBy;
  charged_at: StockOrderReadChargedAt;
  total_price: number;
  stock_order_id: string;
  fulfilled_at: StockOrderReadFulfilledAt;
  confirmed_at: StockOrderReadConfirmedAt;
  invoice_sent_at: StockOrderReadInvoiceSentAt;
  invoice_sent_to?: StockOrderReadInvoiceSentTo;
  owner: EntityName;
  fulfiller: EntityName;
  batches: BatchWithWarehouse[];
  created_by: UserName;
  audit_stock_order: Audit[];
}

/**
 * StockOrderStatusEnum class

Represents the status of a warehouse order.
 */
export type StockOrderStatusEnum =
  (typeof StockOrderStatusEnum)[keyof typeof StockOrderStatusEnum];

export const StockOrderStatusEnum = {
  Draft: "Draft",
  Review: "Review",
  Open: "Open",
  Fulfilled: "Fulfilled",
  Cancelled: "Cancelled",
} as const;

/**
 * Amount of the most recent completed payout
 */
export type StripeBalanceSummaryLastPayoutAmountCents = number | null;

/**
 * Arrival date of the most recent completed payout
 */
export type StripeBalanceSummaryLastPayoutArrivedAt = string | null;

/**
 * Last 4 digits of the connected bank account
 */
export type StripeBalanceSummaryBankAccountLast4 = string | null;

/**
 * Balance and payout summary for a Stripe Connect practice account.
 */
export interface StripeBalanceSummary {
  /** Funds available to pay out */
  available_balance_cents: number;
  /** Funds captured but not yet cleared the processing window (pending to settle) */
  pending_balance_cents: number;
  /** Minimum balance threshold before excess is paid out */
  minimum_balance_cents: number;
  /** Amount of the most recent completed payout */
  last_payout_amount_cents?: StripeBalanceSummaryLastPayoutAmountCents;
  /** Arrival date of the most recent completed payout */
  last_payout_arrived_at?: StripeBalanceSummaryLastPayoutArrivedAt;
  /** Lifetime sum of all completed payouts */
  total_payouts_cents: number;
  /** Last 4 digits of the connected bank account */
  bank_account_last4?: StripeBalanceSummaryBankAccountLast4;
}

/**
 * Human-readable description
 */
export type StripeBalanceTransactionDescription = string | null;

/**
 * Human-readable fee description
 */
export type StripeBalanceTransactionFeeDescription = string | null;

/**
 * A single balance transaction for a Stripe Connect account.
 */
export interface StripeBalanceTransaction {
  /** Stripe balance transaction ID */
  id: string;
  /** Gross amount of the transaction */
  amount_cents: number;
  /** Human-readable description */
  description?: StripeBalanceTransactionDescription;
  /** Fee amount for the transaction */
  fee: number;
  /** Human-readable fee description */
  fee_description?: StripeBalanceTransactionFeeDescription;
  /** Stripe's accounting classification for the transaction */
  reporting_category: string;
  /** Stripe transaction status */
  status: string;
  /** When the transaction occurred */
  created_at: string;
}

/**
 * A paginated page of Stripe balance transactions.
 */
export interface StripeBalanceTransactionPage {
  /** Transactions for the current page */
  items: StripeBalanceTransaction[];
  /** Whether a next page is available */
  has_more: boolean;
}

export type SuborderCreateSuborderId = string | null;

/**
 * Suborder create schema
 */
export interface SuborderCreate {
  suborder_id: SuborderCreateSuborderId;
  dispensing_pharmacy_id: number;
  fulfilling_pharmacy_id: number;
  delivery_method: DeliveryMethodEnum;
  suborder_products: SuborderProductCreate[];
}

export type SuborderManyReadTargetShipBy = string | null;

export type SuborderManyReadChargedAt = string | null;

export type SuborderManyReadChargebackAt = string | null;

export type SuborderManyReadFulfilledAt = string | null;

export type SuborderManyReadDeliveredAt = string | null;

/**
 * Suborder many read schema
 */
export interface SuborderManyRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  order_id: string;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  processing_fee: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  total: number;
  target_ship_by?: SuborderManyReadTargetShipBy;
  status: SuborderStatusEnum;
  suborder_id: string;
  dispensing_pharmacy_id: number;
  fulfilling_pharmacy_id: number;
  delivery_method: DeliveryMethodEnum;
  /** @minimum 0 */
  covered?: number;
  charged_at?: SuborderManyReadChargedAt;
  chargeback_at?: SuborderManyReadChargebackAt;
  fulfilled_at?: SuborderManyReadFulfilledAt;
  delivered_at?: SuborderManyReadDeliveredAt;
  dispensing_pharmacy: Entity;
  fulfilling_pharmacy: Entity;
  order: OrderPatient;
}

/**
 * SuborderNote schema
 */
export interface SuborderNote {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  suborder_id: string;
  note: string;
  suborder_note_id: number;
}

/**
 * SuborderNote create schema
 */
export interface SuborderNoteCreate {
  suborder_id: string;
  note: string;
}

/**
 * SuborderNote read schema
 */
export interface SuborderNoteRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  suborder_id: string;
  note: string;
  suborder_note_id: number;
  updated_by: UserName;
}

export type SuborderOrderSurgeryDate = string | null;

export type SuborderOrderPayment = PatientPayment | null;

export type SuborderOrderPatientPayor = PatientPayor | null;

export type SuborderOrderShippingAddress = PatientAddressRead | null;

/**
 * This is an order schema specifically for sub orders

This schema is used by the sub order schema to avoid recursion errors.

It also removes some fields, like total_price, that we don't want shared with pharmacies.
 */
export interface SuborderOrder {
  surgery_date: SuborderOrderSurgeryDate;
  patient: Patient;
  doctor: DoctorRead;
  practice: Entity;
  payment: SuborderOrderPayment;
  patient_payor: SuborderOrderPatientPayor;
  shipping_address: SuborderOrderShippingAddress;
}

export type SuborderProductBaseInstructions = string | null;

export type SuborderProductBaseExternalRxNumber = string | null;

export type SuborderProductBaseInventoryBatchId = string | null;

export type SuborderProductBaseBundleId = number | null;

/**
 * SuborderProduct base schema
 */
export interface SuborderProductBase {
  product_id: number;
  /** @minimum 0 */
  unit_price: number;
  /** @minimum 0 */
  patient_price: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  quantity: number;
  /** @minimum 0 */
  refills: number;
  instructions?: SuborderProductBaseInstructions;
  external_rx_number?: SuborderProductBaseExternalRxNumber;
  inventory_batch_id?: SuborderProductBaseInventoryBatchId;
  bundle_id?: SuborderProductBaseBundleId;
}

export type SuborderProductCreateInstructions = string | null;

export type SuborderProductCreateExternalRxNumber = string | null;

export type SuborderProductCreateInventoryBatchId = string | null;

export type SuborderProductCreateBundleId = number | null;

export type SuborderProductCreateSuborderProductId = number | null;

/**
 * SuborderProduct create schema
 */
export interface SuborderProductCreate {
  product_id: number;
  /** @minimum 0 */
  unit_price: number;
  /** @minimum 0 */
  patient_price: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  quantity: number;
  /** @minimum 0 */
  refills: number;
  instructions?: SuborderProductCreateInstructions;
  external_rx_number?: SuborderProductCreateExternalRxNumber;
  inventory_batch_id?: SuborderProductCreateInventoryBatchId;
  bundle_id?: SuborderProductCreateBundleId;
  suborder_product_id?: SuborderProductCreateSuborderProductId;
}

export type SuborderProductReadInstructions = string | null;

export type SuborderProductReadExternalRxNumber = string | null;

export type SuborderProductReadInventoryBatchId = string | null;

export type SuborderProductReadBundleId = number | null;

export type SuborderProductReadInventoryBatch = InventoryBatchMinimal | null;

/**
 * SuborderProduct read schema
 */
export interface SuborderProductRead {
  product_id: number;
  /** @minimum 0 */
  unit_price: number;
  /** @minimum 0 */
  patient_price: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  quantity: number;
  /** @minimum 0 */
  refills: number;
  instructions?: SuborderProductReadInstructions;
  external_rx_number?: SuborderProductReadExternalRxNumber;
  inventory_batch_id?: SuborderProductReadInventoryBatchId;
  bundle_id?: SuborderProductReadBundleId;
  suborder_product_id: number;
  suborder_id: string;
  product: Product;
  inventory_batch?: SuborderProductReadInventoryBatch;
}

/**
 * Minimal suborder_product reference for inventory batch logs
 */
export interface SuborderProductRef {
  suborder_product_id: number;
  suborder: InventoryBatchLogSuborder;
}

export type SuborderReadTargetShipBy = string | null;

export type SuborderReadChargedAt = string | null;

export type SuborderReadChargebackAt = string | null;

export type SuborderReadFulfilledAt = string | null;

export type SuborderReadDeliveredAt = string | null;

/**
 * Suborder read schema
 */
export interface SuborderRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  order_id: string;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  processing_fee: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  total: number;
  target_ship_by?: SuborderReadTargetShipBy;
  status: SuborderStatusEnum;
  suborder_id: string;
  dispensing_pharmacy_id: number;
  fulfilling_pharmacy_id: number;
  delivery_method: DeliveryMethodEnum;
  /** @minimum 0 */
  covered?: number;
  charged_at?: SuborderReadChargedAt;
  chargeback_at?: SuborderReadChargebackAt;
  fulfilled_at?: SuborderReadFulfilledAt;
  delivered_at?: SuborderReadDeliveredAt;
  dispensing_pharmacy: Entity;
  fulfilling_pharmacy: Entity;
  suborder_products: SuborderProductRead[];
  suborder_notes: SuborderNoteRead[];
  transactions: TransactionRead[];
  labels: LabelRead[];
  audit_suborder: Audit[];
}

/**
 * SuborderStatusEnum class

Represents the fulfillment status of a suborder
 */
export type SuborderStatusEnum =
  (typeof SuborderStatusEnum)[keyof typeof SuborderStatusEnum];

export const SuborderStatusEnum = {
  Draft: "Draft",
  Open: "Open",
  Fulfilled: "Fulfilled",
  Delivered: "Delivered",
  Cancelled: "Cancelled",
} as const;

export type SuborderWithOrderTargetShipBy = string | null;

export type SuborderWithOrderChargedAt = string | null;

export type SuborderWithOrderChargebackAt = string | null;

export type SuborderWithOrderFulfilledAt = string | null;

export type SuborderWithOrderDeliveredAt = string | null;

/**
 * Suborder with order read schema
 */
export interface SuborderWithOrder {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  order_id: string;
  /** @minimum 0 */
  sales_tax: number;
  /** @minimum 0 */
  shipping_charge: number;
  /** @minimum 0 */
  processing_fee: number;
  /** @minimum 0 */
  discount?: number;
  /** @minimum 0 */
  subtotal: number;
  /** @minimum 0 */
  total: number;
  target_ship_by?: SuborderWithOrderTargetShipBy;
  status: SuborderStatusEnum;
  suborder_id: string;
  dispensing_pharmacy_id: number;
  fulfilling_pharmacy_id: number;
  delivery_method: DeliveryMethodEnum;
  /** @minimum 0 */
  covered?: number;
  charged_at?: SuborderWithOrderChargedAt;
  chargeback_at?: SuborderWithOrderChargebackAt;
  fulfilled_at?: SuborderWithOrderFulfilledAt;
  delivered_at?: SuborderWithOrderDeliveredAt;
  dispensing_pharmacy: Entity;
  fulfilling_pharmacy: Entity;
  suborder_products: SuborderProductRead[];
  suborder_notes: SuborderNoteRead[];
  transactions: TransactionRead[];
  labels: LabelRead[];
  audit_suborder: Audit[];
  order: SuborderOrder;
}

/**
 * Suborders by practice
 */
export interface SubordersByPractice {
  practice_name: string;
  suborders_count: number;
}

/**
 * Suborders over time
 */
export interface SubordersOverTime {
  date: string;
  suborders_count: number;
}

export type TaskOrderId = string | null;

export type TaskProductId = number | null;

export type TaskCompletedAt = string | null;

export type TaskNote = string | null;

/**
 * Task schema
 */
export interface Task {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  patient_id: string;
  order_id?: TaskOrderId;
  product_id?: TaskProductId;
  task: TaskEnum;
  remind_at: string;
  completed_at?: TaskCompletedAt;
  note?: TaskNote;
  task_id: number;
}

export type TaskCreateOrderId = string | null;

export type TaskCreateProductId = number | null;

export type TaskCreateCompletedAt = string | null;

export type TaskCreateNote = string | null;

/**
 * Task create schema
 */
export interface TaskCreate {
  patient_id: string;
  order_id?: TaskCreateOrderId;
  product_id?: TaskCreateProductId;
  task: TaskEnum;
  remind_at: string;
  completed_at?: TaskCreateCompletedAt;
  note?: TaskCreateNote;
}

/**
 * TaskEnum class

Represents the needs of an order generally updated by CSRs.
 */
export type TaskEnum = (typeof TaskEnum)[keyof typeof TaskEnum];

export const TaskEnum = {
  Need_Payment: "Need Payment",
  Need_Address: "Need Address",
  Need_Insurance: "Need Insurance",
  Contact_Practice: "Contact Practice",
  Tech_Process_Insurance: "Tech Process Insurance",
  Tech_Prior_Authorization: "Tech Prior Authorization",
  Tech_Review: "Tech Review",
  Tech_Prepare_to_Transfer: "Tech Prepare to Transfer",
  Pharmacist_Ready_to_Transfer: "Pharmacist Ready to Transfer",
  Patient_Requested_Callback: "Patient Requested Callback",
  Patient_Refill: "Patient Refill",
  Resolve_Chargeback: "Resolve Chargeback",
} as const;

export type TaskReadOrderId = string | null;

export type TaskReadProductId = number | null;

export type TaskReadCompletedAt = string | null;

export type TaskReadNote = string | null;

/**
 * Task read schema
 */
export interface TaskRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  patient_id: string;
  order_id?: TaskReadOrderId;
  product_id?: TaskReadProductId;
  task: TaskEnum;
  remind_at: string;
  completed_at?: TaskReadCompletedAt;
  note?: TaskReadNote;
  task_id: number;
  patient: UserName;
}

export type TaskUpdateTask = TaskEnum | null;

export type TaskUpdateRemindAt = string | null;

export type TaskUpdateCompletedAt = string | null;

export type TaskUpdateNote = string | null;

/**
 * Task edit/update schema
 */
export interface TaskUpdate {
  task?: TaskUpdateTask;
  remind_at?: TaskUpdateRemindAt;
  completed_at?: TaskUpdateCompletedAt;
  note?: TaskUpdateNote;
}

/**
 * TextMessageAttachment base schema

Represents a single attachment in a text
 */
export interface TextMessageAttachmentBase {
  /** URL to the attachment in object storage */
  storage_url: string;
  /** MIME type of the attachment, e.g., 'image/jpeg' */
  content_type: string;
}

/**
 * TextMessageAttachmentRead schema
 */
export interface TextMessageAttachmentRead {
  /** URL to the attachment in object storage */
  storage_url: string;
  /** MIME type of the attachment, e.g., 'image/jpeg' */
  content_type: string;
  /** Unique identifier for the attachment */
  text_message_attachment_id: number;
  /** ID of the parent text message */
  text_message_id: number;
  created_at: string;
}

/**
 * Patient Campaign ID associated with the text message
 */
export type TextMessageBasePatientCampaignId = number | null;

/**
 * Outcome Message ID associated with the text message
 */
export type TextMessageBaseOutcomeMessageId = number | null;

/**
 * TextMessage base schema

Represents a single text message to or from a patient.
 */
export interface TextMessageBase {
  /** Patient's phone number */
  patient_phone: string;
  /** Practice's Twilio phone number */
  practice_phone: string;
  /** Practice ID associated with the text message */
  practice_id: number;
  /** Indicates who sent the text message */
  sent_by: SentByEnum;
  /** Text message content */
  message: string;
  /** Indicates if the text message should be sent. Used for hidden messages like Mark as Read. */
  should_send?: boolean;
  /** Patient Campaign ID associated with the text message */
  patient_campaign_id?: TextMessageBasePatientCampaignId;
  /** Outcome Message ID associated with the text message */
  outcome_message_id?: TextMessageBaseOutcomeMessageId;
}

/**
 * TextMessagePatient read schema
 */
export interface TextMessagePatientRead {
  /** Text Message ID */
  text_message_id: number;
  /** Patient ID */
  patient_id: string;
  patient: UserWithPhoneType;
}

/**
 * Patient Campaign ID associated with the text message
 */
export type TextMessageReadPatientCampaignId = number | null;

/**
 * Outcome Message ID associated with the text message
 */
export type TextMessageReadOutcomeMessageId = number | null;

/**
 * Staff User ID. Should be null if sent_by is PATIENT
 */
export type TextMessageReadUserId = string | null;

/**
 * Twilio SID
 */
export type TextMessageReadTwilioSid = string | null;

/**
 * Timestamp when the message was read
 */
export type TextMessageReadReadAt = string | null;

export type TextMessageReadUser = UserName | null;

/**
 * TextMessage read schema
 */
export interface TextMessageRead {
  /** Patient's phone number */
  patient_phone: string;
  /** Practice's Twilio phone number */
  practice_phone: string;
  /** Practice ID associated with the text message */
  practice_id: number;
  /** Indicates who sent the text message */
  sent_by: SentByEnum;
  /** Text message content */
  message: string;
  /** Indicates if the text message should be sent. Used for hidden messages like Mark as Read. */
  should_send?: boolean;
  /** Patient Campaign ID associated with the text message */
  patient_campaign_id?: TextMessageReadPatientCampaignId;
  /** Outcome Message ID associated with the text message */
  outcome_message_id?: TextMessageReadOutcomeMessageId;
  /** Staff User ID. Should be null if sent_by is PATIENT */
  user_id: TextMessageReadUserId;
  /** Twilio SID */
  twilio_sid?: TextMessageReadTwilioSid;
  /** Unique identifier for the text message */
  text_message_id: number;
  created_at: string;
  /** Timestamp when the message was read */
  read_at?: TextMessageReadReadAt;
  user: TextMessageReadUser;
  /** List of text message attachments */
  text_message_attachments: TextMessageAttachmentRead[];
}

/**
 * Patient Campaign ID associated with the text message
 */
export type TextMessageWithPatientsPatientCampaignId = number | null;

/**
 * Outcome Message ID associated with the text message
 */
export type TextMessageWithPatientsOutcomeMessageId = number | null;

/**
 * Staff User ID. Should be null if sent_by is PATIENT
 */
export type TextMessageWithPatientsUserId = string | null;

/**
 * Twilio SID
 */
export type TextMessageWithPatientsTwilioSid = string | null;

/**
 * Timestamp when the message was read
 */
export type TextMessageWithPatientsReadAt = string | null;

/**
 * TextMessage with patient schema
 */
export interface TextMessageWithPatients {
  /** Patient's phone number */
  patient_phone: string;
  /** Practice's Twilio phone number */
  practice_phone: string;
  /** Practice ID associated with the text message */
  practice_id: number;
  /** Indicates who sent the text message */
  sent_by: SentByEnum;
  /** Text message content */
  message: string;
  /** Indicates if the text message should be sent. Used for hidden messages like Mark as Read. */
  should_send?: boolean;
  /** Patient Campaign ID associated with the text message */
  patient_campaign_id?: TextMessageWithPatientsPatientCampaignId;
  /** Outcome Message ID associated with the text message */
  outcome_message_id?: TextMessageWithPatientsOutcomeMessageId;
  /** Staff User ID. Should be null if sent_by is PATIENT */
  user_id: TextMessageWithPatientsUserId;
  /** Twilio SID */
  twilio_sid?: TextMessageWithPatientsTwilioSid;
  /** Unique identifier for the text message */
  text_message_id: number;
  created_at: string;
  /** Timestamp when the message was read */
  read_at?: TextMessageWithPatientsReadAt;
  text_message_patients: TextMessagePatientRead[];
  practice: Entity;
}

/**
 * Metrics for the texting dashboard
 */
export interface TextingMetrics {
  total_sent_system: number;
  total_sent_manual: number;
  total_received: number;
  patients_texted: number;
  unique_patients_responded: number;
}

/**
 * Text messages sent over time for the texting dashboard.
 */
export interface TextsOverTime {
  manual_sent: number;
  system_sent: number;
  date: string;
}

/**
 * TimePeriodEnum class - represents time periods for grouping data
 */
export type TimePeriodEnum =
  (typeof TimePeriodEnum)[keyof typeof TimePeriodEnum];

export const TimePeriodEnum = {
  day: "day",
  week: "week",
  month: "month",
  quarter: "quarter",
  year: "year",
} as const;

/**
 * ToolCallEnum class for AI tool call event records
 */
export type ToolCallEnum = (typeof ToolCallEnum)[keyof typeof ToolCallEnum];

export const ToolCallEnum = {
  tool_call: "tool_call",
  tool_result: "tool_result",
} as const;

/**
 * Top products by quantity
 */
export interface TopProducts {
  product_id: number;
  product_name: string;
  product_type: string;
  total_quantity: number;
}

/**
 * TransactionCategoryEnum class

Business-level classification of a transaction, independent of the processor/method.
 */
export type TransactionCategoryEnum =
  (typeof TransactionCategoryEnum)[keyof typeof TransactionCategoryEnum];

export const TransactionCategoryEnum = {
  patient: "patient",
  bulk: "bulk",
  misc: "misc",
} as const;

/**
 * TransactionDirectionEnum class

Direction of money movement relative to this transaction's entity_id.
 */
export type TransactionDirectionEnum =
  (typeof TransactionDirectionEnum)[keyof typeof TransactionDirectionEnum];

export const TransactionDirectionEnum = {
  debit: "debit",
  credit: "credit",
} as const;

/**
 * External payment provider reference number
 */
export type TransactionReadReferenceNumber = string | null;

/**
 * USAePay's transaction key, unique across the whole gateway. Used for later API lookups (e.g. voiding a pending charge). Not set for non-USAePay transactions.
 */
export type TransactionReadKey = string | null;

/**
 * Application fee for this transaction, in cents
 */
export type TransactionReadApplicationFee = number | null;

export type TransactionReadSuborderId = string | null;

export type TransactionReadBulkInvoiceId = string | null;

/**
 * Transaction Read schema
 */
export interface TransactionRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /** External payment provider reference number */
  reference_number?: TransactionReadReferenceNumber;
  /** USAePay's transaction key, unique across the whole gateway. Used for later API lookups (e.g. voiding a pending charge). Not set for non-USAePay transactions. */
  key?: TransactionReadKey;
  /** Which payment processor handled this transaction */
  provider: PaymentProviders;
  /** Whether this transaction has settled */
  status: TransactionStatusEnum;
  /** The entity this transaction belongs to */
  entity_id: string;
  /** Internal classification of why this transaction exists */
  category: TransactionCategoryEnum;
  /** The amount of money moved in this transaction, in cents */
  amount: number;
  /** Application fee for this transaction, in cents */
  application_fee?: TransactionReadApplicationFee;
  /** Direction of money movement relative to entity_id */
  transaction_direction: TransactionDirectionEnum;
  /** Why this transaction happened */
  transaction_type: TransactionTypeEnum;
  /** The payment instrument used for this transaction */
  payment_type: PaymentTypeEnum;
  transaction_id: string;
  updated_by: UserName;
  suborder_id?: TransactionReadSuborderId;
  bulk_invoice_id?: TransactionReadBulkInvoiceId;
}

/**
 * TransactionStatusEnum class
 */
export type TransactionStatusEnum =
  (typeof TransactionStatusEnum)[keyof typeof TransactionStatusEnum];

export const TransactionStatusEnum = {
  pending: "pending",
  complete: "complete",
  failed: "failed",
  voided: "voided",
} as const;

/**
 * TransactionTypeEnum class

Why this transaction happened, independent of which way the money moved.
 */
export type TransactionTypeEnum =
  (typeof TransactionTypeEnum)[keyof typeof TransactionTypeEnum];

export const TransactionTypeEnum = {
  sale: "sale",
  refund: "refund",
  chargeback: "chargeback",
  payout: "payout",
} as const;

/**
 * Status message
 */
export type TransferCallResponseMessage = string | null;

/**
 * Response after initiating a transfer.
 */
export interface TransferCallResponse {
  /** Phone call ID */
  phone_call_id: number;
  /** Status: 'initiated', 'completed', 'failed' */
  transfer_status: string;
  /** Original advocate's user ID */
  original_user_id: string;
  /** Target advocate's user ID */
  target_user_id: string;
  /** Status message */
  message?: TransferCallResponseMessage;
}

/**
 * Treatment create schema
 */
export interface TreatmentCreate {
  /** Name of the treatment */
  name: string;
}

/**
 * Treatment read schema
 */
export interface TreatmentRead {
  /** Name of the treatment */
  name: string;
  /** Unique identifier for the treatment */
  treatment_id: number;
}

/**
 * Schema for Twilio Access Token response
 */
export interface TwilioAccessToken {
  /** Twilio JWT access token */
  token: string;
  /** Identity associated with the token */
  identity: string;
}

/**
 * Twilio's JSON-encoded EncryptionDetails form value.
 */
export interface TwilioRecordingEncryptionDetails {
  type: "rsa-aes";
  encrypted_cek: string;
  iv: string;
}

/**
 * Phone number of the user
 */
export type UserPhone = string | null;

/**
 * Type of phone number
 */
export type UserPhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type UserTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type UserTitle = string | null;

/**
 * NPI number of the user
 */
export type UserNpiNumber = string | null;

/**
 * State license number of the user
 */
export type UserStateLicenseNumber = string | null;

/**
 * Allows for Firebase Cloud Messaging to send push notifications
 */
export type UserFcmRegistrationToken = string | null;

/**
 * User schema
 */
export interface User {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  /** Email address of the user */
  email: string;
  /** Phone number of the user */
  phone?: UserPhone;
  /** Type of phone number */
  phone_type?: UserPhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: UserTextingUnsubscribedAt;
  /** Role of the user in the system, e.g., DOCTOR, ADMIN */
  role: UserRoleEnum;
  /** Title of the user, e.g., MD, RN, PA */
  title?: UserTitle;
  /** NPI number of the user */
  npi_number?: UserNpiNumber;
  /** State license number of the user */
  state_license_number?: UserStateLicenseNumber;
  user_id: string;
  /** Allows for Firebase Cloud Messaging to send push notifications */
  fcm_registration_token?: UserFcmRegistrationToken;
  /** Whether the user has at least one MFA factor enrolled */
  mfa_enabled?: boolean;
}

/**
 * Phone number of the user
 */
export type UserBasePhone = string | null;

/**
 * Type of phone number
 */
export type UserBasePhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type UserBaseTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type UserBaseTitle = string | null;

/**
 * NPI number of the user
 */
export type UserBaseNpiNumber = string | null;

/**
 * State license number of the user
 */
export type UserBaseStateLicenseNumber = string | null;

/**
 * User schema
 */
export interface UserBase {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  /** Email address of the user */
  email: string;
  /** Phone number of the user */
  phone?: UserBasePhone;
  /** Type of phone number */
  phone_type?: UserBasePhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: UserBaseTextingUnsubscribedAt;
  /** Role of the user in the system, e.g., DOCTOR, ADMIN */
  role: UserRoleEnum;
  /** Title of the user, e.g., MD, RN, PA */
  title?: UserBaseTitle;
  /** NPI number of the user */
  npi_number?: UserBaseNpiNumber;
  /** State license number of the user */
  state_license_number?: UserBaseStateLicenseNumber;
}

/**
 * Phone number of the user
 */
export type UserCreatePhone = string | null;

/**
 * Type of phone number
 */
export type UserCreatePhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type UserCreateTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type UserCreateTitle = string | null;

/**
 * NPI number of the user
 */
export type UserCreateNpiNumber = string | null;

/**
 * State license number of the user
 */
export type UserCreateStateLicenseNumber = string | null;

/**
 * User create schema
 */
export interface UserCreate {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  /** Email address of the user */
  email: string;
  /** Phone number of the user */
  phone?: UserCreatePhone;
  /** Type of phone number */
  phone_type?: UserCreatePhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: UserCreateTextingUnsubscribedAt;
  /** Role of the user in the system, e.g., DOCTOR, ADMIN */
  role: UserRoleEnum;
  /** Title of the user, e.g., MD, RN, PA */
  title?: UserCreateTitle;
  /** NPI number of the user */
  npi_number?: UserCreateNpiNumber;
  /** State license number of the user */
  state_license_number?: UserCreateStateLicenseNumber;
}

/**
 * UserEntity create schema
 */
export interface UserEntityCreate {
  /** Unique identifier for the user */
  user_id: string;
  /** List of entity IDs the user has access to */
  entity_ids: number[];
}

/**
 * UserEntityManyRead read schema
 */
export interface UserEntityManyRead {
  /** Unique identifier for the user */
  user_id: string;
  /** Unique identifier for the entity */
  entity_id: number;
  /** Unique identifier for the UserEntity */
  user_entity_id: number;
  entity: Entity;
  permissions?: Permission[];
}

/**
 * Commission associated with the user for the entity
 */
export type UserEntityReadCommission = Commission | null;

/**
 * UserEntity read schema
 */
export interface UserEntityRead {
  /** Unique identifier for the user */
  user_id: string;
  /** Unique identifier for the entity */
  entity_id: number;
  /** Unique identifier for the UserEntity */
  user_entity_id: number;
  /** All entity information */
  entity: EntityManyRead;
  /** List of permissions associated with the user for the entity */
  permissions: Permission[];
  /** Commission associated with the user for the entity */
  commission?: UserEntityReadCommission;
}

/**
 * Type of feedback: 'practice', 'support', 'bug', or 'feature'
 */
export type UserFeedbackFeedbackType =
  (typeof UserFeedbackFeedbackType)[keyof typeof UserFeedbackFeedbackType];

export const UserFeedbackFeedbackType = {
  practice: "practice",
  support: "support",
  bug: "bug",
  feature: "feature",
} as const;

/**
 * Optional image attachment for the feedback
 */
export type UserFeedbackImage = string | null;

/**
 * Schema for user feedback submission.
 */
export interface UserFeedback {
  /** Type of feedback: 'practice', 'support', 'bug', or 'feature' */
  feedback_type: UserFeedbackFeedbackType;
  /**
   * Subject line for the feedback
   * @minLength 1
   * @maxLength 100
   */
  subject: string;
  /**
   * Detailed feedback message
   * @minLength 1
   */
  message: string;
  /** URL of the page where the feedback was submitted */
  url: string;
  /** Optional image attachment for the feedback */
  image: UserFeedbackImage;
}

/**
 * Phone number of the user
 */
export type UserManyReadPhone = string | null;

/**
 * Type of phone number
 */
export type UserManyReadPhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type UserManyReadTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type UserManyReadTitle = string | null;

/**
 * NPI number of the user
 */
export type UserManyReadNpiNumber = string | null;

/**
 * State license number of the user
 */
export type UserManyReadStateLicenseNumber = string | null;

/**
 * Allows for Firebase Cloud Messaging to send push notifications
 */
export type UserManyReadFcmRegistrationToken = string | null;

/**
 * UserManyRead schema
 */
export interface UserManyRead {
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  /** Email address of the user */
  email: string;
  /** Phone number of the user */
  phone?: UserManyReadPhone;
  /** Type of phone number */
  phone_type?: UserManyReadPhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: UserManyReadTextingUnsubscribedAt;
  /** Role of the user in the system, e.g., DOCTOR, ADMIN */
  role: UserRoleEnum;
  /** Title of the user, e.g., MD, RN, PA */
  title?: UserManyReadTitle;
  /** NPI number of the user */
  npi_number?: UserManyReadNpiNumber;
  /** State license number of the user */
  state_license_number?: UserManyReadStateLicenseNumber;
  user_id: string;
  /** Allows for Firebase Cloud Messaging to send push notifications */
  fcm_registration_token?: UserManyReadFcmRegistrationToken;
  /** Whether the user has at least one MFA factor enrolled */
  mfa_enabled?: boolean;
  /** List of entities the user has access to */
  user_entities: UserEntityManyRead[];
}

/**
 * UserName schema

This schema can be used to read user names for created_by and updated_by fields
 */
export interface UserName {
  user_id: string;
  first_name: string;
  last_name: string;
}

/**
 * Phone number of the user
 */
export type UserReadPhone = string | null;

/**
 * Type of phone number
 */
export type UserReadPhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the user unsubscribed from text messages
 */
export type UserReadTextingUnsubscribedAt = string | null;

/**
 * Title of the user, e.g., MD, RN, PA
 */
export type UserReadTitle = string | null;

/**
 * NPI number of the user
 */
export type UserReadNpiNumber = string | null;

/**
 * State license number of the user
 */
export type UserReadStateLicenseNumber = string | null;

/**
 * Allows for Firebase Cloud Messaging to send push notifications
 */
export type UserReadFcmRegistrationToken = string | null;

/**
 * User read schema
 */
export interface UserRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  /**
   * First name of the user
   * @minLength 1
   * @maxLength 50
   */
  first_name: string;
  /**
   * Last name of the user
   * @minLength 1
   * @maxLength 50
   */
  last_name: string;
  /** Email address of the user */
  email: string;
  /** Phone number of the user */
  phone?: UserReadPhone;
  /** Type of phone number */
  phone_type?: UserReadPhoneType;
  /** Timestamp when the user unsubscribed from text messages */
  texting_unsubscribed_at?: UserReadTextingUnsubscribedAt;
  /** Role of the user in the system, e.g., DOCTOR, ADMIN */
  role: UserRoleEnum;
  /** Title of the user, e.g., MD, RN, PA */
  title?: UserReadTitle;
  /** NPI number of the user */
  npi_number?: UserReadNpiNumber;
  /** State license number of the user */
  state_license_number?: UserReadStateLicenseNumber;
  user_id: string;
  /** Allows for Firebase Cloud Messaging to send push notifications */
  fcm_registration_token?: UserReadFcmRegistrationToken;
  /** Whether the user has at least one MFA factor enrolled */
  mfa_enabled?: boolean;
  user_entities: UserEntityRead[];
}

/**
 * UserRoleEnum class
 */
export type UserRoleEnum = (typeof UserRoleEnum)[keyof typeof UserRoleEnum];

export const UserRoleEnum = {
  admin: "admin",
  patient_advocate: "patient_advocate",
  fulfillment_team: "fulfillment_team",
  patient: "patient",
  practice_staff: "practice_staff",
  doctor: "doctor",
  pharmacy_technician: "pharmacy_technician",
  pharmacist: "pharmacist",
  fulfiller: "fulfiller",
  sales_advisor: "sales_advisor",
} as const;

export type UserWithPhoneTypePhoneType = PhoneTypeEnum | null;

/**
 * Timestamp when the patient unsubscribed from text messages
 */
export type UserWithPhoneTypeTextingUnsubscribedAt = string | null;

/**
 * Patient schema

Simplified version of User schema for use in TextMessagePatientRead.
 */
export interface UserWithPhoneType {
  user_id: string;
  first_name: string;
  last_name: string;
  phone_type?: UserWithPhoneTypePhoneType;
  /** Timestamp when the patient unsubscribed from text messages */
  texting_unsubscribed_at?: UserWithPhoneTypeTextingUnsubscribedAt;
}

export type ValidationErrorLocItem = string | number;

export type ValidationErrorCtx = { [key: string]: unknown };

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
  input?: unknown;
  ctx?: ValidationErrorCtx;
}

export type VendorPhone = string | null;

export type VendorEmail = string | null;

/**
 * Vendor schema
 */
export interface Vendor {
  fulfiller_id: number;
  name: string;
  phone?: VendorPhone;
  is_whatsapp_enabled?: boolean;
  email?: VendorEmail;
  country: CountryEnum;
  vendor_id: number;
}

export type VendorCreatePhone = string | null;

export type VendorCreateEmail = string | null;

/**
 * Vendor create schema
 */
export interface VendorCreate {
  fulfiller_id: number;
  name: string;
  phone?: VendorCreatePhone;
  is_whatsapp_enabled?: boolean;
  email?: VendorCreateEmail;
  country: CountryEnum;
}

export type VendorManyReadPhone = string | null;

export type VendorManyReadEmail = string | null;

/**
 * Vendor many read schema
 */
export interface VendorManyRead {
  fulfiller_id: number;
  name: string;
  phone?: VendorManyReadPhone;
  is_whatsapp_enabled?: boolean;
  email?: VendorManyReadEmail;
  country: CountryEnum;
  vendor_id: number;
  fulfiller: EntityName;
}

/**
 * VendorNote create schema
 */
export interface VendorNoteCreate {
  vendor_id: number;
  note: string;
}

/**
 * VendorNote read schema
 */
export interface VendorNoteRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  vendor_id: number;
  note: string;
  vendor_note_id: number;
  updated_by: UserName;
}

export type VendorReadPhone = string | null;

export type VendorReadEmail = string | null;

/**
 * Vendor read schema
 */
export interface VendorRead {
  fulfiller_id: number;
  name: string;
  phone?: VendorReadPhone;
  is_whatsapp_enabled?: boolean;
  email?: VendorReadEmail;
  country: CountryEnum;
  vendor_id: number;
  warehouse_vendors: WarehouseVendorWithWarehouse[];
  vendor_notes: VendorNoteRead[];
}

export type WarehouseReorderLevel = number | null;

export type WarehouseHoldingCost = number | null;

export type WarehouseStockPercentage = number | null;

/**
 * Warehouse schema
 */
export interface Warehouse {
  warehouse_id: number;
  quantity_on_hand?: number;
  source: WarehouseSourceEnum;
  reorder_level?: WarehouseReorderLevel;
  holding_cost?: WarehouseHoldingCost;
  catalog_product: CatalogProductRead;
  stock_percentage?: WarehouseStockPercentage;
}

export type WarehouseBaseReorderLevel = number | null;

export type WarehouseBaseHoldingCost = number | null;

/**
 * Warehouse base schema
 */
export interface WarehouseBase {
  warehouse_id: number;
  quantity_on_hand?: number;
  source: WarehouseSourceEnum;
  reorder_level?: WarehouseBaseReorderLevel;
  holding_cost?: WarehouseBaseHoldingCost;
}

export type WarehouseCreateReorderLevel = number | null;

export type WarehouseCreateHoldingCost = number | null;

/**
 * Warehouse create schema
 */
export interface WarehouseCreate {
  warehouse_id: number;
  quantity_on_hand?: number;
  source: WarehouseSourceEnum;
  reorder_level?: WarehouseCreateReorderLevel;
  holding_cost?: WarehouseCreateHoldingCost;
}

export type WarehouseKPIsCostPerKit = number | null;

export type WarehouseKPIsTotalLaborCost = number | null;

/**
 * Warehouse KPIs schema
 */
export interface WarehouseKPIs {
  kits_shipped: number;
  kits_manufactured: number;
  kits_prebuild: number;
  cost_per_kit: WarehouseKPIsCostPerKit;
  total_labor_cost: WarehouseKPIsTotalLaborCost;
}

/**
 * WarehouseLabor schema
 */
export interface WarehouseLabor {
  fulfiller_id: number;
  month: string;
  /** @minimum 0 */
  labor_cost: number;
  warehouse_labor_id: number;
}

/**
 * WarehouseLabor create schema
 */
export interface WarehouseLaborCreate {
  fulfiller_id: number;
  month: string;
  /** @minimum 0 */
  labor_cost: number;
}

/**
 * Warehouse many read schema
 */
export interface WarehouseManyRead {
  warehouse_vendors: WarehouseVendor[];
}

export type WarehouseMonthlySalesMonthlySales = { [key: string]: number };

/**
 * Monthly sales totals for a single warehouse.
 */
export interface WarehouseMonthlySales {
  warehouse_name: string;
  monthly_sales: WarehouseMonthlySalesMonthlySales;
  total: number;
  warehouse_id: number;
}

/**
 * Warehouse predictions schema
 */
export interface WarehousePredictions {
  forecasted_demand_90_days: number;
  next_expected_order_at: string;
  next_order_quantity: number;
  sales_history: WarehouseSalesHistory[];
}

export type WarehouseReadReorderLevel = number | null;

export type WarehouseReadHoldingCost = number | null;

export type WarehouseReadStockPercentage = number | null;

/**
 * Warehouse read schema
 */
export interface WarehouseRead {
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  created_by_id: string;
  updated_by_id: string;
  warehouse_id: number;
  quantity_on_hand?: number;
  source: WarehouseSourceEnum;
  reorder_level?: WarehouseReadReorderLevel;
  holding_cost?: WarehouseReadHoldingCost;
  catalog_product: CatalogProductRead;
  stock_percentage?: WarehouseReadStockPercentage;
  warehouse_vendors: WarehouseVendorWithBatches[];
}

/**
 * Warehouse sales history schema
 */
export interface WarehouseSalesHistory {
  date: string;
  quantity: number;
}

/**
 * WarehouseSourceEnum class

Represents the source of warehouse.
 */
export type WarehouseSourceEnum =
  (typeof WarehouseSourceEnum)[keyof typeof WarehouseSourceEnum];

export const WarehouseSourceEnum = {
  Manufactured: "Manufactured",
  Purchased: "Purchased",
} as const;

export type WarehouseVendorVendorId = number | null;

export type WarehouseVendorRepurchaseLink = string | null;

export type WarehouseVendorOrderCost = number | null;

export type WarehouseVendorMinOrderQuantity = number | null;

/**
 * WarehouseVendor schema
 */
export interface WarehouseVendor {
  warehouse_id: number;
  vendor_id?: WarehouseVendorVendorId;
  repurchase_link?: WarehouseVendorRepurchaseLink;
  lead_time: number;
  unit_cost: number;
  order_cost?: WarehouseVendorOrderCost;
  min_order_quantity?: WarehouseVendorMinOrderQuantity;
  is_primary?: boolean;
  warehouse_vendor_id: number;
}

export type WarehouseVendorBaseVendorId = number | null;

export type WarehouseVendorBaseRepurchaseLink = string | null;

export type WarehouseVendorBaseOrderCost = number | null;

export type WarehouseVendorBaseMinOrderQuantity = number | null;

/**
 * WarehouseVendor base schema
 */
export interface WarehouseVendorBase {
  warehouse_id: number;
  vendor_id?: WarehouseVendorBaseVendorId;
  repurchase_link?: WarehouseVendorBaseRepurchaseLink;
  lead_time: number;
  unit_cost: number;
  order_cost?: WarehouseVendorBaseOrderCost;
  min_order_quantity?: WarehouseVendorBaseMinOrderQuantity;
  is_primary?: boolean;
}

export type WarehouseVendorCreateVendorId = number | null;

export type WarehouseVendorCreateRepurchaseLink = string | null;

export type WarehouseVendorCreateOrderCost = number | null;

export type WarehouseVendorCreateMinOrderQuantity = number | null;

/**
 * WarehouseVendor create schema
 */
export interface WarehouseVendorCreate {
  warehouse_id: number;
  vendor_id?: WarehouseVendorCreateVendorId;
  repurchase_link?: WarehouseVendorCreateRepurchaseLink;
  lead_time: number;
  unit_cost: number;
  order_cost?: WarehouseVendorCreateOrderCost;
  min_order_quantity?: WarehouseVendorCreateMinOrderQuantity;
  is_primary?: boolean;
}

export type WarehouseVendorReadVendorId = number | null;

export type WarehouseVendorReadRepurchaseLink = string | null;

export type WarehouseVendorReadOrderCost = number | null;

export type WarehouseVendorReadMinOrderQuantity = number | null;

export type WarehouseVendorReadVendor = Vendor | null;

/**
 * WarehouseVendor read schema
 */
export interface WarehouseVendorRead {
  warehouse_id: number;
  vendor_id?: WarehouseVendorReadVendorId;
  repurchase_link?: WarehouseVendorReadRepurchaseLink;
  lead_time: number;
  unit_cost: number;
  order_cost?: WarehouseVendorReadOrderCost;
  min_order_quantity?: WarehouseVendorReadMinOrderQuantity;
  is_primary?: boolean;
  warehouse_vendor_id: number;
  warehouse: Warehouse;
  vendor?: WarehouseVendorReadVendor;
}

export type WarehouseVendorWithBatchesVendorId = number | null;

export type WarehouseVendorWithBatchesRepurchaseLink = string | null;

export type WarehouseVendorWithBatchesOrderCost = number | null;

export type WarehouseVendorWithBatchesMinOrderQuantity = number | null;

export type WarehouseVendorWithBatchesVendor = Vendor | null;

/**
 * WarehouseVendor with vendor schema
 */
export interface WarehouseVendorWithBatches {
  warehouse_id: number;
  vendor_id?: WarehouseVendorWithBatchesVendorId;
  repurchase_link?: WarehouseVendorWithBatchesRepurchaseLink;
  lead_time: number;
  unit_cost: number;
  order_cost?: WarehouseVendorWithBatchesOrderCost;
  min_order_quantity?: WarehouseVendorWithBatchesMinOrderQuantity;
  is_primary?: boolean;
  warehouse_vendor_id: number;
  vendor?: WarehouseVendorWithBatchesVendor;
  batches: BatchWithStockOrder[];
}

export type WarehouseVendorWithVendorVendorId = number | null;

export type WarehouseVendorWithVendorRepurchaseLink = string | null;

export type WarehouseVendorWithVendorOrderCost = number | null;

export type WarehouseVendorWithVendorMinOrderQuantity = number | null;

export type WarehouseVendorWithVendorVendor = Vendor | null;

/**
 * WarehouseVendor with vendor schema
 */
export interface WarehouseVendorWithVendor {
  warehouse_id: number;
  vendor_id?: WarehouseVendorWithVendorVendorId;
  repurchase_link?: WarehouseVendorWithVendorRepurchaseLink;
  lead_time: number;
  unit_cost: number;
  order_cost?: WarehouseVendorWithVendorOrderCost;
  min_order_quantity?: WarehouseVendorWithVendorMinOrderQuantity;
  is_primary?: boolean;
  warehouse_vendor_id: number;
  vendor?: WarehouseVendorWithVendorVendor;
}

export type WarehouseVendorWithWarehouseVendorId = number | null;

export type WarehouseVendorWithWarehouseRepurchaseLink = string | null;

export type WarehouseVendorWithWarehouseOrderCost = number | null;

export type WarehouseVendorWithWarehouseMinOrderQuantity = number | null;

/**
 * WarehouseVendor with warehouse schema
 */
export interface WarehouseVendorWithWarehouse {
  warehouse_id: number;
  vendor_id?: WarehouseVendorWithWarehouseVendorId;
  repurchase_link?: WarehouseVendorWithWarehouseRepurchaseLink;
  lead_time: number;
  unit_cost: number;
  order_cost?: WarehouseVendorWithWarehouseOrderCost;
  min_order_quantity?: WarehouseVendorWithWarehouseMinOrderQuantity;
  is_primary?: boolean;
  warehouse_vendor_id: number;
  warehouse: Warehouse;
}

export type WarehouseWithIncomingQuantityReorderLevel = number | null;

export type WarehouseWithIncomingQuantityHoldingCost = number | null;

export type WarehouseWithIncomingQuantityStockPercentage = number | null;

/**
 * Warehouse many read schema
 */
export interface WarehouseWithIncomingQuantity {
  warehouse_id: number;
  quantity_on_hand?: number;
  source: WarehouseSourceEnum;
  reorder_level?: WarehouseWithIncomingQuantityReorderLevel;
  holding_cost?: WarehouseWithIncomingQuantityHoldingCost;
  catalog_product: CatalogProductRead;
  stock_percentage?: WarehouseWithIncomingQuantityStockPercentage;
  /** Quantity of batches that are ordered but have not yet arrived. */
  incoming_quantity: number;
  warehouse_vendors: WarehouseVendor[];
}

export type GetPhoneCallsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  direction?: CallDirectionEnum[];
  status?: CallStatusEnum[];
  duration_min?: number | null;
  duration_max?: number | null;
  user_ids?: string[];
};

export type GetNotificationsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
};

export type GetConversationParams = {
  patient_phone: string;
  patient_ids?: string[];
};

export type GetConversationsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
};

export type BestRxUploadParams = {
  practice_id: number;
  dispensing_pharmacy_id: number;
  delivery_method: DeliveryMethodEnum;
};

export type GetBundlesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type CreateLabelParams = {
  rate_id: string;
};

export type TransferLabelParams = {
  tracking_number: string;
};

export type GetOrdersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  order_statuses?: OrderStatusEnum[] | null;
  practice_ids?: number[] | null;
  hidden_columns?: string[] | null;
};

export type ExportOrdersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  order_statuses?: OrderStatusEnum[] | null;
  practice_ids?: number[] | null;
  hidden_columns?: string[] | null;
};

export type SendReceiptEmailParams = {
  email: string;
};

export type GetTasksParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  completed: boolean;
  future?: boolean;
  task_type?: TaskEnum[] | null;
};

export type CreatePatientParams = {
  link_text_messages: boolean;
};

export type GetPatientsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: string[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  show_duplicates?: boolean | null;
};

export type CheckPatientPhoneParams = {
  phone: string;
};

export type GetPatientRxSummaryParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: string[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type ListOutcomeCampaignsParams = {
  patient_id: string;
};

export type CreatePatientPaymentBody =
  | PatientPaymentCreate
  | PatientPaymentStripeCreate
  | PatientPaymentPriorityCreate;

export type ChargePatientPaymentParams = {
  payment_type: PaymentTypeEnum;
  patient_payment_id?: number | null;
};

export type RefundPatientPaymentParams = {
  payment_type: PaymentTypeEnum;
};

export type GetPayorsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  payor_types?: PayorTypeEnum[];
};

export type TransferCallParams = {
  target_user_id: string;
  to_cell?: boolean;
};

export type GetProductsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  product_types?: ProductTypeEnum[] | null;
  exclude_with_inventory?: boolean;
  catalog_product_id?: number | null;
  only_samples?: boolean;
};

export type GetAvailableFulfillersParams = {
  entity_id: number;
};

export type GetSubordersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  suborder_statuses?: SuborderStatusEnum[] | null;
  fulfilling_pharmacy_ids?: number[] | null;
  sort_surgery_date?: boolean;
};

export type GetSuborderPrescriptionParams = {
  catalog_product_id?: number | null;
};

export type MarkSuborderDeliveredParams = {
  delivered_at: string;
};

export type ToggleSuborderChargeback200 = string | null;

export type SplitSuborderProductParams = {
  /**
   * @minimum 1
   */
  split_quantity: number;
};

export type GetMedicationSummaryParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: string[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type GetQuarantinedProductsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type GetManyOperationalChangesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type GetManyLicensesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type GetInventoryBatchLogsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  log_types?: InventoryBatchLogTypeEnum[] | null;
  timezone?: string;
  hidden_columns?: string[] | null;
  inventory_id?: string | null;
  lot_number?: string | null;
  unassigned_only?: boolean | null;
  product_types?: ProductTypeEnum[] | null;
};

export type ExportInventoryBatchLogsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  log_types?: InventoryBatchLogTypeEnum[] | null;
  timezone?: string;
  hidden_columns?: string[] | null;
  inventory_id?: string | null;
  lot_number?: string | null;
  unassigned_only?: boolean | null;
  product_types?: ProductTypeEnum[] | null;
};

export type GetRecallsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type GetRecallPatientsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
};

export type GetCatalogProductsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  exclude_kits?: boolean;
  entity_ids?: number[];
  product_types?: ProductTypeEnum[];
  exclude_warehouse_items?: boolean;
  exclude_products?: boolean;
  exclude_bulk_products?: boolean;
  fulfiller_has_warehouse_360?: boolean;
  only_samples?: boolean;
  hidden_columns?: string[] | null;
};

export type ExportCatalogProductsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  exclude_kits?: boolean;
  entity_ids?: number[];
  product_types?: ProductTypeEnum[];
  exclude_warehouse_items?: boolean;
  exclude_products?: boolean;
  exclude_bulk_products?: boolean;
  fulfiller_has_warehouse_360?: boolean;
  only_samples?: boolean;
  hidden_columns?: string[] | null;
};

export type DuplicateCatalogProductParams = {
  should_replace: boolean;
};

export type CreateUpdateManyComponent200 = { [key: string]: unknown };

export type GetDoctorsParams = {
  practice_ids: number[];
};

export type GetEntitiesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  entity_types?: EntityTypeEnum[];
  services?: ServiceEnum[];
  include_visible_entities?: "can_see_entities" | "seen_by_entities" | null;
  has_twilio_phone?: boolean;
};

export type GetStripeBalanceTransactionsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  starting_after?: string | null;
};

export type TriggerReportJobParams = {
  report_month?: string | null;
};

export type GetProductBasesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
};

export type GetProductBrandsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
};

export type GetTreatmentsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
};

export type GetUsersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  roles?: UserRoleEnum[];
};

export type CreatePracticeUserParams = {
  entity_id: number;
};

export type RevokeOtherSessionsParams = {
  password_changed?: boolean;
};

export type DeactivateRestoreUserParams = {
  deactivate: boolean;
};

export type InviteUser200 = { [key: string]: string };

export type CreateCommissionsParams = {
  user_id: string;
};

export type GetUserEntityRevenueParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  user_ids?: string[];
  entity_ids?: number[];
};

export type GetOrderSummaryParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetOrdersPerMonthParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetOrdersPerMonthYtdParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetOrderDistributionParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetOrdersByUserParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetFinanceSummaryParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetRevenuePerMonthParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetRevenuePerMonthYtdParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetRevenueDistributionParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetRevenueByUserParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetDoctorSalesParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type ExportDoctorSalesParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetPnlSummaryDataParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetRevenueBreakdownDataParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetCogsBreakdownDataParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetOtherExpensesBreakdownDataParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetTextingMetricsParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetTextsOverTimeParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetCampaignOptInsParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetOptInStatusParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetCallingMetricsParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetCallsOverTimeParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetMissedCallsOverTimeParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetMissedCallBreakdownParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetCallDurationHistogramParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetCallsByHourParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetCallingAgentsParams = {
  practice_ids?: number[] | null;
  doctor_ids?: string[] | null;
  product_type?: ProductTypeEnum[] | null;
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  agent_ids?: string[] | null;
  timezone?: string;
};

export type GetPharmacyKpisParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  practice_ids?: number[] | null;
  product_types?: ProductTypeEnum[] | null;
  time_period?: TimePeriodEnum;
};

export type GetSubordersOverTimeParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  practice_ids?: number[] | null;
  product_types?: ProductTypeEnum[] | null;
  time_period?: TimePeriodEnum;
};

export type GetSubordersByPracticeParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  practice_ids?: number[] | null;
  product_types?: ProductTypeEnum[] | null;
  time_period?: TimePeriodEnum;
};

export type GetTopProductsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  practice_ids?: number[] | null;
  product_types?: ProductTypeEnum[] | null;
  time_period?: TimePeriodEnum;
};

export type GetBulkBundlesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type GetBulkInvoicesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  payment_collector_ids?: number[] | null;
  is_paid?: boolean | null;
  hidden_columns?: string[] | null;
};

export type ExportBulkInvoicesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  payment_collector_ids?: number[] | null;
  is_paid?: boolean | null;
  hidden_columns?: string[] | null;
};

export type MarkBulkInvoicePaidParams = {
  paid_at: string;
};

export type UpdateBulkInvoiceDueDateParams = {
  due_at: string;
};

export type UpdateBulkInvoicePaymentCollectorParams = {
  payment_collector_id: number;
};

export type CreateBulkLabelParams = {
  rate_id: string;
};

export type TransferBulkLabelParams = {
  tracking_number: string;
};

export type GetBulkOrdersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  is_reorder?: boolean;
  bulk_order_statuses?: BulkOrderStatusEnum[] | null;
  is_sample?: boolean | null;
  hidden_columns?: string[] | null;
};

export type ExportBulkOrdersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  is_reorder?: boolean;
  bulk_order_statuses?: BulkOrderStatusEnum[] | null;
  is_sample?: boolean | null;
  hidden_columns?: string[] | null;
};

export type UpdateBulkOrderExternalIdParams = {
  external_id: string | null;
};

export type UpdateBulkOrderOrderedAtParams = {
  ordered_at: string;
};

export type UpdateBulkOrderPaymentCollectorIdParams = {
  payment_collector_id?: number | null;
};

export type GetBulkProductsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  is_orderable?: boolean;
  product_types?: ProductTypeEnum[] | null;
  fulfiller_id?: number | null;
  is_stock_360?: boolean;
  catalog_product_id?: number | null;
  only_samples?: boolean;
};

export type GetBulkSuborderKpiDashboardFulfilledCountsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  fulfiller_ids?: number[] | null;
  time_period?: TimePeriodEnum;
};

export type GetBulkSuborderKpiDashboardSummaryParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  fulfiller_ids?: number[] | null;
  time_period?: TimePeriodEnum;
};

export type GetBulkSuborderKpiDashboardAvgFulfillmentTimeParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  fulfiller_ids?: number[] | null;
  time_period?: TimePeriodEnum;
};

export type FulfillBulkSuborderParams = {
  fulfilled_at: string;
};

export type FulfillBulkSuborderBody = BulkSuborderFulfillQuantity[] | null;

export type MarkBulkSuborderCommissionPaidParams = {
  commission_paid_at: string;
};

export type GetBulkSubordersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  bulk_suborder_statuses?: BulkSuborderStatusEnum[] | null;
  target_ship_by_start?: string | null;
  target_ship_by_end?: string | null;
  fulfiller_ids?: number[] | null;
  is_sample?: boolean | null;
  hidden_columns?: string[] | null;
};

export type ExportBulkSubordersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  bulk_suborder_statuses?: BulkSuborderStatusEnum[] | null;
  target_ship_by_start?: string | null;
  target_ship_by_end?: string | null;
  fulfiller_ids?: number[] | null;
  is_sample?: boolean | null;
  hidden_columns?: string[] | null;
};

export type GetBulkSuborderPackingListParams = {
  bulk_label_id?: number | null;
};

export type UpdateBulkSuborderTargetShipByParams = {
  target_ship_by: string;
};

export type UpdateBulkSuborderShipToBody = BulkSuborderShipTo | null;

export type UpdateBulkSuborderFulfillmentNoteParams = {
  fulfillment_note: string;
};

export type UpdateBulkSuborderShippingSpeedParams = {
  shipping_speed: BulkShippingSpeedEnum;
};

export type UpdateBulkSuborderFulfillerParams = {
  fulfiller_id: number;
};

export type UpdateBulkSuborderProductUnitPriceParams = {
  /**
   * @minimum 0
   */
  unit_price: number;
};

export type UpdateBulkSuborderProductLotInfoParams = {
  lot_number?: string | null;
  expiration_date?: string | null;
};

export type UpdateBulkSuborderProductWholesalePriceParams = {
  /**
   * @minimum 0
   */
  wholesale_price: number;
};

export type SplitBulkSuborderProductParams = {
  /**
   * @minimum 1
   */
  split_quantity: number;
};

export type MarkBulkSuborderDeliveredParams = {
  delivered_at: string;
};

export type CreateBatchParams = {
  is_manufactured?: boolean;
};

export type GetBatchesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  warehouse_id?: number | null;
  has_arrived?: boolean | null;
  statuses?: BatchStatusEnum[];
};

export type UpdateBatchNoteParams = {
  note: string;
};

export type UpdateBatchInvoiceUrlParams = {
  invoice_url: string;
};

export type GetWarehousesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  warehouse_ids?: number[] | null;
  sources?: WarehouseSourceEnum[] | null;
  product_types?: ProductTypeEnum[] | null;
  reorder_level_min?: number | null;
  reorder_level_max?: number | null;
  product_brand_ids?: number[] | null;
  stale_weeks?: number | null;
  countries?: CountryEnum[] | null;
  is_sample?: boolean | null;
  hidden_columns?: string[] | null;
};

export type ExportWarehousesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  warehouse_ids?: number[] | null;
  sources?: WarehouseSourceEnum[] | null;
  product_types?: ProductTypeEnum[] | null;
  reorder_level_min?: number | null;
  reorder_level_max?: number | null;
  product_brand_ids?: number[] | null;
  stale_weeks?: number | null;
  countries?: CountryEnum[] | null;
  is_sample?: boolean | null;
  hidden_columns?: string[] | null;
};

export type GetParentProductsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
};

export type GetWarehousePredictions200 = WarehousePredictions | null;

export type GetStockOrdersParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  status?: StockOrderStatusEnum[] | null;
};

export type GetStockOrderBulkProductsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  is_orderable?: boolean;
  product_types?: ProductTypeEnum[] | null;
  fulfiller_id?: number | null;
  is_stock_360?: boolean;
  catalog_product_id?: number | null;
  only_samples?: boolean;
};

export type FulfillStockOrderParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  batch_ids?: number[] | null;
};

export type UpdateStockOrderChargedDateParams = {
  charged_at: string;
};

export type UpdateStockOrderTargetFulfillByParams = {
  target_fulfill_by: string;
};

export type GetOwnedStockParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  product_types?: ProductTypeEnum[] | null;
};

export type GetWarehouseKpisParams = {
  /**
   * @minimum 1
   */
  page?: number;
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  product_types?: ProductTypeEnum[] | null;
  product_brand_ids?: number[] | null;
};

export type GetKitsByPracticeParams = {
  /**
   * @minimum 1
   */
  page?: number;
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  product_types?: ProductTypeEnum[] | null;
  product_brand_ids?: number[] | null;
};

export type GetKitsByLogTypeParams = {
  /**
   * @minimum 1
   */
  page?: number;
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  product_types?: ProductTypeEnum[] | null;
  product_brand_ids?: number[] | null;
};

export type KitsOverTimeParams = {
  /**
   * @minimum 1
   */
  page?: number;
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  product_types?: ProductTypeEnum[] | null;
  product_brand_ids?: number[] | null;
};

export type GetCostsPerKitParams = {
  /**
   * @minimum 1
   */
  page?: number;
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  product_types?: ProductTypeEnum[] | null;
  product_brand_ids?: number[] | null;
};

export type GetWarehousesHistoricParams = {
  /**
   * @minimum 1
   */
  page?: number;
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  product_types?: ProductTypeEnum[] | null;
  product_brand_ids?: number[] | null;
};

export type ExportWarehousesHistoricParams = {
  /**
   * @minimum 1
   */
  page?: number;
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  date_start?: string | null;
  date_end?: string | null;
  time_period?: TimePeriodEnum;
  product_types?: ProductTypeEnum[] | null;
  product_brand_ids?: number[] | null;
};

export type GetWarehouseVendorsParams = {
  warehouse_id: number;
};

export type GetWarehouseLaborParams = {
  fulfiller_id: number;
  month: string;
};

export type GetWarehouseLabor200 = WarehouseLabor | null;

export type GetVendorsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  country?: CountryEnum[] | null;
};

export type GetDisposersParams = {
  entity_id: number;
};

export type GetInventoriesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  product_types?: ProductTypeEnum[] | null;
  low_stock_only?: boolean;
  catalog_product_id?: number | null;
  hidden_columns?: string[] | null;
};

export type ExportInventoriesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  product_types?: ProductTypeEnum[] | null;
  low_stock_only?: boolean;
  catalog_product_id?: number | null;
  hidden_columns?: string[] | null;
};

export type GetInventoryBatchesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  inventory_id?: string | null;
  product_id?: number | null;
  received?: boolean | null;
  min_quantity?: number | null;
  unassigned_only?: boolean | null;
  unlinked_only?: boolean | null;
  lot_number?: string | null;
};

export type GetLotsLookupParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
  received?: boolean | null;
};

export type GetLotSummaryParams = {
  entity_id: number;
  product_id?: number | null;
  search?: string | null;
  product_types?: ProductTypeEnum[] | null;
};

export type GetInventoryLotsParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  is_deleted?: boolean | null;
  sort_column?: string | null;
  ascending?: boolean | null;
  search?: string | null;
  include_ids?: number[];
  created_at_start?: string | null;
  created_at_end?: string | null;
  updated_at_start?: string | null;
  updated_at_end?: string | null;
  entity_ids?: number[];
};

export type GetLotDetailParams = {
  lot_number?: string | null;
};

export type GetInstructionsViaLinkParams = {
  date_of_birth: string;
};
